export default [
  {
    "id": 1,
    "name": "北京市",
    "type": "省",
    "parentId": 0
  },
  {
    "id": 2,
    "name": "天津市",
    "type": "省",
    "parentId": 0
  },
  {
    "id": 3,
    "name": "河北省",
    "type": "省",
    "parentId": 0
  },
  {
    "id": 4,
    "name": "山西省",
    "type": "省",
    "parentId": 0
  },
  {
    "id": 5,
    "name": "内蒙古自治区",
    "type": "省",
    "parentId": 0
  },
  {
    "id": 6,
    "name": "辽宁省",
    "type": "省",
    "parentId": 0
  },
  {
    "id": 7,
    "name": "吉林省",
    "type": "省",
    "parentId": 0
  },
  {
    "id": 8,
    "name": "黑龙江省",
    "type": "省",
    "parentId": 0
  },
  {
    "id": 9,
    "name": "上海市",
    "type": "省",
    "parentId": 0
  },
  {
    "id": 10,
    "name": "江苏省",
    "type": "省",
    "parentId": 0
  },
  {
    "id": 11,
    "name": "浙江省",
    "type": "省",
    "parentId": 0
  },
  {
    "id": 12,
    "name": "安徽省",
    "type": "省",
    "parentId": 0
  },
  {
    "id": 13,
    "name": "福建省",
    "type": "省",
    "parentId": 0
  },
  {
    "id": 14,
    "name": "江西省",
    "type": "省",
    "parentId": 0
  },
  {
    "id": 15,
    "name": "山东省",
    "type": "省",
    "parentId": 0
  },
  {
    "id": 16,
    "name": "河南省",
    "type": "省",
    "parentId": 0
  },
  {
    "id": 17,
    "name": "湖北省",
    "type": "省",
    "parentId": 0
  },
  {
    "id": 18,
    "name": "湖南省",
    "type": "省",
    "parentId": 0
  },
  {
    "id": 19,
    "name": "广东省",
    "type": "省",
    "parentId": 0
  },
  {
    "id": 20,
    "name": "广西壮族自治区",
    "type": "省",
    "parentId": 0
  },
  {
    "id": 21,
    "name": "海南省",
    "type": "省",
    "parentId": 0
  },
  {
    "id": 22,
    "name": "重庆市",
    "type": "省",
    "parentId": 0
  },
  {
    "id": 23,
    "name": "四川省",
    "type": "省",
    "parentId": 0
  },
  {
    "id": 24,
    "name": "贵州省",
    "type": "省",
    "parentId": 0
  },
  {
    "id": 25,
    "name": "云南省",
    "type": "省",
    "parentId": 0
  },
  {
    "id": 26,
    "name": "西藏自治区",
    "type": "省",
    "parentId": 0
  },
  {
    "id": 27,
    "name": "陕西省",
    "type": "省",
    "parentId": 0
  },
  {
    "id": 28,
    "name": "甘肃省",
    "type": "省",
    "parentId": 0
  },
  {
    "id": 29,
    "name": "青海省",
    "type": "省",
    "parentId": 0
  },
  {
    "id": 30,
    "name": "宁夏回族自治区",
    "type": "省",
    "parentId": 0
  },
  {
    "id": 31,
    "name": "新疆维吾尔自治区",
    "type": "省",
    "parentId": 0
  },
  {
    "id": 32,
    "name": "台湾省",
    "type": "省",
    "parentId": 0
  },
  {
    "id": 33,
    "name": "香港特别行政区",
    "type": "省",
    "parentId": 0
  },
  {
    "id": 34,
    "name": "澳门特别行政区",
    "type": "省",
    "parentId": 0
  },
  {
    "id": 35,
    "name": "北京市",
    "type": "市",
    "parentId": 1
  },
  {
    "id": 36,
    "name": "天津市",
    "type": "市",
    "parentId": 2
  },
  {
    "id": 37,
    "name": "石家庄市",
    "type": "市",
    "parentId": 3
  },
  {
    "id": 38,
    "name": "唐山市",
    "type": "市",
    "parentId": 3
  },
  {
    "id": 39,
    "name": "秦皇岛市",
    "type": "市",
    "parentId": 3
  },
  {
    "id": 40,
    "name": "邯郸市",
    "type": "市",
    "parentId": 3
  },
  {
    "id": 41,
    "name": "邢台市",
    "type": "市",
    "parentId": 3
  },
  {
    "id": 42,
    "name": "保定市",
    "type": "市",
    "parentId": 3
  },
  {
    "id": 43,
    "name": "张家口市",
    "type": "市",
    "parentId": 3
  },
  {
    "id": 44,
    "name": "承德市",
    "type": "市",
    "parentId": 3
  },
  {
    "id": 45,
    "name": "沧州市",
    "type": "市",
    "parentId": 3
  },
  {
    "id": 46,
    "name": "廊坊市",
    "type": "市",
    "parentId": 3
  },
  {
    "id": 47,
    "name": "衡水市",
    "type": "市",
    "parentId": 3
  },
  {
    "id": 48,
    "name": "省直辖县",
    "type": "市",
    "parentId": 3
  },
  {
    "id": 49,
    "name": "太原市",
    "type": "市",
    "parentId": 4
  },
  {
    "id": 50,
    "name": "大同市",
    "type": "市",
    "parentId": 4
  },
  {
    "id": 51,
    "name": "阳泉市",
    "type": "市",
    "parentId": 4
  },
  {
    "id": 52,
    "name": "长治市",
    "type": "市",
    "parentId": 4
  },
  {
    "id": 53,
    "name": "晋城市",
    "type": "市",
    "parentId": 4
  },
  {
    "id": 54,
    "name": "朔州市",
    "type": "市",
    "parentId": 4
  },
  {
    "id": 55,
    "name": "晋中市",
    "type": "市",
    "parentId": 4
  },
  {
    "id": 56,
    "name": "运城市",
    "type": "市",
    "parentId": 4
  },
  {
    "id": 57,
    "name": "忻州市",
    "type": "市",
    "parentId": 4
  },
  {
    "id": 58,
    "name": "临汾市",
    "type": "市",
    "parentId": 4
  },
  {
    "id": 59,
    "name": "吕梁市",
    "type": "市",
    "parentId": 4
  },
  {
    "id": 60,
    "name": "呼和浩特市",
    "type": "市",
    "parentId": 5
  },
  {
    "id": 61,
    "name": "包头市",
    "type": "市",
    "parentId": 5
  },
  {
    "id": 62,
    "name": "乌海市",
    "type": "市",
    "parentId": 5
  },
  {
    "id": 63,
    "name": "赤峰市",
    "type": "市",
    "parentId": 5
  },
  {
    "id": 64,
    "name": "通辽市",
    "type": "市",
    "parentId": 5
  },
  {
    "id": 65,
    "name": "鄂尔多斯市",
    "type": "市",
    "parentId": 5
  },
  {
    "id": 66,
    "name": "呼伦贝尔市",
    "type": "市",
    "parentId": 5
  },
  {
    "id": 67,
    "name": "巴彦淖尔市",
    "type": "市",
    "parentId": 5
  },
  {
    "id": 68,
    "name": "乌兰察布市",
    "type": "市",
    "parentId": 5
  },
  {
    "id": 69,
    "name": "兴安盟",
    "type": "市",
    "parentId": 5
  },
  {
    "id": 70,
    "name": "锡林郭勒盟",
    "type": "市",
    "parentId": 5
  },
  {
    "id": 71,
    "name": "阿拉善盟",
    "type": "市",
    "parentId": 5
  },
  {
    "id": 72,
    "name": "沈阳市",
    "type": "市",
    "parentId": 6
  },
  {
    "id": 73,
    "name": "大连市",
    "type": "市",
    "parentId": 6
  },
  {
    "id": 74,
    "name": "鞍山市",
    "type": "市",
    "parentId": 6
  },
  {
    "id": 75,
    "name": "抚顺市",
    "type": "市",
    "parentId": 6
  },
  {
    "id": 76,
    "name": "本溪市",
    "type": "市",
    "parentId": 6
  },
  {
    "id": 77,
    "name": "丹东市",
    "type": "市",
    "parentId": 6
  },
  {
    "id": 78,
    "name": "锦州市",
    "type": "市",
    "parentId": 6
  },
  {
    "id": 79,
    "name": "营口市",
    "type": "市",
    "parentId": 6
  },
  {
    "id": 80,
    "name": "阜新市",
    "type": "市",
    "parentId": 6
  },
  {
    "id": 81,
    "name": "辽阳市",
    "type": "市",
    "parentId": 6
  },
  {
    "id": 82,
    "name": "盘锦市",
    "type": "市",
    "parentId": 6
  },
  {
    "id": 83,
    "name": "铁岭市",
    "type": "市",
    "parentId": 6
  },
  {
    "id": 84,
    "name": "朝阳市",
    "type": "市",
    "parentId": 6
  },
  {
    "id": 85,
    "name": "葫芦岛市",
    "type": "市",
    "parentId": 6
  },
  {
    "id": 86,
    "name": "长春市",
    "type": "市",
    "parentId": 7
  },
  {
    "id": 87,
    "name": "吉林市",
    "type": "市",
    "parentId": 7
  },
  {
    "id": 88,
    "name": "四平市",
    "type": "市",
    "parentId": 7
  },
  {
    "id": 89,
    "name": "辽源市",
    "type": "市",
    "parentId": 7
  },
  {
    "id": 90,
    "name": "通化市",
    "type": "市",
    "parentId": 7
  },
  {
    "id": 91,
    "name": "白山市",
    "type": "市",
    "parentId": 7
  },
  {
    "id": 92,
    "name": "松原市",
    "type": "市",
    "parentId": 7
  },
  {
    "id": 93,
    "name": "白城市",
    "type": "市",
    "parentId": 7
  },
  {
    "id": 94,
    "name": "延边朝鲜族自治州",
    "type": "市",
    "parentId": 7
  },
  {
    "id": 95,
    "name": "哈尔滨市",
    "type": "市",
    "parentId": 8
  },
  {
    "id": 96,
    "name": "齐齐哈尔市",
    "type": "市",
    "parentId": 8
  },
  {
    "id": 97,
    "name": "鸡西市",
    "type": "市",
    "parentId": 8
  },
  {
    "id": 98,
    "name": "鹤岗市",
    "type": "市",
    "parentId": 8
  },
  {
    "id": 99,
    "name": "双鸭山市",
    "type": "市",
    "parentId": 8
  },
  {
    "id": 100,
    "name": "大庆市",
    "type": "市",
    "parentId": 8
  },
  {
    "id": 101,
    "name": "伊春市",
    "type": "市",
    "parentId": 8
  },
  {
    "id": 102,
    "name": "佳木斯市",
    "type": "市",
    "parentId": 8
  },
  {
    "id": 103,
    "name": "七台河市",
    "type": "市",
    "parentId": 8
  },
  {
    "id": 104,
    "name": "牡丹江市",
    "type": "市",
    "parentId": 8
  },
  {
    "id": 105,
    "name": "黑河市",
    "type": "市",
    "parentId": 8
  },
  {
    "id": 106,
    "name": "绥化市",
    "type": "市",
    "parentId": 8
  },
  {
    "id": 107,
    "name": "大兴安岭地区",
    "type": "市",
    "parentId": 8
  },
  {
    "id": 108,
    "name": "上海市",
    "type": "市",
    "parentId": 9
  },
  {
    "id": 109,
    "name": "南京市",
    "type": "市",
    "parentId": 10
  },
  {
    "id": 110,
    "name": "无锡市",
    "type": "市",
    "parentId": 10
  },
  {
    "id": 111,
    "name": "徐州市",
    "type": "市",
    "parentId": 10
  },
  {
    "id": 112,
    "name": "常州市",
    "type": "市",
    "parentId": 10
  },
  {
    "id": 113,
    "name": "苏州市",
    "type": "市",
    "parentId": 10
  },
  {
    "id": 114,
    "name": "南通市",
    "type": "市",
    "parentId": 10
  },
  {
    "id": 115,
    "name": "连云港市",
    "type": "市",
    "parentId": 10
  },
  {
    "id": 116,
    "name": "淮安市",
    "type": "市",
    "parentId": 10
  },
  {
    "id": 117,
    "name": "盐城市",
    "type": "市",
    "parentId": 10
  },
  {
    "id": 118,
    "name": "扬州市",
    "type": "市",
    "parentId": 10
  },
  {
    "id": 119,
    "name": "镇江市",
    "type": "市",
    "parentId": 10
  },
  {
    "id": 120,
    "name": "泰州市",
    "type": "市",
    "parentId": 10
  },
  {
    "id": 121,
    "name": "宿迁市",
    "type": "市",
    "parentId": 10
  },
  {
    "id": 122,
    "name": "杭州市",
    "type": "市",
    "parentId": 11
  },
  {
    "id": 123,
    "name": "宁波市",
    "type": "市",
    "parentId": 11
  },
  {
    "id": 124,
    "name": "温州市",
    "type": "市",
    "parentId": 11
  },
  {
    "id": 125,
    "name": "嘉兴市",
    "type": "市",
    "parentId": 11
  },
  {
    "id": 126,
    "name": "湖州市",
    "type": "市",
    "parentId": 11
  },
  {
    "id": 127,
    "name": "绍兴市",
    "type": "市",
    "parentId": 11
  },
  {
    "id": 128,
    "name": "金华市",
    "type": "市",
    "parentId": 11
  },
  {
    "id": 129,
    "name": "衢州市",
    "type": "市",
    "parentId": 11
  },
  {
    "id": 130,
    "name": "舟山市",
    "type": "市",
    "parentId": 11
  },
  {
    "id": 131,
    "name": "台州市",
    "type": "市",
    "parentId": 11
  },
  {
    "id": 132,
    "name": "丽水市",
    "type": "市",
    "parentId": 11
  },
  {
    "id": 133,
    "name": "合肥市",
    "type": "市",
    "parentId": 12
  },
  {
    "id": 134,
    "name": "芜湖市",
    "type": "市",
    "parentId": 12
  },
  {
    "id": 135,
    "name": "蚌埠市",
    "type": "市",
    "parentId": 12
  },
  {
    "id": 136,
    "name": "淮南市",
    "type": "市",
    "parentId": 12
  },
  {
    "id": 137,
    "name": "马鞍山市",
    "type": "市",
    "parentId": 12
  },
  {
    "id": 138,
    "name": "淮北市",
    "type": "市",
    "parentId": 12
  },
  {
    "id": 139,
    "name": "铜陵市",
    "type": "市",
    "parentId": 12
  },
  {
    "id": 140,
    "name": "安庆市",
    "type": "市",
    "parentId": 12
  },
  {
    "id": 141,
    "name": "黄山市",
    "type": "市",
    "parentId": 12
  },
  {
    "id": 142,
    "name": "滁州市",
    "type": "市",
    "parentId": 12
  },
  {
    "id": 143,
    "name": "阜阳市",
    "type": "市",
    "parentId": 12
  },
  {
    "id": 144,
    "name": "宿州市",
    "type": "市",
    "parentId": 12
  },
  {
    "id": 145,
    "name": "六安市",
    "type": "市",
    "parentId": 12
  },
  {
    "id": 146,
    "name": "亳州市",
    "type": "市",
    "parentId": 12
  },
  {
    "id": 147,
    "name": "池州市",
    "type": "市",
    "parentId": 12
  },
  {
    "id": 148,
    "name": "宣城市",
    "type": "市",
    "parentId": 12
  },
  {
    "id": 149,
    "name": "福州市",
    "type": "市",
    "parentId": 13
  },
  {
    "id": 150,
    "name": "厦门市",
    "type": "市",
    "parentId": 13
  },
  {
    "id": 151,
    "name": "莆田市",
    "type": "市",
    "parentId": 13
  },
  {
    "id": 152,
    "name": "三明市",
    "type": "市",
    "parentId": 13
  },
  {
    "id": 153,
    "name": "泉州市",
    "type": "市",
    "parentId": 13
  },
  {
    "id": 154,
    "name": "漳州市",
    "type": "市",
    "parentId": 13
  },
  {
    "id": 155,
    "name": "南平市",
    "type": "市",
    "parentId": 13
  },
  {
    "id": 156,
    "name": "龙岩市",
    "type": "市",
    "parentId": 13
  },
  {
    "id": 157,
    "name": "宁德市",
    "type": "市",
    "parentId": 13
  },
  {
    "id": 158,
    "name": "南昌市",
    "type": "市",
    "parentId": 14
  },
  {
    "id": 159,
    "name": "景德镇市",
    "type": "市",
    "parentId": 14
  },
  {
    "id": 160,
    "name": "萍乡市",
    "type": "市",
    "parentId": 14
  },
  {
    "id": 161,
    "name": "九江市",
    "type": "市",
    "parentId": 14
  },
  {
    "id": 162,
    "name": "新余市",
    "type": "市",
    "parentId": 14
  },
  {
    "id": 163,
    "name": "鹰潭市",
    "type": "市",
    "parentId": 14
  },
  {
    "id": 164,
    "name": "赣州市",
    "type": "市",
    "parentId": 14
  },
  {
    "id": 165,
    "name": "吉安市",
    "type": "市",
    "parentId": 14
  },
  {
    "id": 166,
    "name": "宜春市",
    "type": "市",
    "parentId": 14
  },
  {
    "id": 167,
    "name": "抚州市",
    "type": "市",
    "parentId": 14
  },
  {
    "id": 168,
    "name": "上饶市",
    "type": "市",
    "parentId": 14
  },
  {
    "id": 169,
    "name": "济南市",
    "type": "市",
    "parentId": 15
  },
  {
    "id": 170,
    "name": "青岛市",
    "type": "市",
    "parentId": 15
  },
  {
    "id": 171,
    "name": "淄博市",
    "type": "市",
    "parentId": 15
  },
  {
    "id": 172,
    "name": "枣庄市",
    "type": "市",
    "parentId": 15
  },
  {
    "id": 173,
    "name": "东营市",
    "type": "市",
    "parentId": 15
  },
  {
    "id": 174,
    "name": "烟台市",
    "type": "市",
    "parentId": 15
  },
  {
    "id": 175,
    "name": "潍坊市",
    "type": "市",
    "parentId": 15
  },
  {
    "id": 176,
    "name": "济宁市",
    "type": "市",
    "parentId": 15
  },
  {
    "id": 177,
    "name": "泰安市",
    "type": "市",
    "parentId": 15
  },
  {
    "id": 178,
    "name": "威海市",
    "type": "市",
    "parentId": 15
  },
  {
    "id": 179,
    "name": "日照市",
    "type": "市",
    "parentId": 15
  },
  {
    "id": 180,
    "name": "莱芜市",
    "type": "市",
    "parentId": 15
  },
  {
    "id": 181,
    "name": "临沂市",
    "type": "市",
    "parentId": 15
  },
  {
    "id": 182,
    "name": "德州市",
    "type": "市",
    "parentId": 15
  },
  {
    "id": 183,
    "name": "聊城市",
    "type": "市",
    "parentId": 15
  },
  {
    "id": 184,
    "name": "滨州市",
    "type": "市",
    "parentId": 15
  },
  {
    "id": 185,
    "name": "菏泽市",
    "type": "市",
    "parentId": 15
  },
  {
    "id": 186,
    "name": "郑州市",
    "type": "市",
    "parentId": 16
  },
  {
    "id": 187,
    "name": "开封市",
    "type": "市",
    "parentId": 16
  },
  {
    "id": 188,
    "name": "洛阳市",
    "type": "市",
    "parentId": 16
  },
  {
    "id": 189,
    "name": "平顶山市",
    "type": "市",
    "parentId": 16
  },
  {
    "id": 190,
    "name": "安阳市",
    "type": "市",
    "parentId": 16
  },
  {
    "id": 191,
    "name": "鹤壁市",
    "type": "市",
    "parentId": 16
  },
  {
    "id": 192,
    "name": "新乡市",
    "type": "市",
    "parentId": 16
  },
  {
    "id": 193,
    "name": "焦作市",
    "type": "市",
    "parentId": 16
  },
  {
    "id": 194,
    "name": "濮阳市",
    "type": "市",
    "parentId": 16
  },
  {
    "id": 195,
    "name": "许昌市",
    "type": "市",
    "parentId": 16
  },
  {
    "id": 196,
    "name": "漯河市",
    "type": "市",
    "parentId": 16
  },
  {
    "id": 197,
    "name": "三门峡市",
    "type": "市",
    "parentId": 16
  },
  {
    "id": 198,
    "name": "南阳市",
    "type": "市",
    "parentId": 16
  },
  {
    "id": 199,
    "name": "商丘市",
    "type": "市",
    "parentId": 16
  },
  {
    "id": 200,
    "name": "信阳市",
    "type": "市",
    "parentId": 16
  },
  {
    "id": 201,
    "name": "周口市",
    "type": "市",
    "parentId": 16
  },
  {
    "id": 202,
    "name": "驻马店市",
    "type": "市",
    "parentId": 16
  },
  {
    "id": 203,
    "name": "省直辖县",
    "type": "市",
    "parentId": 16
  },
  {
    "id": 204,
    "name": "武汉市",
    "type": "市",
    "parentId": 17
  },
  {
    "id": 205,
    "name": "黄石市",
    "type": "市",
    "parentId": 17
  },
  {
    "id": 206,
    "name": "十堰市",
    "type": "市",
    "parentId": 17
  },
  {
    "id": 207,
    "name": "宜昌市",
    "type": "市",
    "parentId": 17
  },
  {
    "id": 208,
    "name": "襄阳市",
    "type": "市",
    "parentId": 17
  },
  {
    "id": 209,
    "name": "鄂州市",
    "type": "市",
    "parentId": 17
  },
  {
    "id": 210,
    "name": "荆门市",
    "type": "市",
    "parentId": 17
  },
  {
    "id": 211,
    "name": "孝感市",
    "type": "市",
    "parentId": 17
  },
  {
    "id": 212,
    "name": "荆州市",
    "type": "市",
    "parentId": 17
  },
  {
    "id": 213,
    "name": "黄冈市",
    "type": "市",
    "parentId": 17
  },
  {
    "id": 214,
    "name": "咸宁市",
    "type": "市",
    "parentId": 17
  },
  {
    "id": 215,
    "name": "随州市",
    "type": "市",
    "parentId": 17
  },
  {
    "id": 216,
    "name": "恩施土家族苗族自治州",
    "type": "市",
    "parentId": 17
  },
  {
    "id": 217,
    "name": "省直辖县",
    "type": "市",
    "parentId": 17
  },
  {
    "id": 218,
    "name": "长沙市",
    "type": "市",
    "parentId": 18
  },
  {
    "id": 219,
    "name": "株洲市",
    "type": "市",
    "parentId": 18
  },
  {
    "id": 220,
    "name": "湘潭市",
    "type": "市",
    "parentId": 18
  },
  {
    "id": 221,
    "name": "衡阳市",
    "type": "市",
    "parentId": 18
  },
  {
    "id": 222,
    "name": "邵阳市",
    "type": "市",
    "parentId": 18
  },
  {
    "id": 223,
    "name": "岳阳市",
    "type": "市",
    "parentId": 18
  },
  {
    "id": 224,
    "name": "常德市",
    "type": "市",
    "parentId": 18
  },
  {
    "id": 225,
    "name": "张家界市",
    "type": "市",
    "parentId": 18
  },
  {
    "id": 226,
    "name": "益阳市",
    "type": "市",
    "parentId": 18
  },
  {
    "id": 227,
    "name": "郴州市",
    "type": "市",
    "parentId": 18
  },
  {
    "id": 228,
    "name": "永州市",
    "type": "市",
    "parentId": 18
  },
  {
    "id": 229,
    "name": "怀化市",
    "type": "市",
    "parentId": 18
  },
  {
    "id": 230,
    "name": "娄底市",
    "type": "市",
    "parentId": 18
  },
  {
    "id": 231,
    "name": "湘西土家族苗族自治州",
    "type": "市",
    "parentId": 18
  },
  {
    "id": 232,
    "name": "广州市",
    "type": "市",
    "parentId": 19
  },
  {
    "id": 233,
    "name": "韶关市",
    "type": "市",
    "parentId": 19
  },
  {
    "id": 234,
    "name": "深圳市",
    "type": "市",
    "parentId": 19
  },
  {
    "id": 235,
    "name": "珠海市",
    "type": "市",
    "parentId": 19
  },
  {
    "id": 236,
    "name": "汕头市",
    "type": "市",
    "parentId": 19
  },
  {
    "id": 237,
    "name": "佛山市",
    "type": "市",
    "parentId": 19
  },
  {
    "id": 238,
    "name": "江门市",
    "type": "市",
    "parentId": 19
  },
  {
    "id": 239,
    "name": "湛江市",
    "type": "市",
    "parentId": 19
  },
  {
    "id": 240,
    "name": "茂名市",
    "type": "市",
    "parentId": 19
  },
  {
    "id": 241,
    "name": "肇庆市",
    "type": "市",
    "parentId": 19
  },
  {
    "id": 242,
    "name": "惠州市",
    "type": "市",
    "parentId": 19
  },
  {
    "id": 243,
    "name": "梅州市",
    "type": "市",
    "parentId": 19
  },
  {
    "id": 244,
    "name": "汕尾市",
    "type": "市",
    "parentId": 19
  },
  {
    "id": 245,
    "name": "河源市",
    "type": "市",
    "parentId": 19
  },
  {
    "id": 246,
    "name": "阳江市",
    "type": "市",
    "parentId": 19
  },
  {
    "id": 247,
    "name": "清远市",
    "type": "市",
    "parentId": 19
  },
  {
    "id": 248,
    "name": "东莞市",
    "type": "市",
    "parentId": 19
  },
  {
    "id": 249,
    "name": "中山市",
    "type": "市",
    "parentId": 19
  },
  {
    "id": 250,
    "name": "潮州市",
    "type": "市",
    "parentId": 19
  },
  {
    "id": 251,
    "name": "揭阳市",
    "type": "市",
    "parentId": 19
  },
  {
    "id": 252,
    "name": "云浮市",
    "type": "市",
    "parentId": 19
  },
  {
    "id": 253,
    "name": "南宁市",
    "type": "市",
    "parentId": 20
  },
  {
    "id": 254,
    "name": "柳州市",
    "type": "市",
    "parentId": 20
  },
  {
    "id": 255,
    "name": "桂林市",
    "type": "市",
    "parentId": 20
  },
  {
    "id": 256,
    "name": "梧州市",
    "type": "市",
    "parentId": 20
  },
  {
    "id": 257,
    "name": "北海市",
    "type": "市",
    "parentId": 20
  },
  {
    "id": 258,
    "name": "防城港市",
    "type": "市",
    "parentId": 20
  },
  {
    "id": 259,
    "name": "钦州市",
    "type": "市",
    "parentId": 20
  },
  {
    "id": 260,
    "name": "贵港市",
    "type": "市",
    "parentId": 20
  },
  {
    "id": 261,
    "name": "玉林市",
    "type": "市",
    "parentId": 20
  },
  {
    "id": 262,
    "name": "百色市",
    "type": "市",
    "parentId": 20
  },
  {
    "id": 263,
    "name": "贺州市",
    "type": "市",
    "parentId": 20
  },
  {
    "id": 264,
    "name": "河池市",
    "type": "市",
    "parentId": 20
  },
  {
    "id": 265,
    "name": "来宾市",
    "type": "市",
    "parentId": 20
  },
  {
    "id": 266,
    "name": "崇左市",
    "type": "市",
    "parentId": 20
  },
  {
    "id": 267,
    "name": "海口市",
    "type": "市",
    "parentId": 21
  },
  {
    "id": 268,
    "name": "三亚市",
    "type": "市",
    "parentId": 21
  },
  {
    "id": 269,
    "name": "三沙市",
    "type": "市",
    "parentId": 21
  },
  {
    "id": 270,
    "name": "儋州市",
    "type": "市",
    "parentId": 21
  },
  {
    "id": 271,
    "name": "省直辖县",
    "type": "市",
    "parentId": 21
  },
  {
    "id": 272,
    "name": "重庆市",
    "type": "市",
    "parentId": 22
  },
  {
    "id": 273,
    "name": "县",
    "type": "市",
    "parentId": 22
  },
  {
    "id": 274,
    "name": "成都市",
    "type": "市",
    "parentId": 23
  },
  {
    "id": 275,
    "name": "自贡市",
    "type": "市",
    "parentId": 23
  },
  {
    "id": 276,
    "name": "攀枝花市",
    "type": "市",
    "parentId": 23
  },
  {
    "id": 277,
    "name": "泸州市",
    "type": "市",
    "parentId": 23
  },
  {
    "id": 278,
    "name": "德阳市",
    "type": "市",
    "parentId": 23
  },
  {
    "id": 279,
    "name": "绵阳市",
    "type": "市",
    "parentId": 23
  },
  {
    "id": 280,
    "name": "广元市",
    "type": "市",
    "parentId": 23
  },
  {
    "id": 281,
    "name": "遂宁市",
    "type": "市",
    "parentId": 23
  },
  {
    "id": 282,
    "name": "内江市",
    "type": "市",
    "parentId": 23
  },
  {
    "id": 283,
    "name": "乐山市",
    "type": "市",
    "parentId": 23
  },
  {
    "id": 284,
    "name": "南充市",
    "type": "市",
    "parentId": 23
  },
  {
    "id": 285,
    "name": "眉山市",
    "type": "市",
    "parentId": 23
  },
  {
    "id": 286,
    "name": "宜宾市",
    "type": "市",
    "parentId": 23
  },
  {
    "id": 287,
    "name": "广安市",
    "type": "市",
    "parentId": 23
  },
  {
    "id": 288,
    "name": "达州市",
    "type": "市",
    "parentId": 23
  },
  {
    "id": 289,
    "name": "雅安市",
    "type": "市",
    "parentId": 23
  },
  {
    "id": 290,
    "name": "巴中市",
    "type": "市",
    "parentId": 23
  },
  {
    "id": 291,
    "name": "资阳市",
    "type": "市",
    "parentId": 23
  },
  {
    "id": 292,
    "name": "阿坝藏族羌族自治州",
    "type": "市",
    "parentId": 23
  },
  {
    "id": 293,
    "name": "甘孜藏族自治州",
    "type": "市",
    "parentId": 23
  },
  {
    "id": 294,
    "name": "凉山彝族自治州",
    "type": "市",
    "parentId": 23
  },
  {
    "id": 295,
    "name": "贵阳市",
    "type": "市",
    "parentId": 24
  },
  {
    "id": 296,
    "name": "六盘水市",
    "type": "市",
    "parentId": 24
  },
  {
    "id": 297,
    "name": "遵义市",
    "type": "市",
    "parentId": 24
  },
  {
    "id": 298,
    "name": "安顺市",
    "type": "市",
    "parentId": 24
  },
  {
    "id": 299,
    "name": "毕节市",
    "type": "市",
    "parentId": 24
  },
  {
    "id": 300,
    "name": "铜仁市",
    "type": "市",
    "parentId": 24
  },
  {
    "id": 301,
    "name": "黔西南布依族苗族自治州",
    "type": "市",
    "parentId": 24
  },
  {
    "id": 302,
    "name": "黔东南苗族侗族自治州",
    "type": "市",
    "parentId": 24
  },
  {
    "id": 303,
    "name": "黔南布依族苗族自治州",
    "type": "市",
    "parentId": 24
  },
  {
    "id": 304,
    "name": "昆明市",
    "type": "市",
    "parentId": 25
  },
  {
    "id": 305,
    "name": "曲靖市",
    "type": "市",
    "parentId": 25
  },
  {
    "id": 306,
    "name": "玉溪市",
    "type": "市",
    "parentId": 25
  },
  {
    "id": 307,
    "name": "保山市",
    "type": "市",
    "parentId": 25
  },
  {
    "id": 308,
    "name": "昭通市",
    "type": "市",
    "parentId": 25
  },
  {
    "id": 309,
    "name": "丽江市",
    "type": "市",
    "parentId": 25
  },
  {
    "id": 310,
    "name": "普洱市",
    "type": "市",
    "parentId": 25
  },
  {
    "id": 311,
    "name": "临沧市",
    "type": "市",
    "parentId": 25
  },
  {
    "id": 312,
    "name": "楚雄彝族自治州",
    "type": "市",
    "parentId": 25
  },
  {
    "id": 313,
    "name": "红河哈尼族彝族自治州",
    "type": "市",
    "parentId": 25
  },
  {
    "id": 314,
    "name": "文山壮族苗族自治州",
    "type": "市",
    "parentId": 25
  },
  {
    "id": 315,
    "name": "西双版纳傣族自治州",
    "type": "市",
    "parentId": 25
  },
  {
    "id": 316,
    "name": "大理白族自治州",
    "type": "市",
    "parentId": 25
  },
  {
    "id": 317,
    "name": "德宏傣族景颇族自治州",
    "type": "市",
    "parentId": 25
  },
  {
    "id": 318,
    "name": "怒江傈僳族自治州",
    "type": "市",
    "parentId": 25
  },
  {
    "id": 319,
    "name": "迪庆藏族自治州",
    "type": "市",
    "parentId": 25
  },
  {
    "id": 320,
    "name": "拉萨市",
    "type": "市",
    "parentId": 26
  },
  {
    "id": 321,
    "name": "日喀则市",
    "type": "市",
    "parentId": 26
  },
  {
    "id": 322,
    "name": "昌都市",
    "type": "市",
    "parentId": 26
  },
  {
    "id": 323,
    "name": "林芝市",
    "type": "市",
    "parentId": 26
  },
  {
    "id": 324,
    "name": "山南市",
    "type": "市",
    "parentId": 26
  },
  {
    "id": 325,
    "name": "那曲市",
    "type": "市",
    "parentId": 26
  },
  {
    "id": 326,
    "name": "阿里地区",
    "type": "市",
    "parentId": 26
  },
  {
    "id": 327,
    "name": "西安市",
    "type": "市",
    "parentId": 27
  },
  {
    "id": 328,
    "name": "铜川市",
    "type": "市",
    "parentId": 27
  },
  {
    "id": 329,
    "name": "宝鸡市",
    "type": "市",
    "parentId": 27
  },
  {
    "id": 330,
    "name": "咸阳市",
    "type": "市",
    "parentId": 27
  },
  {
    "id": 331,
    "name": "渭南市",
    "type": "市",
    "parentId": 27
  },
  {
    "id": 332,
    "name": "延安市",
    "type": "市",
    "parentId": 27
  },
  {
    "id": 333,
    "name": "汉中市",
    "type": "市",
    "parentId": 27
  },
  {
    "id": 334,
    "name": "榆林市",
    "type": "市",
    "parentId": 27
  },
  {
    "id": 335,
    "name": "安康市",
    "type": "市",
    "parentId": 27
  },
  {
    "id": 336,
    "name": "商洛市",
    "type": "市",
    "parentId": 27
  },
  {
    "id": 337,
    "name": "兰州市",
    "type": "市",
    "parentId": 28
  },
  {
    "id": 338,
    "name": "嘉峪关市",
    "type": "市",
    "parentId": 28
  },
  {
    "id": 339,
    "name": "金昌市",
    "type": "市",
    "parentId": 28
  },
  {
    "id": 340,
    "name": "白银市",
    "type": "市",
    "parentId": 28
  },
  {
    "id": 341,
    "name": "天水市",
    "type": "市",
    "parentId": 28
  },
  {
    "id": 342,
    "name": "武威市",
    "type": "市",
    "parentId": 28
  },
  {
    "id": 343,
    "name": "张掖市",
    "type": "市",
    "parentId": 28
  },
  {
    "id": 344,
    "name": "平凉市",
    "type": "市",
    "parentId": 28
  },
  {
    "id": 345,
    "name": "酒泉市",
    "type": "市",
    "parentId": 28
  },
  {
    "id": 346,
    "name": "庆阳市",
    "type": "市",
    "parentId": 28
  },
  {
    "id": 347,
    "name": "定西市",
    "type": "市",
    "parentId": 28
  },
  {
    "id": 348,
    "name": "陇南市",
    "type": "市",
    "parentId": 28
  },
  {
    "id": 349,
    "name": "临夏回族自治州",
    "type": "市",
    "parentId": 28
  },
  {
    "id": 350,
    "name": "甘南藏族自治州",
    "type": "市",
    "parentId": 28
  },
  {
    "id": 351,
    "name": "西宁市",
    "type": "市",
    "parentId": 29
  },
  {
    "id": 352,
    "name": "海东市",
    "type": "市",
    "parentId": 29
  },
  {
    "id": 353,
    "name": "海北藏族自治州",
    "type": "市",
    "parentId": 29
  },
  {
    "id": 354,
    "name": "黄南藏族自治州",
    "type": "市",
    "parentId": 29
  },
  {
    "id": 355,
    "name": "海南藏族自治州",
    "type": "市",
    "parentId": 29
  },
  {
    "id": 356,
    "name": "果洛藏族自治州",
    "type": "市",
    "parentId": 29
  },
  {
    "id": 357,
    "name": "玉树藏族自治州",
    "type": "市",
    "parentId": 29
  },
  {
    "id": 358,
    "name": "海西蒙古族藏族自治州",
    "type": "市",
    "parentId": 29
  },
  {
    "id": 359,
    "name": "银川市",
    "type": "市",
    "parentId": 30
  },
  {
    "id": 360,
    "name": "石嘴山市",
    "type": "市",
    "parentId": 30
  },
  {
    "id": 361,
    "name": "吴忠市",
    "type": "市",
    "parentId": 30
  },
  {
    "id": 362,
    "name": "固原市",
    "type": "市",
    "parentId": 30
  },
  {
    "id": 363,
    "name": "中卫市",
    "type": "市",
    "parentId": 30
  },
  {
    "id": 364,
    "name": "乌鲁木齐市",
    "type": "市",
    "parentId": 31
  },
  {
    "id": 365,
    "name": "克拉玛依市",
    "type": "市",
    "parentId": 31
  },
  {
    "id": 366,
    "name": "吐鲁番市",
    "type": "市",
    "parentId": 31
  },
  {
    "id": 367,
    "name": "哈密市",
    "type": "市",
    "parentId": 31
  },
  {
    "id": 368,
    "name": "昌吉回族自治州",
    "type": "市",
    "parentId": 31
  },
  {
    "id": 369,
    "name": "博尔塔拉蒙古自治州",
    "type": "市",
    "parentId": 31
  },
  {
    "id": 370,
    "name": "巴音郭楞蒙古自治州",
    "type": "市",
    "parentId": 31
  },
  {
    "id": 371,
    "name": "阿克苏地区",
    "type": "市",
    "parentId": 31
  },
  {
    "id": 372,
    "name": "克孜勒苏柯尔克孜自治州",
    "type": "市",
    "parentId": 31
  },
  {
    "id": 373,
    "name": "喀什地区",
    "type": "市",
    "parentId": 31
  },
  {
    "id": 374,
    "name": "和田地区",
    "type": "市",
    "parentId": 31
  },
  {
    "id": 375,
    "name": "伊犁哈萨克自治州",
    "type": "市",
    "parentId": 31
  },
  {
    "id": 376,
    "name": "塔城地区",
    "type": "市",
    "parentId": 31
  },
  {
    "id": 377,
    "name": "阿勒泰地区",
    "type": "市",
    "parentId": 31
  },
  {
    "id": 378,
    "name": "自治区直辖县级行政区划",
    "type": "市",
    "parentId": 31
  },
  {
    "id": 379,
    "name": "台北市",
    "type": "市",
    "parentId": 32
  },
  {
    "id": 380,
    "name": "高雄市",
    "type": "市",
    "parentId": 32
  },
  {
    "id": 381,
    "name": "台南市",
    "type": "市",
    "parentId": 32
  },
  {
    "id": 382,
    "name": "台中市",
    "type": "市",
    "parentId": 32
  },
  {
    "id": 383,
    "name": "金门县",
    "type": "市",
    "parentId": 32
  },
  {
    "id": 384,
    "name": "南投县",
    "type": "市",
    "parentId": 32
  },
  {
    "id": 385,
    "name": "基隆市",
    "type": "市",
    "parentId": 32
  },
  {
    "id": 386,
    "name": "新竹市",
    "type": "市",
    "parentId": 32
  },
  {
    "id": 387,
    "name": "嘉义市",
    "type": "市",
    "parentId": 32
  },
  {
    "id": 388,
    "name": "新北市",
    "type": "市",
    "parentId": 32
  },
  {
    "id": 389,
    "name": "宜兰县",
    "type": "市",
    "parentId": 32
  },
  {
    "id": 390,
    "name": "新竹县",
    "type": "市",
    "parentId": 32
  },
  {
    "id": 391,
    "name": "桃园县",
    "type": "市",
    "parentId": 32
  },
  {
    "id": 392,
    "name": "苗栗县",
    "type": "市",
    "parentId": 32
  },
  {
    "id": 393,
    "name": "彰化县",
    "type": "市",
    "parentId": 32
  },
  {
    "id": 394,
    "name": "嘉义县",
    "type": "市",
    "parentId": 32
  },
  {
    "id": 395,
    "name": "云林县",
    "type": "市",
    "parentId": 32
  },
  {
    "id": 396,
    "name": "屏东县",
    "type": "市",
    "parentId": 32
  },
  {
    "id": 397,
    "name": "台东县",
    "type": "市",
    "parentId": 32
  },
  {
    "id": 398,
    "name": "花莲县",
    "type": "市",
    "parentId": 32
  },
  {
    "id": 399,
    "name": "澎湖县",
    "type": "市",
    "parentId": 32
  },
  {
    "id": 400,
    "name": "连江县",
    "type": "市",
    "parentId": 32
  },
  {
    "id": 401,
    "name": "香港岛",
    "type": "市",
    "parentId": 33
  },
  {
    "id": 402,
    "name": "九龙",
    "type": "市",
    "parentId": 33
  },
  {
    "id": 403,
    "name": "新界",
    "type": "市",
    "parentId": 33
  },
  {
    "id": 404,
    "name": "澳门半岛",
    "type": "市",
    "parentId": 34
  },
  {
    "id": 405,
    "name": "离岛",
    "type": "市",
    "parentId": 34
  },
  {
    "id": 406,
    "name": "东城区",
    "type": "区",
    "parentId": 35
  },
  {
    "id": 407,
    "name": "西城区",
    "type": "区",
    "parentId": 35
  },
  {
    "id": 408,
    "name": "朝阳区",
    "type": "区",
    "parentId": 35
  },
  {
    "id": 409,
    "name": "丰台区",
    "type": "区",
    "parentId": 35
  },
  {
    "id": 410,
    "name": "石景山区",
    "type": "区",
    "parentId": 35
  },
  {
    "id": 411,
    "name": "海淀区",
    "type": "区",
    "parentId": 35
  },
  {
    "id": 412,
    "name": "门头沟区",
    "type": "区",
    "parentId": 35
  },
  {
    "id": 413,
    "name": "房山区",
    "type": "区",
    "parentId": 35
  },
  {
    "id": 414,
    "name": "通州区",
    "type": "区",
    "parentId": 35
  },
  {
    "id": 415,
    "name": "顺义区",
    "type": "区",
    "parentId": 35
  },
  {
    "id": 416,
    "name": "昌平区",
    "type": "区",
    "parentId": 35
  },
  {
    "id": 417,
    "name": "大兴区",
    "type": "区",
    "parentId": 35
  },
  {
    "id": 418,
    "name": "怀柔区",
    "type": "区",
    "parentId": 35
  },
  {
    "id": 419,
    "name": "平谷区",
    "type": "区",
    "parentId": 35
  },
  {
    "id": 420,
    "name": "密云区",
    "type": "区",
    "parentId": 35
  },
  {
    "id": 421,
    "name": "延庆区",
    "type": "区",
    "parentId": 35
  },
  {
    "id": 422,
    "name": "和平区",
    "type": "区",
    "parentId": 36
  },
  {
    "id": 423,
    "name": "河东区",
    "type": "区",
    "parentId": 36
  },
  {
    "id": 424,
    "name": "河西区",
    "type": "区",
    "parentId": 36
  },
  {
    "id": 425,
    "name": "南开区",
    "type": "区",
    "parentId": 36
  },
  {
    "id": 426,
    "name": "河北区",
    "type": "区",
    "parentId": 36
  },
  {
    "id": 427,
    "name": "红桥区",
    "type": "区",
    "parentId": 36
  },
  {
    "id": 428,
    "name": "东丽区",
    "type": "区",
    "parentId": 36
  },
  {
    "id": 429,
    "name": "西青区",
    "type": "区",
    "parentId": 36
  },
  {
    "id": 430,
    "name": "津南区",
    "type": "区",
    "parentId": 36
  },
  {
    "id": 431,
    "name": "北辰区",
    "type": "区",
    "parentId": 36
  },
  {
    "id": 432,
    "name": "武清区",
    "type": "区",
    "parentId": 36
  },
  {
    "id": 433,
    "name": "宝坻区",
    "type": "区",
    "parentId": 36
  },
  {
    "id": 434,
    "name": "滨海新区",
    "type": "区",
    "parentId": 36
  },
  {
    "id": 435,
    "name": "宁河区",
    "type": "区",
    "parentId": 36
  },
  {
    "id": 436,
    "name": "静海区",
    "type": "区",
    "parentId": 36
  },
  {
    "id": 437,
    "name": "蓟州区",
    "type": "区",
    "parentId": 36
  },
  {
    "id": 438,
    "name": "长安区",
    "type": "区",
    "parentId": 37
  },
  {
    "id": 439,
    "name": "桥西区",
    "type": "区",
    "parentId": 37
  },
  {
    "id": 440,
    "name": "新华区",
    "type": "区",
    "parentId": 37
  },
  {
    "id": 441,
    "name": "井陉矿区",
    "type": "区",
    "parentId": 37
  },
  {
    "id": 442,
    "name": "裕华区",
    "type": "区",
    "parentId": 37
  },
  {
    "id": 443,
    "name": "藁城区",
    "type": "区",
    "parentId": 37
  },
  {
    "id": 444,
    "name": "鹿泉区",
    "type": "区",
    "parentId": 37
  },
  {
    "id": 445,
    "name": "栾城区",
    "type": "区",
    "parentId": 37
  },
  {
    "id": 446,
    "name": "井陉县",
    "type": "区",
    "parentId": 37
  },
  {
    "id": 447,
    "name": "正定县",
    "type": "区",
    "parentId": 37
  },
  {
    "id": 448,
    "name": "行唐县",
    "type": "区",
    "parentId": 37
  },
  {
    "id": 449,
    "name": "灵寿县",
    "type": "区",
    "parentId": 37
  },
  {
    "id": 450,
    "name": "高邑县",
    "type": "区",
    "parentId": 37
  },
  {
    "id": 451,
    "name": "深泽县",
    "type": "区",
    "parentId": 37
  },
  {
    "id": 452,
    "name": "赞皇县",
    "type": "区",
    "parentId": 37
  },
  {
    "id": 453,
    "name": "无极县",
    "type": "区",
    "parentId": 37
  },
  {
    "id": 454,
    "name": "平山县",
    "type": "区",
    "parentId": 37
  },
  {
    "id": 455,
    "name": "元氏县",
    "type": "区",
    "parentId": 37
  },
  {
    "id": 456,
    "name": "赵县",
    "type": "区",
    "parentId": 37
  },
  {
    "id": 457,
    "name": "辛集市",
    "type": "区",
    "parentId": 37
  },
  {
    "id": 458,
    "name": "晋州市",
    "type": "区",
    "parentId": 37
  },
  {
    "id": 459,
    "name": "新乐市",
    "type": "区",
    "parentId": 37
  },
  {
    "id": 460,
    "name": "路南区",
    "type": "区",
    "parentId": 38
  },
  {
    "id": 461,
    "name": "路北区",
    "type": "区",
    "parentId": 38
  },
  {
    "id": 462,
    "name": "古冶区",
    "type": "区",
    "parentId": 38
  },
  {
    "id": 463,
    "name": "开平区",
    "type": "区",
    "parentId": 38
  },
  {
    "id": 464,
    "name": "丰南区",
    "type": "区",
    "parentId": 38
  },
  {
    "id": 465,
    "name": "丰润区",
    "type": "区",
    "parentId": 38
  },
  {
    "id": 466,
    "name": "曹妃甸区",
    "type": "区",
    "parentId": 38
  },
  {
    "id": 467,
    "name": "滦县",
    "type": "区",
    "parentId": 38
  },
  {
    "id": 468,
    "name": "滦南县",
    "type": "区",
    "parentId": 38
  },
  {
    "id": 469,
    "name": "乐亭县",
    "type": "区",
    "parentId": 38
  },
  {
    "id": 470,
    "name": "迁西县",
    "type": "区",
    "parentId": 38
  },
  {
    "id": 471,
    "name": "玉田县",
    "type": "区",
    "parentId": 38
  },
  {
    "id": 472,
    "name": "遵化市",
    "type": "区",
    "parentId": 38
  },
  {
    "id": 473,
    "name": "迁安市",
    "type": "区",
    "parentId": 38
  },
  {
    "id": 474,
    "name": "海港区",
    "type": "区",
    "parentId": 39
  },
  {
    "id": 475,
    "name": "山海关区",
    "type": "区",
    "parentId": 39
  },
  {
    "id": 476,
    "name": "北戴河区",
    "type": "区",
    "parentId": 39
  },
  {
    "id": 477,
    "name": "抚宁区",
    "type": "区",
    "parentId": 39
  },
  {
    "id": 478,
    "name": "青龙满族自治县",
    "type": "区",
    "parentId": 39
  },
  {
    "id": 479,
    "name": "昌黎县",
    "type": "区",
    "parentId": 39
  },
  {
    "id": 480,
    "name": "卢龙县",
    "type": "区",
    "parentId": 39
  },
  {
    "id": 481,
    "name": "经济技术开发区",
    "type": "区",
    "parentId": 39
  },
  {
    "id": 482,
    "name": "邯山区",
    "type": "区",
    "parentId": 40
  },
  {
    "id": 483,
    "name": "丛台区",
    "type": "区",
    "parentId": 40
  },
  {
    "id": 484,
    "name": "复兴区",
    "type": "区",
    "parentId": 40
  },
  {
    "id": 485,
    "name": "峰峰矿区",
    "type": "区",
    "parentId": 40
  },
  {
    "id": 486,
    "name": "肥乡区",
    "type": "区",
    "parentId": 40
  },
  {
    "id": 487,
    "name": "永年区",
    "type": "区",
    "parentId": 40
  },
  {
    "id": 488,
    "name": "临漳县",
    "type": "区",
    "parentId": 40
  },
  {
    "id": 489,
    "name": "成安县",
    "type": "区",
    "parentId": 40
  },
  {
    "id": 490,
    "name": "大名县",
    "type": "区",
    "parentId": 40
  },
  {
    "id": 491,
    "name": "涉县",
    "type": "区",
    "parentId": 40
  },
  {
    "id": 492,
    "name": "磁县",
    "type": "区",
    "parentId": 40
  },
  {
    "id": 493,
    "name": "邱县",
    "type": "区",
    "parentId": 40
  },
  {
    "id": 494,
    "name": "鸡泽县",
    "type": "区",
    "parentId": 40
  },
  {
    "id": 495,
    "name": "广平县",
    "type": "区",
    "parentId": 40
  },
  {
    "id": 496,
    "name": "馆陶县",
    "type": "区",
    "parentId": 40
  },
  {
    "id": 497,
    "name": "魏县",
    "type": "区",
    "parentId": 40
  },
  {
    "id": 498,
    "name": "曲周县",
    "type": "区",
    "parentId": 40
  },
  {
    "id": 499,
    "name": "武安市",
    "type": "区",
    "parentId": 40
  },
  {
    "id": 500,
    "name": "桥东区",
    "type": "区",
    "parentId": 41
  },
  {
    "id": 501,
    "name": "桥西区",
    "type": "区",
    "parentId": 41
  },
  {
    "id": 502,
    "name": "邢台县",
    "type": "区",
    "parentId": 41
  },
  {
    "id": 503,
    "name": "临城县",
    "type": "区",
    "parentId": 41
  },
  {
    "id": 504,
    "name": "内丘县",
    "type": "区",
    "parentId": 41
  },
  {
    "id": 505,
    "name": "柏乡县",
    "type": "区",
    "parentId": 41
  },
  {
    "id": 506,
    "name": "隆尧县",
    "type": "区",
    "parentId": 41
  },
  {
    "id": 507,
    "name": "任县",
    "type": "区",
    "parentId": 41
  },
  {
    "id": 508,
    "name": "南和县",
    "type": "区",
    "parentId": 41
  },
  {
    "id": 509,
    "name": "宁晋县",
    "type": "区",
    "parentId": 41
  },
  {
    "id": 510,
    "name": "巨鹿县",
    "type": "区",
    "parentId": 41
  },
  {
    "id": 511,
    "name": "新河县",
    "type": "区",
    "parentId": 41
  },
  {
    "id": 512,
    "name": "广宗县",
    "type": "区",
    "parentId": 41
  },
  {
    "id": 513,
    "name": "平乡县",
    "type": "区",
    "parentId": 41
  },
  {
    "id": 514,
    "name": "威县",
    "type": "区",
    "parentId": 41
  },
  {
    "id": 515,
    "name": "清河县",
    "type": "区",
    "parentId": 41
  },
  {
    "id": 516,
    "name": "临西县",
    "type": "区",
    "parentId": 41
  },
  {
    "id": 517,
    "name": "南宫市",
    "type": "区",
    "parentId": 41
  },
  {
    "id": 518,
    "name": "沙河市",
    "type": "区",
    "parentId": 41
  },
  {
    "id": 519,
    "name": "竞秀区",
    "type": "区",
    "parentId": 42
  },
  {
    "id": 520,
    "name": "莲池区",
    "type": "区",
    "parentId": 42
  },
  {
    "id": 521,
    "name": "满城区",
    "type": "区",
    "parentId": 42
  },
  {
    "id": 522,
    "name": "清苑区",
    "type": "区",
    "parentId": 42
  },
  {
    "id": 523,
    "name": "徐水区",
    "type": "区",
    "parentId": 42
  },
  {
    "id": 524,
    "name": "涞水县",
    "type": "区",
    "parentId": 42
  },
  {
    "id": 525,
    "name": "阜平县",
    "type": "区",
    "parentId": 42
  },
  {
    "id": 526,
    "name": "定兴县",
    "type": "区",
    "parentId": 42
  },
  {
    "id": 527,
    "name": "唐县",
    "type": "区",
    "parentId": 42
  },
  {
    "id": 528,
    "name": "高阳县",
    "type": "区",
    "parentId": 42
  },
  {
    "id": 529,
    "name": "容城县",
    "type": "区",
    "parentId": 42
  },
  {
    "id": 530,
    "name": "涞源县",
    "type": "区",
    "parentId": 42
  },
  {
    "id": 531,
    "name": "望都县",
    "type": "区",
    "parentId": 42
  },
  {
    "id": 532,
    "name": "安新县",
    "type": "区",
    "parentId": 42
  },
  {
    "id": 533,
    "name": "易县",
    "type": "区",
    "parentId": 42
  },
  {
    "id": 534,
    "name": "曲阳县",
    "type": "区",
    "parentId": 42
  },
  {
    "id": 535,
    "name": "蠡县",
    "type": "区",
    "parentId": 42
  },
  {
    "id": 536,
    "name": "顺平县",
    "type": "区",
    "parentId": 42
  },
  {
    "id": 537,
    "name": "博野县",
    "type": "区",
    "parentId": 42
  },
  {
    "id": 538,
    "name": "雄县",
    "type": "区",
    "parentId": 42
  },
  {
    "id": 539,
    "name": "涿州市",
    "type": "区",
    "parentId": 42
  },
  {
    "id": 540,
    "name": "定州市",
    "type": "区",
    "parentId": 42
  },
  {
    "id": 541,
    "name": "安国市",
    "type": "区",
    "parentId": 42
  },
  {
    "id": 542,
    "name": "高碑店市",
    "type": "区",
    "parentId": 42
  },
  {
    "id": 543,
    "name": "桥东区",
    "type": "区",
    "parentId": 43
  },
  {
    "id": 544,
    "name": "桥西区",
    "type": "区",
    "parentId": 43
  },
  {
    "id": 545,
    "name": "宣化区",
    "type": "区",
    "parentId": 43
  },
  {
    "id": 546,
    "name": "下花园区",
    "type": "区",
    "parentId": 43
  },
  {
    "id": 547,
    "name": "万全区",
    "type": "区",
    "parentId": 43
  },
  {
    "id": 548,
    "name": "崇礼区",
    "type": "区",
    "parentId": 43
  },
  {
    "id": 549,
    "name": "张北县",
    "type": "区",
    "parentId": 43
  },
  {
    "id": 550,
    "name": "康保县",
    "type": "区",
    "parentId": 43
  },
  {
    "id": 551,
    "name": "沽源县",
    "type": "区",
    "parentId": 43
  },
  {
    "id": 552,
    "name": "尚义县",
    "type": "区",
    "parentId": 43
  },
  {
    "id": 553,
    "name": "蔚县",
    "type": "区",
    "parentId": 43
  },
  {
    "id": 554,
    "name": "阳原县",
    "type": "区",
    "parentId": 43
  },
  {
    "id": 555,
    "name": "怀安县",
    "type": "区",
    "parentId": 43
  },
  {
    "id": 556,
    "name": "怀来县",
    "type": "区",
    "parentId": 43
  },
  {
    "id": 557,
    "name": "涿鹿县",
    "type": "区",
    "parentId": 43
  },
  {
    "id": 558,
    "name": "赤城县",
    "type": "区",
    "parentId": 43
  },
  {
    "id": 559,
    "name": "双桥区",
    "type": "区",
    "parentId": 44
  },
  {
    "id": 560,
    "name": "双滦区",
    "type": "区",
    "parentId": 44
  },
  {
    "id": 561,
    "name": "鹰手营子矿区",
    "type": "区",
    "parentId": 44
  },
  {
    "id": 562,
    "name": "承德县",
    "type": "区",
    "parentId": 44
  },
  {
    "id": 563,
    "name": "兴隆县",
    "type": "区",
    "parentId": 44
  },
  {
    "id": 564,
    "name": "滦平县",
    "type": "区",
    "parentId": 44
  },
  {
    "id": 565,
    "name": "隆化县",
    "type": "区",
    "parentId": 44
  },
  {
    "id": 566,
    "name": "丰宁满族自治县",
    "type": "区",
    "parentId": 44
  },
  {
    "id": 567,
    "name": "宽城满族自治县",
    "type": "区",
    "parentId": 44
  },
  {
    "id": 568,
    "name": "围场满族蒙古族自治县",
    "type": "区",
    "parentId": 44
  },
  {
    "id": 569,
    "name": "平泉市",
    "type": "区",
    "parentId": 44
  },
  {
    "id": 570,
    "name": "新华区",
    "type": "区",
    "parentId": 45
  },
  {
    "id": 571,
    "name": "运河区",
    "type": "区",
    "parentId": 45
  },
  {
    "id": 572,
    "name": "沧县",
    "type": "区",
    "parentId": 45
  },
  {
    "id": 573,
    "name": "青县",
    "type": "区",
    "parentId": 45
  },
  {
    "id": 574,
    "name": "东光县",
    "type": "区",
    "parentId": 45
  },
  {
    "id": 575,
    "name": "海兴县",
    "type": "区",
    "parentId": 45
  },
  {
    "id": 576,
    "name": "盐山县",
    "type": "区",
    "parentId": 45
  },
  {
    "id": 577,
    "name": "肃宁县",
    "type": "区",
    "parentId": 45
  },
  {
    "id": 578,
    "name": "南皮县",
    "type": "区",
    "parentId": 45
  },
  {
    "id": 579,
    "name": "吴桥县",
    "type": "区",
    "parentId": 45
  },
  {
    "id": 580,
    "name": "献县",
    "type": "区",
    "parentId": 45
  },
  {
    "id": 581,
    "name": "孟村回族自治县",
    "type": "区",
    "parentId": 45
  },
  {
    "id": 582,
    "name": "泊头市",
    "type": "区",
    "parentId": 45
  },
  {
    "id": 583,
    "name": "任丘市",
    "type": "区",
    "parentId": 45
  },
  {
    "id": 584,
    "name": "黄骅市",
    "type": "区",
    "parentId": 45
  },
  {
    "id": 585,
    "name": "河间市",
    "type": "区",
    "parentId": 45
  },
  {
    "id": 586,
    "name": "安次区",
    "type": "区",
    "parentId": 46
  },
  {
    "id": 587,
    "name": "广阳区",
    "type": "区",
    "parentId": 46
  },
  {
    "id": 588,
    "name": "固安县",
    "type": "区",
    "parentId": 46
  },
  {
    "id": 589,
    "name": "永清县",
    "type": "区",
    "parentId": 46
  },
  {
    "id": 590,
    "name": "香河县",
    "type": "区",
    "parentId": 46
  },
  {
    "id": 591,
    "name": "大城县",
    "type": "区",
    "parentId": 46
  },
  {
    "id": 592,
    "name": "文安县",
    "type": "区",
    "parentId": 46
  },
  {
    "id": 593,
    "name": "大厂回族自治县",
    "type": "区",
    "parentId": 46
  },
  {
    "id": 594,
    "name": "霸州市",
    "type": "区",
    "parentId": 46
  },
  {
    "id": 595,
    "name": "三河市",
    "type": "区",
    "parentId": 46
  },
  {
    "id": 596,
    "name": "开发区",
    "type": "区",
    "parentId": 46
  },
  {
    "id": 597,
    "name": "桃城区",
    "type": "区",
    "parentId": 47
  },
  {
    "id": 598,
    "name": "冀州区",
    "type": "区",
    "parentId": 47
  },
  {
    "id": 599,
    "name": "枣强县",
    "type": "区",
    "parentId": 47
  },
  {
    "id": 600,
    "name": "武邑县",
    "type": "区",
    "parentId": 47
  },
  {
    "id": 601,
    "name": "武强县",
    "type": "区",
    "parentId": 47
  },
  {
    "id": 602,
    "name": "饶阳县",
    "type": "区",
    "parentId": 47
  },
  {
    "id": 603,
    "name": "安平县",
    "type": "区",
    "parentId": 47
  },
  {
    "id": 604,
    "name": "故城县",
    "type": "区",
    "parentId": 47
  },
  {
    "id": 605,
    "name": "景县",
    "type": "区",
    "parentId": 47
  },
  {
    "id": 606,
    "name": "阜城县",
    "type": "区",
    "parentId": 47
  },
  {
    "id": 607,
    "name": "深州市",
    "type": "区",
    "parentId": 47
  },
  {
    "id": 608,
    "name": "小店区",
    "type": "区",
    "parentId": 49
  },
  {
    "id": 609,
    "name": "迎泽区",
    "type": "区",
    "parentId": 49
  },
  {
    "id": 610,
    "name": "杏花岭区",
    "type": "区",
    "parentId": 49
  },
  {
    "id": 611,
    "name": "尖草坪区",
    "type": "区",
    "parentId": 49
  },
  {
    "id": 612,
    "name": "万柏林区",
    "type": "区",
    "parentId": 49
  },
  {
    "id": 613,
    "name": "晋源区",
    "type": "区",
    "parentId": 49
  },
  {
    "id": 614,
    "name": "清徐县",
    "type": "区",
    "parentId": 49
  },
  {
    "id": 615,
    "name": "阳曲县",
    "type": "区",
    "parentId": 49
  },
  {
    "id": 616,
    "name": "娄烦县",
    "type": "区",
    "parentId": 49
  },
  {
    "id": 617,
    "name": "古交市",
    "type": "区",
    "parentId": 49
  },
  {
    "id": 618,
    "name": "城区",
    "type": "区",
    "parentId": 50
  },
  {
    "id": 619,
    "name": "矿区",
    "type": "区",
    "parentId": 50
  },
  {
    "id": 620,
    "name": "南郊区",
    "type": "区",
    "parentId": 50
  },
  {
    "id": 621,
    "name": "新荣区",
    "type": "区",
    "parentId": 50
  },
  {
    "id": 622,
    "name": "阳高县",
    "type": "区",
    "parentId": 50
  },
  {
    "id": 623,
    "name": "天镇县",
    "type": "区",
    "parentId": 50
  },
  {
    "id": 624,
    "name": "广灵县",
    "type": "区",
    "parentId": 50
  },
  {
    "id": 625,
    "name": "灵丘县",
    "type": "区",
    "parentId": 50
  },
  {
    "id": 626,
    "name": "浑源县",
    "type": "区",
    "parentId": 50
  },
  {
    "id": 627,
    "name": "左云县",
    "type": "区",
    "parentId": 50
  },
  {
    "id": 628,
    "name": "大同县",
    "type": "区",
    "parentId": 50
  },
  {
    "id": 629,
    "name": "城区",
    "type": "区",
    "parentId": 51
  },
  {
    "id": 630,
    "name": "矿区",
    "type": "区",
    "parentId": 51
  },
  {
    "id": 631,
    "name": "郊区",
    "type": "区",
    "parentId": 51
  },
  {
    "id": 632,
    "name": "平定县",
    "type": "区",
    "parentId": 51
  },
  {
    "id": 633,
    "name": "盂县",
    "type": "区",
    "parentId": 51
  },
  {
    "id": 634,
    "name": "城区",
    "type": "区",
    "parentId": 52
  },
  {
    "id": 635,
    "name": "郊区",
    "type": "区",
    "parentId": 52
  },
  {
    "id": 636,
    "name": "长治县",
    "type": "区",
    "parentId": 52
  },
  {
    "id": 637,
    "name": "襄垣县",
    "type": "区",
    "parentId": 52
  },
  {
    "id": 638,
    "name": "屯留县",
    "type": "区",
    "parentId": 52
  },
  {
    "id": 639,
    "name": "平顺县",
    "type": "区",
    "parentId": 52
  },
  {
    "id": 640,
    "name": "黎城县",
    "type": "区",
    "parentId": 52
  },
  {
    "id": 641,
    "name": "壶关县",
    "type": "区",
    "parentId": 52
  },
  {
    "id": 642,
    "name": "长子县",
    "type": "区",
    "parentId": 52
  },
  {
    "id": 643,
    "name": "武乡县",
    "type": "区",
    "parentId": 52
  },
  {
    "id": 644,
    "name": "沁县",
    "type": "区",
    "parentId": 52
  },
  {
    "id": 645,
    "name": "沁源县",
    "type": "区",
    "parentId": 52
  },
  {
    "id": 646,
    "name": "潞城市",
    "type": "区",
    "parentId": 52
  },
  {
    "id": 647,
    "name": "城区",
    "type": "区",
    "parentId": 53
  },
  {
    "id": 648,
    "name": "沁水县",
    "type": "区",
    "parentId": 53
  },
  {
    "id": 649,
    "name": "阳城县",
    "type": "区",
    "parentId": 53
  },
  {
    "id": 650,
    "name": "陵川县",
    "type": "区",
    "parentId": 53
  },
  {
    "id": 651,
    "name": "泽州县",
    "type": "区",
    "parentId": 53
  },
  {
    "id": 652,
    "name": "高平市",
    "type": "区",
    "parentId": 53
  },
  {
    "id": 653,
    "name": "朔城区",
    "type": "区",
    "parentId": 54
  },
  {
    "id": 654,
    "name": "平鲁区",
    "type": "区",
    "parentId": 54
  },
  {
    "id": 655,
    "name": "山阴县",
    "type": "区",
    "parentId": 54
  },
  {
    "id": 656,
    "name": "应县",
    "type": "区",
    "parentId": 54
  },
  {
    "id": 657,
    "name": "右玉县",
    "type": "区",
    "parentId": 54
  },
  {
    "id": 658,
    "name": "怀仁县",
    "type": "区",
    "parentId": 54
  },
  {
    "id": 659,
    "name": "榆次区",
    "type": "区",
    "parentId": 55
  },
  {
    "id": 660,
    "name": "榆社县",
    "type": "区",
    "parentId": 55
  },
  {
    "id": 661,
    "name": "左权县",
    "type": "区",
    "parentId": 55
  },
  {
    "id": 662,
    "name": "和顺县",
    "type": "区",
    "parentId": 55
  },
  {
    "id": 663,
    "name": "昔阳县",
    "type": "区",
    "parentId": 55
  },
  {
    "id": 664,
    "name": "寿阳县",
    "type": "区",
    "parentId": 55
  },
  {
    "id": 665,
    "name": "太谷县",
    "type": "区",
    "parentId": 55
  },
  {
    "id": 666,
    "name": "祁县",
    "type": "区",
    "parentId": 55
  },
  {
    "id": 667,
    "name": "平遥县",
    "type": "区",
    "parentId": 55
  },
  {
    "id": 668,
    "name": "灵石县",
    "type": "区",
    "parentId": 55
  },
  {
    "id": 669,
    "name": "介休市",
    "type": "区",
    "parentId": 55
  },
  {
    "id": 670,
    "name": "盐湖区",
    "type": "区",
    "parentId": 56
  },
  {
    "id": 671,
    "name": "临猗县",
    "type": "区",
    "parentId": 56
  },
  {
    "id": 672,
    "name": "万荣县",
    "type": "区",
    "parentId": 56
  },
  {
    "id": 673,
    "name": "闻喜县",
    "type": "区",
    "parentId": 56
  },
  {
    "id": 674,
    "name": "稷山县",
    "type": "区",
    "parentId": 56
  },
  {
    "id": 675,
    "name": "新绛县",
    "type": "区",
    "parentId": 56
  },
  {
    "id": 676,
    "name": "绛县",
    "type": "区",
    "parentId": 56
  },
  {
    "id": 677,
    "name": "垣曲县",
    "type": "区",
    "parentId": 56
  },
  {
    "id": 678,
    "name": "夏县",
    "type": "区",
    "parentId": 56
  },
  {
    "id": 679,
    "name": "平陆县",
    "type": "区",
    "parentId": 56
  },
  {
    "id": 680,
    "name": "芮城县",
    "type": "区",
    "parentId": 56
  },
  {
    "id": 681,
    "name": "永济市",
    "type": "区",
    "parentId": 56
  },
  {
    "id": 682,
    "name": "河津市",
    "type": "区",
    "parentId": 56
  },
  {
    "id": 683,
    "name": "忻府区",
    "type": "区",
    "parentId": 57
  },
  {
    "id": 684,
    "name": "定襄县",
    "type": "区",
    "parentId": 57
  },
  {
    "id": 685,
    "name": "五台县",
    "type": "区",
    "parentId": 57
  },
  {
    "id": 686,
    "name": "代县",
    "type": "区",
    "parentId": 57
  },
  {
    "id": 687,
    "name": "繁峙县",
    "type": "区",
    "parentId": 57
  },
  {
    "id": 688,
    "name": "宁武县",
    "type": "区",
    "parentId": 57
  },
  {
    "id": 689,
    "name": "静乐县",
    "type": "区",
    "parentId": 57
  },
  {
    "id": 690,
    "name": "神池县",
    "type": "区",
    "parentId": 57
  },
  {
    "id": 691,
    "name": "五寨县",
    "type": "区",
    "parentId": 57
  },
  {
    "id": 692,
    "name": "岢岚县",
    "type": "区",
    "parentId": 57
  },
  {
    "id": 693,
    "name": "河曲县",
    "type": "区",
    "parentId": 57
  },
  {
    "id": 694,
    "name": "保德县",
    "type": "区",
    "parentId": 57
  },
  {
    "id": 695,
    "name": "偏关县",
    "type": "区",
    "parentId": 57
  },
  {
    "id": 696,
    "name": "原平市",
    "type": "区",
    "parentId": 57
  },
  {
    "id": 697,
    "name": "尧都区",
    "type": "区",
    "parentId": 58
  },
  {
    "id": 698,
    "name": "曲沃县",
    "type": "区",
    "parentId": 58
  },
  {
    "id": 699,
    "name": "翼城县",
    "type": "区",
    "parentId": 58
  },
  {
    "id": 700,
    "name": "襄汾县",
    "type": "区",
    "parentId": 58
  },
  {
    "id": 701,
    "name": "洪洞县",
    "type": "区",
    "parentId": 58
  },
  {
    "id": 702,
    "name": "古县",
    "type": "区",
    "parentId": 58
  },
  {
    "id": 703,
    "name": "安泽县",
    "type": "区",
    "parentId": 58
  },
  {
    "id": 704,
    "name": "浮山县",
    "type": "区",
    "parentId": 58
  },
  {
    "id": 705,
    "name": "吉县",
    "type": "区",
    "parentId": 58
  },
  {
    "id": 706,
    "name": "乡宁县",
    "type": "区",
    "parentId": 58
  },
  {
    "id": 707,
    "name": "大宁县",
    "type": "区",
    "parentId": 58
  },
  {
    "id": 708,
    "name": "隰县",
    "type": "区",
    "parentId": 58
  },
  {
    "id": 709,
    "name": "永和县",
    "type": "区",
    "parentId": 58
  },
  {
    "id": 710,
    "name": "蒲县",
    "type": "区",
    "parentId": 58
  },
  {
    "id": 711,
    "name": "汾西县",
    "type": "区",
    "parentId": 58
  },
  {
    "id": 712,
    "name": "侯马市",
    "type": "区",
    "parentId": 58
  },
  {
    "id": 713,
    "name": "霍州市",
    "type": "区",
    "parentId": 58
  },
  {
    "id": 714,
    "name": "离石区",
    "type": "区",
    "parentId": 59
  },
  {
    "id": 715,
    "name": "文水县",
    "type": "区",
    "parentId": 59
  },
  {
    "id": 716,
    "name": "交城县",
    "type": "区",
    "parentId": 59
  },
  {
    "id": 717,
    "name": "兴县",
    "type": "区",
    "parentId": 59
  },
  {
    "id": 718,
    "name": "临县",
    "type": "区",
    "parentId": 59
  },
  {
    "id": 719,
    "name": "柳林县",
    "type": "区",
    "parentId": 59
  },
  {
    "id": 720,
    "name": "石楼县",
    "type": "区",
    "parentId": 59
  },
  {
    "id": 721,
    "name": "岚县",
    "type": "区",
    "parentId": 59
  },
  {
    "id": 722,
    "name": "方山县",
    "type": "区",
    "parentId": 59
  },
  {
    "id": 723,
    "name": "中阳县",
    "type": "区",
    "parentId": 59
  },
  {
    "id": 724,
    "name": "交口县",
    "type": "区",
    "parentId": 59
  },
  {
    "id": 725,
    "name": "孝义市",
    "type": "区",
    "parentId": 59
  },
  {
    "id": 726,
    "name": "汾阳市",
    "type": "区",
    "parentId": 59
  },
  {
    "id": 727,
    "name": "新城区",
    "type": "区",
    "parentId": 60
  },
  {
    "id": 728,
    "name": "回民区",
    "type": "区",
    "parentId": 60
  },
  {
    "id": 729,
    "name": "玉泉区",
    "type": "区",
    "parentId": 60
  },
  {
    "id": 730,
    "name": "赛罕区",
    "type": "区",
    "parentId": 60
  },
  {
    "id": 731,
    "name": "土默特左旗",
    "type": "区",
    "parentId": 60
  },
  {
    "id": 732,
    "name": "托克托县",
    "type": "区",
    "parentId": 60
  },
  {
    "id": 733,
    "name": "和林格尔县",
    "type": "区",
    "parentId": 60
  },
  {
    "id": 734,
    "name": "清水河县",
    "type": "区",
    "parentId": 60
  },
  {
    "id": 735,
    "name": "武川县",
    "type": "区",
    "parentId": 60
  },
  {
    "id": 736,
    "name": "东河区",
    "type": "区",
    "parentId": 61
  },
  {
    "id": 737,
    "name": "昆都仑区",
    "type": "区",
    "parentId": 61
  },
  {
    "id": 738,
    "name": "青山区",
    "type": "区",
    "parentId": 61
  },
  {
    "id": 739,
    "name": "石拐区",
    "type": "区",
    "parentId": 61
  },
  {
    "id": 740,
    "name": "白云鄂博矿区",
    "type": "区",
    "parentId": 61
  },
  {
    "id": 741,
    "name": "九原区",
    "type": "区",
    "parentId": 61
  },
  {
    "id": 742,
    "name": "土默特右旗",
    "type": "区",
    "parentId": 61
  },
  {
    "id": 743,
    "name": "固阳县",
    "type": "区",
    "parentId": 61
  },
  {
    "id": 744,
    "name": "达尔罕茂明安联合旗",
    "type": "区",
    "parentId": 61
  },
  {
    "id": 745,
    "name": "海勃湾区",
    "type": "区",
    "parentId": 62
  },
  {
    "id": 746,
    "name": "海南区",
    "type": "区",
    "parentId": 62
  },
  {
    "id": 747,
    "name": "乌达区",
    "type": "区",
    "parentId": 62
  },
  {
    "id": 748,
    "name": "红山区",
    "type": "区",
    "parentId": 63
  },
  {
    "id": 749,
    "name": "元宝山区",
    "type": "区",
    "parentId": 63
  },
  {
    "id": 750,
    "name": "松山区",
    "type": "区",
    "parentId": 63
  },
  {
    "id": 751,
    "name": "阿鲁科尔沁旗",
    "type": "区",
    "parentId": 63
  },
  {
    "id": 752,
    "name": "巴林左旗",
    "type": "区",
    "parentId": 63
  },
  {
    "id": 753,
    "name": "巴林右旗",
    "type": "区",
    "parentId": 63
  },
  {
    "id": 754,
    "name": "林西县",
    "type": "区",
    "parentId": 63
  },
  {
    "id": 755,
    "name": "克什克腾旗",
    "type": "区",
    "parentId": 63
  },
  {
    "id": 756,
    "name": "翁牛特旗",
    "type": "区",
    "parentId": 63
  },
  {
    "id": 757,
    "name": "喀喇沁旗",
    "type": "区",
    "parentId": 63
  },
  {
    "id": 758,
    "name": "宁城县",
    "type": "区",
    "parentId": 63
  },
  {
    "id": 759,
    "name": "敖汉旗",
    "type": "区",
    "parentId": 63
  },
  {
    "id": 760,
    "name": "科尔沁区",
    "type": "区",
    "parentId": 64
  },
  {
    "id": 761,
    "name": "科尔沁左翼中旗",
    "type": "区",
    "parentId": 64
  },
  {
    "id": 762,
    "name": "科尔沁左翼后旗",
    "type": "区",
    "parentId": 64
  },
  {
    "id": 763,
    "name": "开鲁县",
    "type": "区",
    "parentId": 64
  },
  {
    "id": 764,
    "name": "库伦旗",
    "type": "区",
    "parentId": 64
  },
  {
    "id": 765,
    "name": "奈曼旗",
    "type": "区",
    "parentId": 64
  },
  {
    "id": 766,
    "name": "扎鲁特旗",
    "type": "区",
    "parentId": 64
  },
  {
    "id": 767,
    "name": "霍林郭勒市",
    "type": "区",
    "parentId": 64
  },
  {
    "id": 768,
    "name": "东胜区",
    "type": "区",
    "parentId": 65
  },
  {
    "id": 769,
    "name": "康巴什区",
    "type": "区",
    "parentId": 65
  },
  {
    "id": 770,
    "name": "达拉特旗",
    "type": "区",
    "parentId": 65
  },
  {
    "id": 771,
    "name": "准格尔旗",
    "type": "区",
    "parentId": 65
  },
  {
    "id": 772,
    "name": "鄂托克前旗",
    "type": "区",
    "parentId": 65
  },
  {
    "id": 773,
    "name": "鄂托克旗",
    "type": "区",
    "parentId": 65
  },
  {
    "id": 774,
    "name": "杭锦旗",
    "type": "区",
    "parentId": 65
  },
  {
    "id": 775,
    "name": "乌审旗",
    "type": "区",
    "parentId": 65
  },
  {
    "id": 776,
    "name": "伊金霍洛旗",
    "type": "区",
    "parentId": 65
  },
  {
    "id": 777,
    "name": "海拉尔区",
    "type": "区",
    "parentId": 66
  },
  {
    "id": 778,
    "name": "扎赉诺尔区",
    "type": "区",
    "parentId": 66
  },
  {
    "id": 779,
    "name": "阿荣旗",
    "type": "区",
    "parentId": 66
  },
  {
    "id": 780,
    "name": "莫力达瓦达斡尔族自治旗",
    "type": "区",
    "parentId": 66
  },
  {
    "id": 781,
    "name": "鄂伦春自治旗",
    "type": "区",
    "parentId": 66
  },
  {
    "id": 782,
    "name": "鄂温克族自治旗",
    "type": "区",
    "parentId": 66
  },
  {
    "id": 783,
    "name": "陈巴尔虎旗",
    "type": "区",
    "parentId": 66
  },
  {
    "id": 784,
    "name": "新巴尔虎左旗",
    "type": "区",
    "parentId": 66
  },
  {
    "id": 785,
    "name": "新巴尔虎右旗",
    "type": "区",
    "parentId": 66
  },
  {
    "id": 786,
    "name": "满洲里市",
    "type": "区",
    "parentId": 66
  },
  {
    "id": 787,
    "name": "牙克石市",
    "type": "区",
    "parentId": 66
  },
  {
    "id": 788,
    "name": "扎兰屯市",
    "type": "区",
    "parentId": 66
  },
  {
    "id": 789,
    "name": "额尔古纳市",
    "type": "区",
    "parentId": 66
  },
  {
    "id": 790,
    "name": "根河市",
    "type": "区",
    "parentId": 66
  },
  {
    "id": 791,
    "name": "临河区",
    "type": "区",
    "parentId": 67
  },
  {
    "id": 792,
    "name": "五原县",
    "type": "区",
    "parentId": 67
  },
  {
    "id": 793,
    "name": "磴口县",
    "type": "区",
    "parentId": 67
  },
  {
    "id": 794,
    "name": "乌拉特前旗",
    "type": "区",
    "parentId": 67
  },
  {
    "id": 795,
    "name": "乌拉特中旗",
    "type": "区",
    "parentId": 67
  },
  {
    "id": 796,
    "name": "乌拉特后旗",
    "type": "区",
    "parentId": 67
  },
  {
    "id": 797,
    "name": "杭锦后旗",
    "type": "区",
    "parentId": 67
  },
  {
    "id": 798,
    "name": "集宁区",
    "type": "区",
    "parentId": 68
  },
  {
    "id": 799,
    "name": "卓资县",
    "type": "区",
    "parentId": 68
  },
  {
    "id": 800,
    "name": "化德县",
    "type": "区",
    "parentId": 68
  },
  {
    "id": 801,
    "name": "商都县",
    "type": "区",
    "parentId": 68
  },
  {
    "id": 802,
    "name": "兴和县",
    "type": "区",
    "parentId": 68
  },
  {
    "id": 803,
    "name": "凉城县",
    "type": "区",
    "parentId": 68
  },
  {
    "id": 804,
    "name": "察哈尔右翼前旗",
    "type": "区",
    "parentId": 68
  },
  {
    "id": 805,
    "name": "察哈尔右翼中旗",
    "type": "区",
    "parentId": 68
  },
  {
    "id": 806,
    "name": "察哈尔右翼后旗",
    "type": "区",
    "parentId": 68
  },
  {
    "id": 807,
    "name": "四子王旗",
    "type": "区",
    "parentId": 68
  },
  {
    "id": 808,
    "name": "丰镇市",
    "type": "区",
    "parentId": 68
  },
  {
    "id": 809,
    "name": "乌兰浩特市",
    "type": "区",
    "parentId": 69
  },
  {
    "id": 810,
    "name": "阿尔山市",
    "type": "区",
    "parentId": 69
  },
  {
    "id": 811,
    "name": "科尔沁右翼前旗",
    "type": "区",
    "parentId": 69
  },
  {
    "id": 812,
    "name": "科尔沁右翼中旗",
    "type": "区",
    "parentId": 69
  },
  {
    "id": 813,
    "name": "扎赉特旗",
    "type": "区",
    "parentId": 69
  },
  {
    "id": 814,
    "name": "突泉县",
    "type": "区",
    "parentId": 69
  },
  {
    "id": 815,
    "name": "二连浩特市",
    "type": "区",
    "parentId": 70
  },
  {
    "id": 816,
    "name": "锡林浩特市",
    "type": "区",
    "parentId": 70
  },
  {
    "id": 817,
    "name": "阿巴嘎旗",
    "type": "区",
    "parentId": 70
  },
  {
    "id": 818,
    "name": "苏尼特左旗",
    "type": "区",
    "parentId": 70
  },
  {
    "id": 819,
    "name": "苏尼特右旗",
    "type": "区",
    "parentId": 70
  },
  {
    "id": 820,
    "name": "东乌珠穆沁旗",
    "type": "区",
    "parentId": 70
  },
  {
    "id": 821,
    "name": "西乌珠穆沁旗",
    "type": "区",
    "parentId": 70
  },
  {
    "id": 822,
    "name": "太仆寺旗",
    "type": "区",
    "parentId": 70
  },
  {
    "id": 823,
    "name": "镶黄旗",
    "type": "区",
    "parentId": 70
  },
  {
    "id": 824,
    "name": "正镶白旗",
    "type": "区",
    "parentId": 70
  },
  {
    "id": 825,
    "name": "正蓝旗",
    "type": "区",
    "parentId": 70
  },
  {
    "id": 826,
    "name": "多伦县",
    "type": "区",
    "parentId": 70
  },
  {
    "id": 827,
    "name": "阿拉善左旗",
    "type": "区",
    "parentId": 71
  },
  {
    "id": 828,
    "name": "阿拉善右旗",
    "type": "区",
    "parentId": 71
  },
  {
    "id": 829,
    "name": "额济纳旗",
    "type": "区",
    "parentId": 71
  },
  {
    "id": 830,
    "name": "和平区",
    "type": "区",
    "parentId": 72
  },
  {
    "id": 831,
    "name": "沈河区",
    "type": "区",
    "parentId": 72
  },
  {
    "id": 832,
    "name": "大东区",
    "type": "区",
    "parentId": 72
  },
  {
    "id": 833,
    "name": "皇姑区",
    "type": "区",
    "parentId": 72
  },
  {
    "id": 834,
    "name": "铁西区",
    "type": "区",
    "parentId": 72
  },
  {
    "id": 835,
    "name": "苏家屯区",
    "type": "区",
    "parentId": 72
  },
  {
    "id": 836,
    "name": "浑南区",
    "type": "区",
    "parentId": 72
  },
  {
    "id": 837,
    "name": "沈北新区",
    "type": "区",
    "parentId": 72
  },
  {
    "id": 838,
    "name": "于洪区",
    "type": "区",
    "parentId": 72
  },
  {
    "id": 839,
    "name": "辽中区",
    "type": "区",
    "parentId": 72
  },
  {
    "id": 840,
    "name": "康平县",
    "type": "区",
    "parentId": 72
  },
  {
    "id": 841,
    "name": "法库县",
    "type": "区",
    "parentId": 72
  },
  {
    "id": 842,
    "name": "新民市",
    "type": "区",
    "parentId": 72
  },
  {
    "id": 843,
    "name": "经济技术开发区",
    "type": "区",
    "parentId": 72
  },
  {
    "id": 844,
    "name": "中山区",
    "type": "区",
    "parentId": 73
  },
  {
    "id": 845,
    "name": "西岗区",
    "type": "区",
    "parentId": 73
  },
  {
    "id": 846,
    "name": "沙河口区",
    "type": "区",
    "parentId": 73
  },
  {
    "id": 847,
    "name": "甘井子区",
    "type": "区",
    "parentId": 73
  },
  {
    "id": 848,
    "name": "旅顺口区",
    "type": "区",
    "parentId": 73
  },
  {
    "id": 849,
    "name": "金州区",
    "type": "区",
    "parentId": 73
  },
  {
    "id": 850,
    "name": "普兰店区",
    "type": "区",
    "parentId": 73
  },
  {
    "id": 851,
    "name": "长海县",
    "type": "区",
    "parentId": 73
  },
  {
    "id": 852,
    "name": "瓦房店市",
    "type": "区",
    "parentId": 73
  },
  {
    "id": 853,
    "name": "庄河市",
    "type": "区",
    "parentId": 73
  },
  {
    "id": 854,
    "name": "铁东区",
    "type": "区",
    "parentId": 74
  },
  {
    "id": 855,
    "name": "铁西区",
    "type": "区",
    "parentId": 74
  },
  {
    "id": 856,
    "name": "立山区",
    "type": "区",
    "parentId": 74
  },
  {
    "id": 857,
    "name": "千山区",
    "type": "区",
    "parentId": 74
  },
  {
    "id": 858,
    "name": "台安县",
    "type": "区",
    "parentId": 74
  },
  {
    "id": 859,
    "name": "岫岩满族自治县",
    "type": "区",
    "parentId": 74
  },
  {
    "id": 860,
    "name": "海城市",
    "type": "区",
    "parentId": 74
  },
  {
    "id": 861,
    "name": "高新区",
    "type": "区",
    "parentId": 74
  },
  {
    "id": 862,
    "name": "新抚区",
    "type": "区",
    "parentId": 75
  },
  {
    "id": 863,
    "name": "东洲区",
    "type": "区",
    "parentId": 75
  },
  {
    "id": 864,
    "name": "望花区",
    "type": "区",
    "parentId": 75
  },
  {
    "id": 865,
    "name": "顺城区",
    "type": "区",
    "parentId": 75
  },
  {
    "id": 866,
    "name": "抚顺县",
    "type": "区",
    "parentId": 75
  },
  {
    "id": 867,
    "name": "新宾满族自治县",
    "type": "区",
    "parentId": 75
  },
  {
    "id": 868,
    "name": "清原满族自治县",
    "type": "区",
    "parentId": 75
  },
  {
    "id": 869,
    "name": "平山区",
    "type": "区",
    "parentId": 76
  },
  {
    "id": 870,
    "name": "溪湖区",
    "type": "区",
    "parentId": 76
  },
  {
    "id": 871,
    "name": "明山区",
    "type": "区",
    "parentId": 76
  },
  {
    "id": 872,
    "name": "南芬区",
    "type": "区",
    "parentId": 76
  },
  {
    "id": 873,
    "name": "本溪满族自治县",
    "type": "区",
    "parentId": 76
  },
  {
    "id": 874,
    "name": "桓仁满族自治县",
    "type": "区",
    "parentId": 76
  },
  {
    "id": 875,
    "name": "元宝区",
    "type": "区",
    "parentId": 77
  },
  {
    "id": 876,
    "name": "振兴区",
    "type": "区",
    "parentId": 77
  },
  {
    "id": 877,
    "name": "振安区",
    "type": "区",
    "parentId": 77
  },
  {
    "id": 878,
    "name": "宽甸满族自治县",
    "type": "区",
    "parentId": 77
  },
  {
    "id": 879,
    "name": "东港市",
    "type": "区",
    "parentId": 77
  },
  {
    "id": 880,
    "name": "凤城市",
    "type": "区",
    "parentId": 77
  },
  {
    "id": 881,
    "name": "古塔区",
    "type": "区",
    "parentId": 78
  },
  {
    "id": 882,
    "name": "凌河区",
    "type": "区",
    "parentId": 78
  },
  {
    "id": 883,
    "name": "太和区",
    "type": "区",
    "parentId": 78
  },
  {
    "id": 884,
    "name": "黑山县",
    "type": "区",
    "parentId": 78
  },
  {
    "id": 885,
    "name": "义县",
    "type": "区",
    "parentId": 78
  },
  {
    "id": 886,
    "name": "凌海市",
    "type": "区",
    "parentId": 78
  },
  {
    "id": 887,
    "name": "北镇市",
    "type": "区",
    "parentId": 78
  },
  {
    "id": 888,
    "name": "经济技术开发区",
    "type": "区",
    "parentId": 78
  },
  {
    "id": 889,
    "name": "站前区",
    "type": "区",
    "parentId": 79
  },
  {
    "id": 890,
    "name": "西市区",
    "type": "区",
    "parentId": 79
  },
  {
    "id": 891,
    "name": "鲅鱼圈区",
    "type": "区",
    "parentId": 79
  },
  {
    "id": 892,
    "name": "老边区",
    "type": "区",
    "parentId": 79
  },
  {
    "id": 893,
    "name": "盖州市",
    "type": "区",
    "parentId": 79
  },
  {
    "id": 894,
    "name": "大石桥市",
    "type": "区",
    "parentId": 79
  },
  {
    "id": 895,
    "name": "海州区",
    "type": "区",
    "parentId": 80
  },
  {
    "id": 896,
    "name": "新邱区",
    "type": "区",
    "parentId": 80
  },
  {
    "id": 897,
    "name": "太平区",
    "type": "区",
    "parentId": 80
  },
  {
    "id": 898,
    "name": "清河门区",
    "type": "区",
    "parentId": 80
  },
  {
    "id": 899,
    "name": "细河区",
    "type": "区",
    "parentId": 80
  },
  {
    "id": 900,
    "name": "阜新蒙古族自治县",
    "type": "区",
    "parentId": 80
  },
  {
    "id": 901,
    "name": "彰武县",
    "type": "区",
    "parentId": 80
  },
  {
    "id": 902,
    "name": "白塔区",
    "type": "区",
    "parentId": 81
  },
  {
    "id": 903,
    "name": "文圣区",
    "type": "区",
    "parentId": 81
  },
  {
    "id": 904,
    "name": "宏伟区",
    "type": "区",
    "parentId": 81
  },
  {
    "id": 905,
    "name": "弓长岭区",
    "type": "区",
    "parentId": 81
  },
  {
    "id": 906,
    "name": "太子河区",
    "type": "区",
    "parentId": 81
  },
  {
    "id": 907,
    "name": "辽阳县",
    "type": "区",
    "parentId": 81
  },
  {
    "id": 908,
    "name": "灯塔市",
    "type": "区",
    "parentId": 81
  },
  {
    "id": 909,
    "name": "双台子区",
    "type": "区",
    "parentId": 82
  },
  {
    "id": 910,
    "name": "兴隆台区",
    "type": "区",
    "parentId": 82
  },
  {
    "id": 911,
    "name": "大洼区",
    "type": "区",
    "parentId": 82
  },
  {
    "id": 912,
    "name": "盘山县",
    "type": "区",
    "parentId": 82
  },
  {
    "id": 913,
    "name": "银州区",
    "type": "区",
    "parentId": 83
  },
  {
    "id": 914,
    "name": "清河区",
    "type": "区",
    "parentId": 83
  },
  {
    "id": 915,
    "name": "铁岭县",
    "type": "区",
    "parentId": 83
  },
  {
    "id": 916,
    "name": "西丰县",
    "type": "区",
    "parentId": 83
  },
  {
    "id": 917,
    "name": "昌图县",
    "type": "区",
    "parentId": 83
  },
  {
    "id": 918,
    "name": "调兵山市",
    "type": "区",
    "parentId": 83
  },
  {
    "id": 919,
    "name": "开原市",
    "type": "区",
    "parentId": 83
  },
  {
    "id": 920,
    "name": "双塔区",
    "type": "区",
    "parentId": 84
  },
  {
    "id": 921,
    "name": "龙城区",
    "type": "区",
    "parentId": 84
  },
  {
    "id": 922,
    "name": "朝阳县",
    "type": "区",
    "parentId": 84
  },
  {
    "id": 923,
    "name": "建平县",
    "type": "区",
    "parentId": 84
  },
  {
    "id": 924,
    "name": "喀喇沁左翼蒙古族自治县",
    "type": "区",
    "parentId": 84
  },
  {
    "id": 925,
    "name": "北票市",
    "type": "区",
    "parentId": 84
  },
  {
    "id": 926,
    "name": "凌源市",
    "type": "区",
    "parentId": 84
  },
  {
    "id": 927,
    "name": "连山区",
    "type": "区",
    "parentId": 85
  },
  {
    "id": 928,
    "name": "龙港区",
    "type": "区",
    "parentId": 85
  },
  {
    "id": 929,
    "name": "南票区",
    "type": "区",
    "parentId": 85
  },
  {
    "id": 930,
    "name": "绥中县",
    "type": "区",
    "parentId": 85
  },
  {
    "id": 931,
    "name": "建昌县",
    "type": "区",
    "parentId": 85
  },
  {
    "id": 932,
    "name": "兴城市",
    "type": "区",
    "parentId": 85
  },
  {
    "id": 933,
    "name": "南关区",
    "type": "区",
    "parentId": 86
  },
  {
    "id": 934,
    "name": "宽城区",
    "type": "区",
    "parentId": 86
  },
  {
    "id": 935,
    "name": "朝阳区",
    "type": "区",
    "parentId": 86
  },
  {
    "id": 936,
    "name": "二道区",
    "type": "区",
    "parentId": 86
  },
  {
    "id": 937,
    "name": "绿园区",
    "type": "区",
    "parentId": 86
  },
  {
    "id": 938,
    "name": "双阳区",
    "type": "区",
    "parentId": 86
  },
  {
    "id": 939,
    "name": "九台区",
    "type": "区",
    "parentId": 86
  },
  {
    "id": 940,
    "name": "农安县",
    "type": "区",
    "parentId": 86
  },
  {
    "id": 941,
    "name": "榆树市",
    "type": "区",
    "parentId": 86
  },
  {
    "id": 942,
    "name": "德惠市",
    "type": "区",
    "parentId": 86
  },
  {
    "id": 943,
    "name": "经济技术开发区",
    "type": "区",
    "parentId": 86
  },
  {
    "id": 944,
    "name": "昌邑区",
    "type": "区",
    "parentId": 87
  },
  {
    "id": 945,
    "name": "龙潭区",
    "type": "区",
    "parentId": 87
  },
  {
    "id": 946,
    "name": "船营区",
    "type": "区",
    "parentId": 87
  },
  {
    "id": 947,
    "name": "丰满区",
    "type": "区",
    "parentId": 87
  },
  {
    "id": 948,
    "name": "永吉县",
    "type": "区",
    "parentId": 87
  },
  {
    "id": 949,
    "name": "蛟河市",
    "type": "区",
    "parentId": 87
  },
  {
    "id": 950,
    "name": "桦甸市",
    "type": "区",
    "parentId": 87
  },
  {
    "id": 951,
    "name": "舒兰市",
    "type": "区",
    "parentId": 87
  },
  {
    "id": 952,
    "name": "磐石市",
    "type": "区",
    "parentId": 87
  },
  {
    "id": 953,
    "name": "铁西区",
    "type": "区",
    "parentId": 88
  },
  {
    "id": 954,
    "name": "铁东区",
    "type": "区",
    "parentId": 88
  },
  {
    "id": 955,
    "name": "梨树县",
    "type": "区",
    "parentId": 88
  },
  {
    "id": 956,
    "name": "伊通满族自治县",
    "type": "区",
    "parentId": 88
  },
  {
    "id": 957,
    "name": "公主岭市",
    "type": "区",
    "parentId": 88
  },
  {
    "id": 958,
    "name": "双辽市",
    "type": "区",
    "parentId": 88
  },
  {
    "id": 959,
    "name": "龙山区",
    "type": "区",
    "parentId": 89
  },
  {
    "id": 960,
    "name": "西安区",
    "type": "区",
    "parentId": 89
  },
  {
    "id": 961,
    "name": "东丰县",
    "type": "区",
    "parentId": 89
  },
  {
    "id": 962,
    "name": "东辽县",
    "type": "区",
    "parentId": 89
  },
  {
    "id": 963,
    "name": "东昌区",
    "type": "区",
    "parentId": 90
  },
  {
    "id": 964,
    "name": "二道江区",
    "type": "区",
    "parentId": 90
  },
  {
    "id": 965,
    "name": "通化县",
    "type": "区",
    "parentId": 90
  },
  {
    "id": 966,
    "name": "辉南县",
    "type": "区",
    "parentId": 90
  },
  {
    "id": 967,
    "name": "柳河县",
    "type": "区",
    "parentId": 90
  },
  {
    "id": 968,
    "name": "梅河口市",
    "type": "区",
    "parentId": 90
  },
  {
    "id": 969,
    "name": "集安市",
    "type": "区",
    "parentId": 90
  },
  {
    "id": 970,
    "name": "浑江区",
    "type": "区",
    "parentId": 91
  },
  {
    "id": 971,
    "name": "江源区",
    "type": "区",
    "parentId": 91
  },
  {
    "id": 972,
    "name": "抚松县",
    "type": "区",
    "parentId": 91
  },
  {
    "id": 973,
    "name": "靖宇县",
    "type": "区",
    "parentId": 91
  },
  {
    "id": 974,
    "name": "长白朝鲜族自治县",
    "type": "区",
    "parentId": 91
  },
  {
    "id": 975,
    "name": "临江市",
    "type": "区",
    "parentId": 91
  },
  {
    "id": 976,
    "name": "宁江区",
    "type": "区",
    "parentId": 92
  },
  {
    "id": 977,
    "name": "前郭尔罗斯蒙古族自治县",
    "type": "区",
    "parentId": 92
  },
  {
    "id": 978,
    "name": "长岭县",
    "type": "区",
    "parentId": 92
  },
  {
    "id": 979,
    "name": "乾安县",
    "type": "区",
    "parentId": 92
  },
  {
    "id": 980,
    "name": "扶余市",
    "type": "区",
    "parentId": 92
  },
  {
    "id": 981,
    "name": "洮北区",
    "type": "区",
    "parentId": 93
  },
  {
    "id": 982,
    "name": "镇赉县",
    "type": "区",
    "parentId": 93
  },
  {
    "id": 983,
    "name": "通榆县",
    "type": "区",
    "parentId": 93
  },
  {
    "id": 984,
    "name": "洮南市",
    "type": "区",
    "parentId": 93
  },
  {
    "id": 985,
    "name": "大安市",
    "type": "区",
    "parentId": 93
  },
  {
    "id": 986,
    "name": "延吉市",
    "type": "区",
    "parentId": 94
  },
  {
    "id": 987,
    "name": "图们市",
    "type": "区",
    "parentId": 94
  },
  {
    "id": 988,
    "name": "敦化市",
    "type": "区",
    "parentId": 94
  },
  {
    "id": 989,
    "name": "珲春市",
    "type": "区",
    "parentId": 94
  },
  {
    "id": 990,
    "name": "龙井市",
    "type": "区",
    "parentId": 94
  },
  {
    "id": 991,
    "name": "和龙市",
    "type": "区",
    "parentId": 94
  },
  {
    "id": 992,
    "name": "汪清县",
    "type": "区",
    "parentId": 94
  },
  {
    "id": 993,
    "name": "安图县",
    "type": "区",
    "parentId": 94
  },
  {
    "id": 994,
    "name": "道里区",
    "type": "区",
    "parentId": 95
  },
  {
    "id": 995,
    "name": "南岗区",
    "type": "区",
    "parentId": 95
  },
  {
    "id": 996,
    "name": "道外区",
    "type": "区",
    "parentId": 95
  },
  {
    "id": 997,
    "name": "平房区",
    "type": "区",
    "parentId": 95
  },
  {
    "id": 998,
    "name": "松北区",
    "type": "区",
    "parentId": 95
  },
  {
    "id": 999,
    "name": "香坊区",
    "type": "区",
    "parentId": 95
  },
  {
    "id": 1000,
    "name": "呼兰区",
    "type": "区",
    "parentId": 95
  },
  {
    "id": 1001,
    "name": "阿城区",
    "type": "区",
    "parentId": 95
  },
  {
    "id": 1002,
    "name": "双城区",
    "type": "区",
    "parentId": 95
  },
  {
    "id": 1003,
    "name": "依兰县",
    "type": "区",
    "parentId": 95
  },
  {
    "id": 1004,
    "name": "方正县",
    "type": "区",
    "parentId": 95
  },
  {
    "id": 1005,
    "name": "宾县",
    "type": "区",
    "parentId": 95
  },
  {
    "id": 1006,
    "name": "巴彦县",
    "type": "区",
    "parentId": 95
  },
  {
    "id": 1007,
    "name": "木兰县",
    "type": "区",
    "parentId": 95
  },
  {
    "id": 1008,
    "name": "通河县",
    "type": "区",
    "parentId": 95
  },
  {
    "id": 1009,
    "name": "延寿县",
    "type": "区",
    "parentId": 95
  },
  {
    "id": 1010,
    "name": "尚志市",
    "type": "区",
    "parentId": 95
  },
  {
    "id": 1011,
    "name": "五常市",
    "type": "区",
    "parentId": 95
  },
  {
    "id": 1012,
    "name": "龙沙区",
    "type": "区",
    "parentId": 96
  },
  {
    "id": 1013,
    "name": "建华区",
    "type": "区",
    "parentId": 96
  },
  {
    "id": 1014,
    "name": "铁锋区",
    "type": "区",
    "parentId": 96
  },
  {
    "id": 1015,
    "name": "昂昂溪区",
    "type": "区",
    "parentId": 96
  },
  {
    "id": 1016,
    "name": "富拉尔基区",
    "type": "区",
    "parentId": 96
  },
  {
    "id": 1017,
    "name": "碾子山区",
    "type": "区",
    "parentId": 96
  },
  {
    "id": 1018,
    "name": "梅里斯达斡尔族区",
    "type": "区",
    "parentId": 96
  },
  {
    "id": 1019,
    "name": "龙江县",
    "type": "区",
    "parentId": 96
  },
  {
    "id": 1020,
    "name": "依安县",
    "type": "区",
    "parentId": 96
  },
  {
    "id": 1021,
    "name": "泰来县",
    "type": "区",
    "parentId": 96
  },
  {
    "id": 1022,
    "name": "甘南县",
    "type": "区",
    "parentId": 96
  },
  {
    "id": 1023,
    "name": "富裕县",
    "type": "区",
    "parentId": 96
  },
  {
    "id": 1024,
    "name": "克山县",
    "type": "区",
    "parentId": 96
  },
  {
    "id": 1025,
    "name": "克东县",
    "type": "区",
    "parentId": 96
  },
  {
    "id": 1026,
    "name": "拜泉县",
    "type": "区",
    "parentId": 96
  },
  {
    "id": 1027,
    "name": "讷河市",
    "type": "区",
    "parentId": 96
  },
  {
    "id": 1028,
    "name": "鸡冠区",
    "type": "区",
    "parentId": 97
  },
  {
    "id": 1029,
    "name": "恒山区",
    "type": "区",
    "parentId": 97
  },
  {
    "id": 1030,
    "name": "滴道区",
    "type": "区",
    "parentId": 97
  },
  {
    "id": 1031,
    "name": "梨树区",
    "type": "区",
    "parentId": 97
  },
  {
    "id": 1032,
    "name": "城子河区",
    "type": "区",
    "parentId": 97
  },
  {
    "id": 1033,
    "name": "麻山区",
    "type": "区",
    "parentId": 97
  },
  {
    "id": 1034,
    "name": "鸡东县",
    "type": "区",
    "parentId": 97
  },
  {
    "id": 1035,
    "name": "虎林市",
    "type": "区",
    "parentId": 97
  },
  {
    "id": 1036,
    "name": "密山市",
    "type": "区",
    "parentId": 97
  },
  {
    "id": 1037,
    "name": "向阳区",
    "type": "区",
    "parentId": 98
  },
  {
    "id": 1038,
    "name": "工农区",
    "type": "区",
    "parentId": 98
  },
  {
    "id": 1039,
    "name": "南山区",
    "type": "区",
    "parentId": 98
  },
  {
    "id": 1040,
    "name": "兴安区",
    "type": "区",
    "parentId": 98
  },
  {
    "id": 1041,
    "name": "东山区",
    "type": "区",
    "parentId": 98
  },
  {
    "id": 1042,
    "name": "兴山区",
    "type": "区",
    "parentId": 98
  },
  {
    "id": 1043,
    "name": "萝北县",
    "type": "区",
    "parentId": 98
  },
  {
    "id": 1044,
    "name": "绥滨县",
    "type": "区",
    "parentId": 98
  },
  {
    "id": 1045,
    "name": "尖山区",
    "type": "区",
    "parentId": 99
  },
  {
    "id": 1046,
    "name": "岭东区",
    "type": "区",
    "parentId": 99
  },
  {
    "id": 1047,
    "name": "四方台区",
    "type": "区",
    "parentId": 99
  },
  {
    "id": 1048,
    "name": "宝山区",
    "type": "区",
    "parentId": 99
  },
  {
    "id": 1049,
    "name": "集贤县",
    "type": "区",
    "parentId": 99
  },
  {
    "id": 1050,
    "name": "友谊县",
    "type": "区",
    "parentId": 99
  },
  {
    "id": 1051,
    "name": "宝清县",
    "type": "区",
    "parentId": 99
  },
  {
    "id": 1052,
    "name": "饶河县",
    "type": "区",
    "parentId": 99
  },
  {
    "id": 1053,
    "name": "萨尔图区",
    "type": "区",
    "parentId": 100
  },
  {
    "id": 1054,
    "name": "龙凤区",
    "type": "区",
    "parentId": 100
  },
  {
    "id": 1055,
    "name": "让胡路区",
    "type": "区",
    "parentId": 100
  },
  {
    "id": 1056,
    "name": "红岗区",
    "type": "区",
    "parentId": 100
  },
  {
    "id": 1057,
    "name": "大同区",
    "type": "区",
    "parentId": 100
  },
  {
    "id": 1058,
    "name": "肇州县",
    "type": "区",
    "parentId": 100
  },
  {
    "id": 1059,
    "name": "肇源县",
    "type": "区",
    "parentId": 100
  },
  {
    "id": 1060,
    "name": "林甸县",
    "type": "区",
    "parentId": 100
  },
  {
    "id": 1061,
    "name": "杜尔伯特蒙古族自治县",
    "type": "区",
    "parentId": 100
  },
  {
    "id": 1062,
    "name": "伊春区",
    "type": "区",
    "parentId": 101
  },
  {
    "id": 1063,
    "name": "南岔区",
    "type": "区",
    "parentId": 101
  },
  {
    "id": 1064,
    "name": "友好区",
    "type": "区",
    "parentId": 101
  },
  {
    "id": 1065,
    "name": "西林区",
    "type": "区",
    "parentId": 101
  },
  {
    "id": 1066,
    "name": "翠峦区",
    "type": "区",
    "parentId": 101
  },
  {
    "id": 1067,
    "name": "新青区",
    "type": "区",
    "parentId": 101
  },
  {
    "id": 1068,
    "name": "美溪区",
    "type": "区",
    "parentId": 101
  },
  {
    "id": 1069,
    "name": "金山屯区",
    "type": "区",
    "parentId": 101
  },
  {
    "id": 1070,
    "name": "五营区",
    "type": "区",
    "parentId": 101
  },
  {
    "id": 1071,
    "name": "乌马河区",
    "type": "区",
    "parentId": 101
  },
  {
    "id": 1072,
    "name": "汤旺河区",
    "type": "区",
    "parentId": 101
  },
  {
    "id": 1073,
    "name": "带岭区",
    "type": "区",
    "parentId": 101
  },
  {
    "id": 1074,
    "name": "乌伊岭区",
    "type": "区",
    "parentId": 101
  },
  {
    "id": 1075,
    "name": "红星区",
    "type": "区",
    "parentId": 101
  },
  {
    "id": 1076,
    "name": "上甘岭区",
    "type": "区",
    "parentId": 101
  },
  {
    "id": 1077,
    "name": "嘉荫县",
    "type": "区",
    "parentId": 101
  },
  {
    "id": 1078,
    "name": "铁力市",
    "type": "区",
    "parentId": 101
  },
  {
    "id": 1079,
    "name": "向阳区",
    "type": "区",
    "parentId": 102
  },
  {
    "id": 1080,
    "name": "前进区",
    "type": "区",
    "parentId": 102
  },
  {
    "id": 1081,
    "name": "东风区",
    "type": "区",
    "parentId": 102
  },
  {
    "id": 1082,
    "name": "郊区",
    "type": "区",
    "parentId": 102
  },
  {
    "id": 1083,
    "name": "桦南县",
    "type": "区",
    "parentId": 102
  },
  {
    "id": 1084,
    "name": "桦川县",
    "type": "区",
    "parentId": 102
  },
  {
    "id": 1085,
    "name": "汤原县",
    "type": "区",
    "parentId": 102
  },
  {
    "id": 1086,
    "name": "同江市",
    "type": "区",
    "parentId": 102
  },
  {
    "id": 1087,
    "name": "富锦市",
    "type": "区",
    "parentId": 102
  },
  {
    "id": 1088,
    "name": "抚远市",
    "type": "区",
    "parentId": 102
  },
  {
    "id": 1089,
    "name": "新兴区",
    "type": "区",
    "parentId": 103
  },
  {
    "id": 1090,
    "name": "桃山区",
    "type": "区",
    "parentId": 103
  },
  {
    "id": 1091,
    "name": "茄子河区",
    "type": "区",
    "parentId": 103
  },
  {
    "id": 1092,
    "name": "勃利县",
    "type": "区",
    "parentId": 103
  },
  {
    "id": 1093,
    "name": "东安区",
    "type": "区",
    "parentId": 104
  },
  {
    "id": 1094,
    "name": "阳明区",
    "type": "区",
    "parentId": 104
  },
  {
    "id": 1095,
    "name": "爱民区",
    "type": "区",
    "parentId": 104
  },
  {
    "id": 1096,
    "name": "西安区",
    "type": "区",
    "parentId": 104
  },
  {
    "id": 1097,
    "name": "林口县",
    "type": "区",
    "parentId": 104
  },
  {
    "id": 1098,
    "name": "绥芬河市",
    "type": "区",
    "parentId": 104
  },
  {
    "id": 1099,
    "name": "海林市",
    "type": "区",
    "parentId": 104
  },
  {
    "id": 1100,
    "name": "宁安市",
    "type": "区",
    "parentId": 104
  },
  {
    "id": 1101,
    "name": "穆棱市",
    "type": "区",
    "parentId": 104
  },
  {
    "id": 1102,
    "name": "东宁市",
    "type": "区",
    "parentId": 104
  },
  {
    "id": 1103,
    "name": "爱辉区",
    "type": "区",
    "parentId": 105
  },
  {
    "id": 1104,
    "name": "嫩江县",
    "type": "区",
    "parentId": 105
  },
  {
    "id": 1105,
    "name": "逊克县",
    "type": "区",
    "parentId": 105
  },
  {
    "id": 1106,
    "name": "孙吴县",
    "type": "区",
    "parentId": 105
  },
  {
    "id": 1107,
    "name": "北安市",
    "type": "区",
    "parentId": 105
  },
  {
    "id": 1108,
    "name": "五大连池市",
    "type": "区",
    "parentId": 105
  },
  {
    "id": 1109,
    "name": "北林区",
    "type": "区",
    "parentId": 106
  },
  {
    "id": 1110,
    "name": "望奎县",
    "type": "区",
    "parentId": 106
  },
  {
    "id": 1111,
    "name": "兰西县",
    "type": "区",
    "parentId": 106
  },
  {
    "id": 1112,
    "name": "青冈县",
    "type": "区",
    "parentId": 106
  },
  {
    "id": 1113,
    "name": "庆安县",
    "type": "区",
    "parentId": 106
  },
  {
    "id": 1114,
    "name": "明水县",
    "type": "区",
    "parentId": 106
  },
  {
    "id": 1115,
    "name": "绥棱县",
    "type": "区",
    "parentId": 106
  },
  {
    "id": 1116,
    "name": "安达市",
    "type": "区",
    "parentId": 106
  },
  {
    "id": 1117,
    "name": "肇东市",
    "type": "区",
    "parentId": 106
  },
  {
    "id": 1118,
    "name": "海伦市",
    "type": "区",
    "parentId": 106
  },
  {
    "id": 1119,
    "name": "呼玛县",
    "type": "区",
    "parentId": 107
  },
  {
    "id": 1120,
    "name": "塔河县",
    "type": "区",
    "parentId": 107
  },
  {
    "id": 1121,
    "name": "漠河县",
    "type": "区",
    "parentId": 107
  },
  {
    "id": 1122,
    "name": "松岭区",
    "type": "区",
    "parentId": 107
  },
  {
    "id": 1123,
    "name": "呼中区",
    "type": "区",
    "parentId": 107
  },
  {
    "id": 1124,
    "name": "加格达奇区",
    "type": "区",
    "parentId": 107
  },
  {
    "id": 1125,
    "name": "新林区",
    "type": "区",
    "parentId": 107
  },
  {
    "id": 1126,
    "name": "黄浦区",
    "type": "区",
    "parentId": 108
  },
  {
    "id": 1127,
    "name": "徐汇区",
    "type": "区",
    "parentId": 108
  },
  {
    "id": 1128,
    "name": "长宁区",
    "type": "区",
    "parentId": 108
  },
  {
    "id": 1129,
    "name": "静安区",
    "type": "区",
    "parentId": 108
  },
  {
    "id": 1130,
    "name": "普陀区",
    "type": "区",
    "parentId": 108
  },
  {
    "id": 1131,
    "name": "虹口区",
    "type": "区",
    "parentId": 108
  },
  {
    "id": 1132,
    "name": "杨浦区",
    "type": "区",
    "parentId": 108
  },
  {
    "id": 1133,
    "name": "闵行区",
    "type": "区",
    "parentId": 108
  },
  {
    "id": 1134,
    "name": "宝山区",
    "type": "区",
    "parentId": 108
  },
  {
    "id": 1135,
    "name": "嘉定区",
    "type": "区",
    "parentId": 108
  },
  {
    "id": 1136,
    "name": "浦东新区",
    "type": "区",
    "parentId": 108
  },
  {
    "id": 1137,
    "name": "金山区",
    "type": "区",
    "parentId": 108
  },
  {
    "id": 1138,
    "name": "松江区",
    "type": "区",
    "parentId": 108
  },
  {
    "id": 1139,
    "name": "青浦区",
    "type": "区",
    "parentId": 108
  },
  {
    "id": 1140,
    "name": "奉贤区",
    "type": "区",
    "parentId": 108
  },
  {
    "id": 1141,
    "name": "崇明区",
    "type": "区",
    "parentId": 108
  },
  {
    "id": 1142,
    "name": "玄武区",
    "type": "区",
    "parentId": 109
  },
  {
    "id": 1143,
    "name": "秦淮区",
    "type": "区",
    "parentId": 109
  },
  {
    "id": 1144,
    "name": "建邺区",
    "type": "区",
    "parentId": 109
  },
  {
    "id": 1145,
    "name": "鼓楼区",
    "type": "区",
    "parentId": 109
  },
  {
    "id": 1146,
    "name": "浦口区",
    "type": "区",
    "parentId": 109
  },
  {
    "id": 1147,
    "name": "栖霞区",
    "type": "区",
    "parentId": 109
  },
  {
    "id": 1148,
    "name": "雨花台区",
    "type": "区",
    "parentId": 109
  },
  {
    "id": 1149,
    "name": "江宁区",
    "type": "区",
    "parentId": 109
  },
  {
    "id": 1150,
    "name": "六合区",
    "type": "区",
    "parentId": 109
  },
  {
    "id": 1151,
    "name": "溧水区",
    "type": "区",
    "parentId": 109
  },
  {
    "id": 1152,
    "name": "高淳区",
    "type": "区",
    "parentId": 109
  },
  {
    "id": 1153,
    "name": "锡山区",
    "type": "区",
    "parentId": 110
  },
  {
    "id": 1154,
    "name": "惠山区",
    "type": "区",
    "parentId": 110
  },
  {
    "id": 1155,
    "name": "滨湖区",
    "type": "区",
    "parentId": 110
  },
  {
    "id": 1156,
    "name": "梁溪区",
    "type": "区",
    "parentId": 110
  },
  {
    "id": 1157,
    "name": "新吴区",
    "type": "区",
    "parentId": 110
  },
  {
    "id": 1158,
    "name": "江阴市",
    "type": "区",
    "parentId": 110
  },
  {
    "id": 1159,
    "name": "宜兴市",
    "type": "区",
    "parentId": 110
  },
  {
    "id": 1160,
    "name": "鼓楼区",
    "type": "区",
    "parentId": 111
  },
  {
    "id": 1161,
    "name": "云龙区",
    "type": "区",
    "parentId": 111
  },
  {
    "id": 1162,
    "name": "贾汪区",
    "type": "区",
    "parentId": 111
  },
  {
    "id": 1163,
    "name": "泉山区",
    "type": "区",
    "parentId": 111
  },
  {
    "id": 1164,
    "name": "铜山区",
    "type": "区",
    "parentId": 111
  },
  {
    "id": 1165,
    "name": "丰县",
    "type": "区",
    "parentId": 111
  },
  {
    "id": 1166,
    "name": "沛县",
    "type": "区",
    "parentId": 111
  },
  {
    "id": 1167,
    "name": "睢宁县",
    "type": "区",
    "parentId": 111
  },
  {
    "id": 1168,
    "name": "新沂市",
    "type": "区",
    "parentId": 111
  },
  {
    "id": 1169,
    "name": "邳州市",
    "type": "区",
    "parentId": 111
  },
  {
    "id": 1170,
    "name": "工业园区",
    "type": "区",
    "parentId": 111
  },
  {
    "id": 1171,
    "name": "天宁区",
    "type": "区",
    "parentId": 112
  },
  {
    "id": 1172,
    "name": "钟楼区",
    "type": "区",
    "parentId": 112
  },
  {
    "id": 1173,
    "name": "新北区",
    "type": "区",
    "parentId": 112
  },
  {
    "id": 1174,
    "name": "武进区",
    "type": "区",
    "parentId": 112
  },
  {
    "id": 1175,
    "name": "金坛区",
    "type": "区",
    "parentId": 112
  },
  {
    "id": 1176,
    "name": "溧阳市",
    "type": "区",
    "parentId": 112
  },
  {
    "id": 1177,
    "name": "虎丘区",
    "type": "区",
    "parentId": 113
  },
  {
    "id": 1178,
    "name": "吴中区",
    "type": "区",
    "parentId": 113
  },
  {
    "id": 1179,
    "name": "相城区",
    "type": "区",
    "parentId": 113
  },
  {
    "id": 1180,
    "name": "姑苏区",
    "type": "区",
    "parentId": 113
  },
  {
    "id": 1181,
    "name": "吴江区",
    "type": "区",
    "parentId": 113
  },
  {
    "id": 1182,
    "name": "常熟市",
    "type": "区",
    "parentId": 113
  },
  {
    "id": 1183,
    "name": "张家港市",
    "type": "区",
    "parentId": 113
  },
  {
    "id": 1184,
    "name": "昆山市",
    "type": "区",
    "parentId": 113
  },
  {
    "id": 1185,
    "name": "太仓市",
    "type": "区",
    "parentId": 113
  },
  {
    "id": 1186,
    "name": "工业园区",
    "type": "区",
    "parentId": 113
  },
  {
    "id": 1187,
    "name": "高新区",
    "type": "区",
    "parentId": 113
  },
  {
    "id": 1188,
    "name": "崇川区",
    "type": "区",
    "parentId": 114
  },
  {
    "id": 1189,
    "name": "港闸区",
    "type": "区",
    "parentId": 114
  },
  {
    "id": 1190,
    "name": "通州区",
    "type": "区",
    "parentId": 114
  },
  {
    "id": 1191,
    "name": "海安县",
    "type": "区",
    "parentId": 114
  },
  {
    "id": 1192,
    "name": "如东县",
    "type": "区",
    "parentId": 114
  },
  {
    "id": 1193,
    "name": "启东市",
    "type": "区",
    "parentId": 114
  },
  {
    "id": 1194,
    "name": "如皋市",
    "type": "区",
    "parentId": 114
  },
  {
    "id": 1195,
    "name": "海门市",
    "type": "区",
    "parentId": 114
  },
  {
    "id": 1196,
    "name": "高新区",
    "type": "区",
    "parentId": 114
  },
  {
    "id": 1197,
    "name": "连云区",
    "type": "区",
    "parentId": 115
  },
  {
    "id": 1198,
    "name": "海州区",
    "type": "区",
    "parentId": 115
  },
  {
    "id": 1199,
    "name": "赣榆区",
    "type": "区",
    "parentId": 115
  },
  {
    "id": 1200,
    "name": "东海县",
    "type": "区",
    "parentId": 115
  },
  {
    "id": 1201,
    "name": "灌云县",
    "type": "区",
    "parentId": 115
  },
  {
    "id": 1202,
    "name": "灌南县",
    "type": "区",
    "parentId": 115
  },
  {
    "id": 1203,
    "name": "淮安区",
    "type": "区",
    "parentId": 116
  },
  {
    "id": 1204,
    "name": "淮阴区",
    "type": "区",
    "parentId": 116
  },
  {
    "id": 1205,
    "name": "清江浦区",
    "type": "区",
    "parentId": 116
  },
  {
    "id": 1206,
    "name": "洪泽区",
    "type": "区",
    "parentId": 116
  },
  {
    "id": 1207,
    "name": "涟水县",
    "type": "区",
    "parentId": 116
  },
  {
    "id": 1208,
    "name": "盱眙县",
    "type": "区",
    "parentId": 116
  },
  {
    "id": 1209,
    "name": "金湖县",
    "type": "区",
    "parentId": 116
  },
  {
    "id": 1210,
    "name": "经济开发区",
    "type": "区",
    "parentId": 116
  },
  {
    "id": 1211,
    "name": "亭湖区",
    "type": "区",
    "parentId": 117
  },
  {
    "id": 1212,
    "name": "盐都区",
    "type": "区",
    "parentId": 117
  },
  {
    "id": 1213,
    "name": "大丰区",
    "type": "区",
    "parentId": 117
  },
  {
    "id": 1214,
    "name": "响水县",
    "type": "区",
    "parentId": 117
  },
  {
    "id": 1215,
    "name": "滨海县",
    "type": "区",
    "parentId": 117
  },
  {
    "id": 1216,
    "name": "阜宁县",
    "type": "区",
    "parentId": 117
  },
  {
    "id": 1217,
    "name": "射阳县",
    "type": "区",
    "parentId": 117
  },
  {
    "id": 1218,
    "name": "建湖县",
    "type": "区",
    "parentId": 117
  },
  {
    "id": 1219,
    "name": "东台市",
    "type": "区",
    "parentId": 117
  },
  {
    "id": 1220,
    "name": "广陵区",
    "type": "区",
    "parentId": 118
  },
  {
    "id": 1221,
    "name": "邗江区",
    "type": "区",
    "parentId": 118
  },
  {
    "id": 1222,
    "name": "江都区",
    "type": "区",
    "parentId": 118
  },
  {
    "id": 1223,
    "name": "宝应县",
    "type": "区",
    "parentId": 118
  },
  {
    "id": 1224,
    "name": "仪征市",
    "type": "区",
    "parentId": 118
  },
  {
    "id": 1225,
    "name": "高邮市",
    "type": "区",
    "parentId": 118
  },
  {
    "id": 1226,
    "name": "经济开发区",
    "type": "区",
    "parentId": 118
  },
  {
    "id": 1227,
    "name": "京口区",
    "type": "区",
    "parentId": 119
  },
  {
    "id": 1228,
    "name": "润州区",
    "type": "区",
    "parentId": 119
  },
  {
    "id": 1229,
    "name": "丹徒区",
    "type": "区",
    "parentId": 119
  },
  {
    "id": 1230,
    "name": "丹阳市",
    "type": "区",
    "parentId": 119
  },
  {
    "id": 1231,
    "name": "扬中市",
    "type": "区",
    "parentId": 119
  },
  {
    "id": 1232,
    "name": "句容市",
    "type": "区",
    "parentId": 119
  },
  {
    "id": 1233,
    "name": "海陵区",
    "type": "区",
    "parentId": 120
  },
  {
    "id": 1234,
    "name": "高港区",
    "type": "区",
    "parentId": 120
  },
  {
    "id": 1235,
    "name": "姜堰区",
    "type": "区",
    "parentId": 120
  },
  {
    "id": 1236,
    "name": "兴化市",
    "type": "区",
    "parentId": 120
  },
  {
    "id": 1237,
    "name": "靖江市",
    "type": "区",
    "parentId": 120
  },
  {
    "id": 1238,
    "name": "泰兴市",
    "type": "区",
    "parentId": 120
  },
  {
    "id": 1239,
    "name": "宿城区",
    "type": "区",
    "parentId": 121
  },
  {
    "id": 1240,
    "name": "宿豫区",
    "type": "区",
    "parentId": 121
  },
  {
    "id": 1241,
    "name": "沭阳县",
    "type": "区",
    "parentId": 121
  },
  {
    "id": 1242,
    "name": "泗阳县",
    "type": "区",
    "parentId": 121
  },
  {
    "id": 1243,
    "name": "泗洪县",
    "type": "区",
    "parentId": 121
  },
  {
    "id": 1244,
    "name": "上城区",
    "type": "区",
    "parentId": 122
  },
  {
    "id": 1245,
    "name": "下城区",
    "type": "区",
    "parentId": 122
  },
  {
    "id": 1246,
    "name": "江干区",
    "type": "区",
    "parentId": 122
  },
  {
    "id": 1247,
    "name": "拱墅区",
    "type": "区",
    "parentId": 122
  },
  {
    "id": 1248,
    "name": "西湖区",
    "type": "区",
    "parentId": 122
  },
  {
    "id": 1249,
    "name": "滨江区",
    "type": "区",
    "parentId": 122
  },
  {
    "id": 1250,
    "name": "萧山区",
    "type": "区",
    "parentId": 122
  },
  {
    "id": 1251,
    "name": "余杭区",
    "type": "区",
    "parentId": 122
  },
  {
    "id": 1252,
    "name": "富阳区",
    "type": "区",
    "parentId": 122
  },
  {
    "id": 1253,
    "name": "临安区",
    "type": "区",
    "parentId": 122
  },
  {
    "id": 1254,
    "name": "桐庐县",
    "type": "区",
    "parentId": 122
  },
  {
    "id": 1255,
    "name": "淳安县",
    "type": "区",
    "parentId": 122
  },
  {
    "id": 1256,
    "name": "建德市",
    "type": "区",
    "parentId": 122
  },
  {
    "id": 1257,
    "name": "海曙区",
    "type": "区",
    "parentId": 123
  },
  {
    "id": 1258,
    "name": "江北区",
    "type": "区",
    "parentId": 123
  },
  {
    "id": 1259,
    "name": "北仑区",
    "type": "区",
    "parentId": 123
  },
  {
    "id": 1260,
    "name": "镇海区",
    "type": "区",
    "parentId": 123
  },
  {
    "id": 1261,
    "name": "鄞州区",
    "type": "区",
    "parentId": 123
  },
  {
    "id": 1262,
    "name": "奉化区",
    "type": "区",
    "parentId": 123
  },
  {
    "id": 1263,
    "name": "象山县",
    "type": "区",
    "parentId": 123
  },
  {
    "id": 1264,
    "name": "宁海县",
    "type": "区",
    "parentId": 123
  },
  {
    "id": 1265,
    "name": "余姚市",
    "type": "区",
    "parentId": 123
  },
  {
    "id": 1266,
    "name": "慈溪市",
    "type": "区",
    "parentId": 123
  },
  {
    "id": 1267,
    "name": "鹿城区",
    "type": "区",
    "parentId": 124
  },
  {
    "id": 1268,
    "name": "龙湾区",
    "type": "区",
    "parentId": 124
  },
  {
    "id": 1269,
    "name": "瓯海区",
    "type": "区",
    "parentId": 124
  },
  {
    "id": 1270,
    "name": "洞头区",
    "type": "区",
    "parentId": 124
  },
  {
    "id": 1271,
    "name": "永嘉县",
    "type": "区",
    "parentId": 124
  },
  {
    "id": 1272,
    "name": "平阳县",
    "type": "区",
    "parentId": 124
  },
  {
    "id": 1273,
    "name": "苍南县",
    "type": "区",
    "parentId": 124
  },
  {
    "id": 1274,
    "name": "文成县",
    "type": "区",
    "parentId": 124
  },
  {
    "id": 1275,
    "name": "泰顺县",
    "type": "区",
    "parentId": 124
  },
  {
    "id": 1276,
    "name": "瑞安市",
    "type": "区",
    "parentId": 124
  },
  {
    "id": 1277,
    "name": "乐清市",
    "type": "区",
    "parentId": 124
  },
  {
    "id": 1278,
    "name": "南湖区",
    "type": "区",
    "parentId": 125
  },
  {
    "id": 1279,
    "name": "秀洲区",
    "type": "区",
    "parentId": 125
  },
  {
    "id": 1280,
    "name": "嘉善县",
    "type": "区",
    "parentId": 125
  },
  {
    "id": 1281,
    "name": "海盐县",
    "type": "区",
    "parentId": 125
  },
  {
    "id": 1282,
    "name": "海宁市",
    "type": "区",
    "parentId": 125
  },
  {
    "id": 1283,
    "name": "平湖市",
    "type": "区",
    "parentId": 125
  },
  {
    "id": 1284,
    "name": "桐乡市",
    "type": "区",
    "parentId": 125
  },
  {
    "id": 1285,
    "name": "吴兴区",
    "type": "区",
    "parentId": 126
  },
  {
    "id": 1286,
    "name": "南浔区",
    "type": "区",
    "parentId": 126
  },
  {
    "id": 1287,
    "name": "德清县",
    "type": "区",
    "parentId": 126
  },
  {
    "id": 1288,
    "name": "长兴县",
    "type": "区",
    "parentId": 126
  },
  {
    "id": 1289,
    "name": "安吉县",
    "type": "区",
    "parentId": 126
  },
  {
    "id": 1290,
    "name": "越城区",
    "type": "区",
    "parentId": 127
  },
  {
    "id": 1291,
    "name": "柯桥区",
    "type": "区",
    "parentId": 127
  },
  {
    "id": 1292,
    "name": "上虞区",
    "type": "区",
    "parentId": 127
  },
  {
    "id": 1293,
    "name": "新昌县",
    "type": "区",
    "parentId": 127
  },
  {
    "id": 1294,
    "name": "诸暨市",
    "type": "区",
    "parentId": 127
  },
  {
    "id": 1295,
    "name": "嵊州市",
    "type": "区",
    "parentId": 127
  },
  {
    "id": 1296,
    "name": "婺城区",
    "type": "区",
    "parentId": 128
  },
  {
    "id": 1297,
    "name": "金东区",
    "type": "区",
    "parentId": 128
  },
  {
    "id": 1298,
    "name": "武义县",
    "type": "区",
    "parentId": 128
  },
  {
    "id": 1299,
    "name": "浦江县",
    "type": "区",
    "parentId": 128
  },
  {
    "id": 1300,
    "name": "磐安县",
    "type": "区",
    "parentId": 128
  },
  {
    "id": 1301,
    "name": "兰溪市",
    "type": "区",
    "parentId": 128
  },
  {
    "id": 1302,
    "name": "义乌市",
    "type": "区",
    "parentId": 128
  },
  {
    "id": 1303,
    "name": "东阳市",
    "type": "区",
    "parentId": 128
  },
  {
    "id": 1304,
    "name": "永康市",
    "type": "区",
    "parentId": 128
  },
  {
    "id": 1305,
    "name": "柯城区",
    "type": "区",
    "parentId": 129
  },
  {
    "id": 1306,
    "name": "衢江区",
    "type": "区",
    "parentId": 129
  },
  {
    "id": 1307,
    "name": "常山县",
    "type": "区",
    "parentId": 129
  },
  {
    "id": 1308,
    "name": "开化县",
    "type": "区",
    "parentId": 129
  },
  {
    "id": 1309,
    "name": "龙游县",
    "type": "区",
    "parentId": 129
  },
  {
    "id": 1310,
    "name": "江山市",
    "type": "区",
    "parentId": 129
  },
  {
    "id": 1311,
    "name": "定海区",
    "type": "区",
    "parentId": 130
  },
  {
    "id": 1312,
    "name": "普陀区",
    "type": "区",
    "parentId": 130
  },
  {
    "id": 1313,
    "name": "岱山县",
    "type": "区",
    "parentId": 130
  },
  {
    "id": 1314,
    "name": "嵊泗县",
    "type": "区",
    "parentId": 130
  },
  {
    "id": 1315,
    "name": "椒江区",
    "type": "区",
    "parentId": 131
  },
  {
    "id": 1316,
    "name": "黄岩区",
    "type": "区",
    "parentId": 131
  },
  {
    "id": 1317,
    "name": "路桥区",
    "type": "区",
    "parentId": 131
  },
  {
    "id": 1318,
    "name": "三门县",
    "type": "区",
    "parentId": 131
  },
  {
    "id": 1319,
    "name": "天台县",
    "type": "区",
    "parentId": 131
  },
  {
    "id": 1320,
    "name": "仙居县",
    "type": "区",
    "parentId": 131
  },
  {
    "id": 1321,
    "name": "温岭市",
    "type": "区",
    "parentId": 131
  },
  {
    "id": 1322,
    "name": "临海市",
    "type": "区",
    "parentId": 131
  },
  {
    "id": 1323,
    "name": "玉环市",
    "type": "区",
    "parentId": 131
  },
  {
    "id": 1324,
    "name": "莲都区",
    "type": "区",
    "parentId": 132
  },
  {
    "id": 1325,
    "name": "青田县",
    "type": "区",
    "parentId": 132
  },
  {
    "id": 1326,
    "name": "缙云县",
    "type": "区",
    "parentId": 132
  },
  {
    "id": 1327,
    "name": "遂昌县",
    "type": "区",
    "parentId": 132
  },
  {
    "id": 1328,
    "name": "松阳县",
    "type": "区",
    "parentId": 132
  },
  {
    "id": 1329,
    "name": "云和县",
    "type": "区",
    "parentId": 132
  },
  {
    "id": 1330,
    "name": "庆元县",
    "type": "区",
    "parentId": 132
  },
  {
    "id": 1331,
    "name": "景宁畲族自治县",
    "type": "区",
    "parentId": 132
  },
  {
    "id": 1332,
    "name": "龙泉市",
    "type": "区",
    "parentId": 132
  },
  {
    "id": 1333,
    "name": "瑶海区",
    "type": "区",
    "parentId": 133
  },
  {
    "id": 1334,
    "name": "庐阳区",
    "type": "区",
    "parentId": 133
  },
  {
    "id": 1335,
    "name": "蜀山区",
    "type": "区",
    "parentId": 133
  },
  {
    "id": 1336,
    "name": "包河区",
    "type": "区",
    "parentId": 133
  },
  {
    "id": 1337,
    "name": "长丰县",
    "type": "区",
    "parentId": 133
  },
  {
    "id": 1338,
    "name": "肥东县",
    "type": "区",
    "parentId": 133
  },
  {
    "id": 1339,
    "name": "肥西县",
    "type": "区",
    "parentId": 133
  },
  {
    "id": 1340,
    "name": "庐江县",
    "type": "区",
    "parentId": 133
  },
  {
    "id": 1341,
    "name": "巢湖市",
    "type": "区",
    "parentId": 133
  },
  {
    "id": 1342,
    "name": "高新技术开发区",
    "type": "区",
    "parentId": 133
  },
  {
    "id": 1343,
    "name": "经济技术开发区",
    "type": "区",
    "parentId": 133
  },
  {
    "id": 1344,
    "name": "镜湖区",
    "type": "区",
    "parentId": 134
  },
  {
    "id": 1345,
    "name": "弋江区",
    "type": "区",
    "parentId": 134
  },
  {
    "id": 1346,
    "name": "鸠江区",
    "type": "区",
    "parentId": 134
  },
  {
    "id": 1347,
    "name": "三山区",
    "type": "区",
    "parentId": 134
  },
  {
    "id": 1348,
    "name": "芜湖县",
    "type": "区",
    "parentId": 134
  },
  {
    "id": 1349,
    "name": "繁昌县",
    "type": "区",
    "parentId": 134
  },
  {
    "id": 1350,
    "name": "南陵县",
    "type": "区",
    "parentId": 134
  },
  {
    "id": 1351,
    "name": "无为县",
    "type": "区",
    "parentId": 134
  },
  {
    "id": 1352,
    "name": "龙子湖区",
    "type": "区",
    "parentId": 135
  },
  {
    "id": 1353,
    "name": "蚌山区",
    "type": "区",
    "parentId": 135
  },
  {
    "id": 1354,
    "name": "禹会区",
    "type": "区",
    "parentId": 135
  },
  {
    "id": 1355,
    "name": "淮上区",
    "type": "区",
    "parentId": 135
  },
  {
    "id": 1356,
    "name": "怀远县",
    "type": "区",
    "parentId": 135
  },
  {
    "id": 1357,
    "name": "五河县",
    "type": "区",
    "parentId": 135
  },
  {
    "id": 1358,
    "name": "固镇县",
    "type": "区",
    "parentId": 135
  },
  {
    "id": 1359,
    "name": "大通区",
    "type": "区",
    "parentId": 136
  },
  {
    "id": 1360,
    "name": "田家庵区",
    "type": "区",
    "parentId": 136
  },
  {
    "id": 1361,
    "name": "谢家集区",
    "type": "区",
    "parentId": 136
  },
  {
    "id": 1362,
    "name": "八公山区",
    "type": "区",
    "parentId": 136
  },
  {
    "id": 1363,
    "name": "潘集区",
    "type": "区",
    "parentId": 136
  },
  {
    "id": 1364,
    "name": "凤台县",
    "type": "区",
    "parentId": 136
  },
  {
    "id": 1365,
    "name": "寿县",
    "type": "区",
    "parentId": 136
  },
  {
    "id": 1366,
    "name": "花山区",
    "type": "区",
    "parentId": 137
  },
  {
    "id": 1367,
    "name": "雨山区",
    "type": "区",
    "parentId": 137
  },
  {
    "id": 1368,
    "name": "博望区",
    "type": "区",
    "parentId": 137
  },
  {
    "id": 1369,
    "name": "当涂县",
    "type": "区",
    "parentId": 137
  },
  {
    "id": 1370,
    "name": "含山县",
    "type": "区",
    "parentId": 137
  },
  {
    "id": 1371,
    "name": "和县",
    "type": "区",
    "parentId": 137
  },
  {
    "id": 1372,
    "name": "杜集区",
    "type": "区",
    "parentId": 138
  },
  {
    "id": 1373,
    "name": "相山区",
    "type": "区",
    "parentId": 138
  },
  {
    "id": 1374,
    "name": "烈山区",
    "type": "区",
    "parentId": 138
  },
  {
    "id": 1375,
    "name": "濉溪县",
    "type": "区",
    "parentId": 138
  },
  {
    "id": 1376,
    "name": "铜官区",
    "type": "区",
    "parentId": 139
  },
  {
    "id": 1377,
    "name": "义安区",
    "type": "区",
    "parentId": 139
  },
  {
    "id": 1378,
    "name": "郊区",
    "type": "区",
    "parentId": 139
  },
  {
    "id": 1379,
    "name": "枞阳县",
    "type": "区",
    "parentId": 139
  },
  {
    "id": 1380,
    "name": "迎江区",
    "type": "区",
    "parentId": 140
  },
  {
    "id": 1381,
    "name": "大观区",
    "type": "区",
    "parentId": 140
  },
  {
    "id": 1382,
    "name": "宜秀区",
    "type": "区",
    "parentId": 140
  },
  {
    "id": 1383,
    "name": "怀宁县",
    "type": "区",
    "parentId": 140
  },
  {
    "id": 1384,
    "name": "潜山县",
    "type": "区",
    "parentId": 140
  },
  {
    "id": 1385,
    "name": "太湖县",
    "type": "区",
    "parentId": 140
  },
  {
    "id": 1386,
    "name": "宿松县",
    "type": "区",
    "parentId": 140
  },
  {
    "id": 1387,
    "name": "望江县",
    "type": "区",
    "parentId": 140
  },
  {
    "id": 1388,
    "name": "岳西县",
    "type": "区",
    "parentId": 140
  },
  {
    "id": 1389,
    "name": "桐城市",
    "type": "区",
    "parentId": 140
  },
  {
    "id": 1390,
    "name": "屯溪区",
    "type": "区",
    "parentId": 141
  },
  {
    "id": 1391,
    "name": "黄山区",
    "type": "区",
    "parentId": 141
  },
  {
    "id": 1392,
    "name": "徽州区",
    "type": "区",
    "parentId": 141
  },
  {
    "id": 1393,
    "name": "歙县",
    "type": "区",
    "parentId": 141
  },
  {
    "id": 1394,
    "name": "休宁县",
    "type": "区",
    "parentId": 141
  },
  {
    "id": 1395,
    "name": "黟县",
    "type": "区",
    "parentId": 141
  },
  {
    "id": 1396,
    "name": "祁门县",
    "type": "区",
    "parentId": 141
  },
  {
    "id": 1397,
    "name": "琅琊区",
    "type": "区",
    "parentId": 142
  },
  {
    "id": 1398,
    "name": "南谯区",
    "type": "区",
    "parentId": 142
  },
  {
    "id": 1399,
    "name": "来安县",
    "type": "区",
    "parentId": 142
  },
  {
    "id": 1400,
    "name": "全椒县",
    "type": "区",
    "parentId": 142
  },
  {
    "id": 1401,
    "name": "定远县",
    "type": "区",
    "parentId": 142
  },
  {
    "id": 1402,
    "name": "凤阳县",
    "type": "区",
    "parentId": 142
  },
  {
    "id": 1403,
    "name": "天长市",
    "type": "区",
    "parentId": 142
  },
  {
    "id": 1404,
    "name": "明光市",
    "type": "区",
    "parentId": 142
  },
  {
    "id": 1405,
    "name": "颍州区",
    "type": "区",
    "parentId": 143
  },
  {
    "id": 1406,
    "name": "颍东区",
    "type": "区",
    "parentId": 143
  },
  {
    "id": 1407,
    "name": "颍泉区",
    "type": "区",
    "parentId": 143
  },
  {
    "id": 1408,
    "name": "临泉县",
    "type": "区",
    "parentId": 143
  },
  {
    "id": 1409,
    "name": "太和县",
    "type": "区",
    "parentId": 143
  },
  {
    "id": 1410,
    "name": "阜南县",
    "type": "区",
    "parentId": 143
  },
  {
    "id": 1411,
    "name": "颍上县",
    "type": "区",
    "parentId": 143
  },
  {
    "id": 1412,
    "name": "界首市",
    "type": "区",
    "parentId": 143
  },
  {
    "id": 1413,
    "name": "埇桥区",
    "type": "区",
    "parentId": 144
  },
  {
    "id": 1414,
    "name": "砀山县",
    "type": "区",
    "parentId": 144
  },
  {
    "id": 1415,
    "name": "萧县",
    "type": "区",
    "parentId": 144
  },
  {
    "id": 1416,
    "name": "灵璧县",
    "type": "区",
    "parentId": 144
  },
  {
    "id": 1417,
    "name": "泗县",
    "type": "区",
    "parentId": 144
  },
  {
    "id": 1418,
    "name": "经济开发区",
    "type": "区",
    "parentId": 144
  },
  {
    "id": 1419,
    "name": "金安区",
    "type": "区",
    "parentId": 145
  },
  {
    "id": 1420,
    "name": "裕安区",
    "type": "区",
    "parentId": 145
  },
  {
    "id": 1421,
    "name": "叶集区",
    "type": "区",
    "parentId": 145
  },
  {
    "id": 1422,
    "name": "霍邱县",
    "type": "区",
    "parentId": 145
  },
  {
    "id": 1423,
    "name": "舒城县",
    "type": "区",
    "parentId": 145
  },
  {
    "id": 1424,
    "name": "金寨县",
    "type": "区",
    "parentId": 145
  },
  {
    "id": 1425,
    "name": "霍山县",
    "type": "区",
    "parentId": 145
  },
  {
    "id": 1426,
    "name": "谯城区",
    "type": "区",
    "parentId": 146
  },
  {
    "id": 1427,
    "name": "涡阳县",
    "type": "区",
    "parentId": 146
  },
  {
    "id": 1428,
    "name": "蒙城县",
    "type": "区",
    "parentId": 146
  },
  {
    "id": 1429,
    "name": "利辛县",
    "type": "区",
    "parentId": 146
  },
  {
    "id": 1430,
    "name": "贵池区",
    "type": "区",
    "parentId": 147
  },
  {
    "id": 1431,
    "name": "东至县",
    "type": "区",
    "parentId": 147
  },
  {
    "id": 1432,
    "name": "石台县",
    "type": "区",
    "parentId": 147
  },
  {
    "id": 1433,
    "name": "青阳县",
    "type": "区",
    "parentId": 147
  },
  {
    "id": 1434,
    "name": "宣州区",
    "type": "区",
    "parentId": 148
  },
  {
    "id": 1435,
    "name": "郎溪县",
    "type": "区",
    "parentId": 148
  },
  {
    "id": 1436,
    "name": "广德县",
    "type": "区",
    "parentId": 148
  },
  {
    "id": 1437,
    "name": "泾县",
    "type": "区",
    "parentId": 148
  },
  {
    "id": 1438,
    "name": "绩溪县",
    "type": "区",
    "parentId": 148
  },
  {
    "id": 1439,
    "name": "旌德县",
    "type": "区",
    "parentId": 148
  },
  {
    "id": 1440,
    "name": "宁国市",
    "type": "区",
    "parentId": 148
  },
  {
    "id": 1441,
    "name": "鼓楼区",
    "type": "区",
    "parentId": 149
  },
  {
    "id": 1442,
    "name": "台江区",
    "type": "区",
    "parentId": 149
  },
  {
    "id": 1443,
    "name": "仓山区",
    "type": "区",
    "parentId": 149
  },
  {
    "id": 1444,
    "name": "马尾区",
    "type": "区",
    "parentId": 149
  },
  {
    "id": 1445,
    "name": "晋安区",
    "type": "区",
    "parentId": 149
  },
  {
    "id": 1446,
    "name": "长乐区",
    "type": "区",
    "parentId": 149
  },
  {
    "id": 1447,
    "name": "闽侯县",
    "type": "区",
    "parentId": 149
  },
  {
    "id": 1448,
    "name": "连江县",
    "type": "区",
    "parentId": 149
  },
  {
    "id": 1449,
    "name": "罗源县",
    "type": "区",
    "parentId": 149
  },
  {
    "id": 1450,
    "name": "闽清县",
    "type": "区",
    "parentId": 149
  },
  {
    "id": 1451,
    "name": "永泰县",
    "type": "区",
    "parentId": 149
  },
  {
    "id": 1452,
    "name": "平潭县",
    "type": "区",
    "parentId": 149
  },
  {
    "id": 1453,
    "name": "福清市",
    "type": "区",
    "parentId": 149
  },
  {
    "id": 1454,
    "name": "思明区",
    "type": "区",
    "parentId": 150
  },
  {
    "id": 1455,
    "name": "海沧区",
    "type": "区",
    "parentId": 150
  },
  {
    "id": 1456,
    "name": "湖里区",
    "type": "区",
    "parentId": 150
  },
  {
    "id": 1457,
    "name": "集美区",
    "type": "区",
    "parentId": 150
  },
  {
    "id": 1458,
    "name": "同安区",
    "type": "区",
    "parentId": 150
  },
  {
    "id": 1459,
    "name": "翔安区",
    "type": "区",
    "parentId": 150
  },
  {
    "id": 1460,
    "name": "城厢区",
    "type": "区",
    "parentId": 151
  },
  {
    "id": 1461,
    "name": "涵江区",
    "type": "区",
    "parentId": 151
  },
  {
    "id": 1462,
    "name": "荔城区",
    "type": "区",
    "parentId": 151
  },
  {
    "id": 1463,
    "name": "秀屿区",
    "type": "区",
    "parentId": 151
  },
  {
    "id": 1464,
    "name": "仙游县",
    "type": "区",
    "parentId": 151
  },
  {
    "id": 1465,
    "name": "梅列区",
    "type": "区",
    "parentId": 152
  },
  {
    "id": 1466,
    "name": "三元区",
    "type": "区",
    "parentId": 152
  },
  {
    "id": 1467,
    "name": "明溪县",
    "type": "区",
    "parentId": 152
  },
  {
    "id": 1468,
    "name": "清流县",
    "type": "区",
    "parentId": 152
  },
  {
    "id": 1469,
    "name": "宁化县",
    "type": "区",
    "parentId": 152
  },
  {
    "id": 1470,
    "name": "大田县",
    "type": "区",
    "parentId": 152
  },
  {
    "id": 1471,
    "name": "尤溪县",
    "type": "区",
    "parentId": 152
  },
  {
    "id": 1472,
    "name": "沙县",
    "type": "区",
    "parentId": 152
  },
  {
    "id": 1473,
    "name": "将乐县",
    "type": "区",
    "parentId": 152
  },
  {
    "id": 1474,
    "name": "泰宁县",
    "type": "区",
    "parentId": 152
  },
  {
    "id": 1475,
    "name": "建宁县",
    "type": "区",
    "parentId": 152
  },
  {
    "id": 1476,
    "name": "永安市",
    "type": "区",
    "parentId": 152
  },
  {
    "id": 1477,
    "name": "鲤城区",
    "type": "区",
    "parentId": 153
  },
  {
    "id": 1478,
    "name": "丰泽区",
    "type": "区",
    "parentId": 153
  },
  {
    "id": 1479,
    "name": "洛江区",
    "type": "区",
    "parentId": 153
  },
  {
    "id": 1480,
    "name": "泉港区",
    "type": "区",
    "parentId": 153
  },
  {
    "id": 1481,
    "name": "惠安县",
    "type": "区",
    "parentId": 153
  },
  {
    "id": 1482,
    "name": "安溪县",
    "type": "区",
    "parentId": 153
  },
  {
    "id": 1483,
    "name": "永春县",
    "type": "区",
    "parentId": 153
  },
  {
    "id": 1484,
    "name": "德化县",
    "type": "区",
    "parentId": 153
  },
  {
    "id": 1485,
    "name": "金门县",
    "type": "区",
    "parentId": 153
  },
  {
    "id": 1486,
    "name": "石狮市",
    "type": "区",
    "parentId": 153
  },
  {
    "id": 1487,
    "name": "晋江市",
    "type": "区",
    "parentId": 153
  },
  {
    "id": 1488,
    "name": "南安市",
    "type": "区",
    "parentId": 153
  },
  {
    "id": 1489,
    "name": "芗城区",
    "type": "区",
    "parentId": 154
  },
  {
    "id": 1490,
    "name": "龙文区",
    "type": "区",
    "parentId": 154
  },
  {
    "id": 1491,
    "name": "云霄县",
    "type": "区",
    "parentId": 154
  },
  {
    "id": 1492,
    "name": "漳浦县",
    "type": "区",
    "parentId": 154
  },
  {
    "id": 1493,
    "name": "诏安县",
    "type": "区",
    "parentId": 154
  },
  {
    "id": 1494,
    "name": "长泰县",
    "type": "区",
    "parentId": 154
  },
  {
    "id": 1495,
    "name": "东山县",
    "type": "区",
    "parentId": 154
  },
  {
    "id": 1496,
    "name": "南靖县",
    "type": "区",
    "parentId": 154
  },
  {
    "id": 1497,
    "name": "平和县",
    "type": "区",
    "parentId": 154
  },
  {
    "id": 1498,
    "name": "华安县",
    "type": "区",
    "parentId": 154
  },
  {
    "id": 1499,
    "name": "龙海市",
    "type": "区",
    "parentId": 154
  },
  {
    "id": 1500,
    "name": "延平区",
    "type": "区",
    "parentId": 155
  },
  {
    "id": 1501,
    "name": "建阳区",
    "type": "区",
    "parentId": 155
  },
  {
    "id": 1502,
    "name": "顺昌县",
    "type": "区",
    "parentId": 155
  },
  {
    "id": 1503,
    "name": "浦城县",
    "type": "区",
    "parentId": 155
  },
  {
    "id": 1504,
    "name": "光泽县",
    "type": "区",
    "parentId": 155
  },
  {
    "id": 1505,
    "name": "松溪县",
    "type": "区",
    "parentId": 155
  },
  {
    "id": 1506,
    "name": "政和县",
    "type": "区",
    "parentId": 155
  },
  {
    "id": 1507,
    "name": "邵武市",
    "type": "区",
    "parentId": 155
  },
  {
    "id": 1508,
    "name": "武夷山市",
    "type": "区",
    "parentId": 155
  },
  {
    "id": 1509,
    "name": "建瓯市",
    "type": "区",
    "parentId": 155
  },
  {
    "id": 1510,
    "name": "新罗区",
    "type": "区",
    "parentId": 156
  },
  {
    "id": 1511,
    "name": "永定区",
    "type": "区",
    "parentId": 156
  },
  {
    "id": 1512,
    "name": "长汀县",
    "type": "区",
    "parentId": 156
  },
  {
    "id": 1513,
    "name": "上杭县",
    "type": "区",
    "parentId": 156
  },
  {
    "id": 1514,
    "name": "武平县",
    "type": "区",
    "parentId": 156
  },
  {
    "id": 1515,
    "name": "连城县",
    "type": "区",
    "parentId": 156
  },
  {
    "id": 1516,
    "name": "漳平市",
    "type": "区",
    "parentId": 156
  },
  {
    "id": 1517,
    "name": "蕉城区",
    "type": "区",
    "parentId": 157
  },
  {
    "id": 1518,
    "name": "霞浦县",
    "type": "区",
    "parentId": 157
  },
  {
    "id": 1519,
    "name": "古田县",
    "type": "区",
    "parentId": 157
  },
  {
    "id": 1520,
    "name": "屏南县",
    "type": "区",
    "parentId": 157
  },
  {
    "id": 1521,
    "name": "寿宁县",
    "type": "区",
    "parentId": 157
  },
  {
    "id": 1522,
    "name": "周宁县",
    "type": "区",
    "parentId": 157
  },
  {
    "id": 1523,
    "name": "柘荣县",
    "type": "区",
    "parentId": 157
  },
  {
    "id": 1524,
    "name": "福安市",
    "type": "区",
    "parentId": 157
  },
  {
    "id": 1525,
    "name": "福鼎市",
    "type": "区",
    "parentId": 157
  },
  {
    "id": 1526,
    "name": "东湖区",
    "type": "区",
    "parentId": 158
  },
  {
    "id": 1527,
    "name": "西湖区",
    "type": "区",
    "parentId": 158
  },
  {
    "id": 1528,
    "name": "青云谱区",
    "type": "区",
    "parentId": 158
  },
  {
    "id": 1529,
    "name": "湾里区",
    "type": "区",
    "parentId": 158
  },
  {
    "id": 1530,
    "name": "青山湖区",
    "type": "区",
    "parentId": 158
  },
  {
    "id": 1531,
    "name": "新建区",
    "type": "区",
    "parentId": 158
  },
  {
    "id": 1532,
    "name": "南昌县",
    "type": "区",
    "parentId": 158
  },
  {
    "id": 1533,
    "name": "安义县",
    "type": "区",
    "parentId": 158
  },
  {
    "id": 1534,
    "name": "进贤县",
    "type": "区",
    "parentId": 158
  },
  {
    "id": 1535,
    "name": "经济技术开发区",
    "type": "区",
    "parentId": 158
  },
  {
    "id": 1536,
    "name": "高新区",
    "type": "区",
    "parentId": 158
  },
  {
    "id": 1537,
    "name": "昌江区",
    "type": "区",
    "parentId": 159
  },
  {
    "id": 1538,
    "name": "珠山区",
    "type": "区",
    "parentId": 159
  },
  {
    "id": 1539,
    "name": "浮梁县",
    "type": "区",
    "parentId": 159
  },
  {
    "id": 1540,
    "name": "乐平市",
    "type": "区",
    "parentId": 159
  },
  {
    "id": 1541,
    "name": "安源区",
    "type": "区",
    "parentId": 160
  },
  {
    "id": 1542,
    "name": "湘东区",
    "type": "区",
    "parentId": 160
  },
  {
    "id": 1543,
    "name": "莲花县",
    "type": "区",
    "parentId": 160
  },
  {
    "id": 1544,
    "name": "上栗县",
    "type": "区",
    "parentId": 160
  },
  {
    "id": 1545,
    "name": "芦溪县",
    "type": "区",
    "parentId": 160
  },
  {
    "id": 1546,
    "name": "濂溪区",
    "type": "区",
    "parentId": 161
  },
  {
    "id": 1547,
    "name": "浔阳区",
    "type": "区",
    "parentId": 161
  },
  {
    "id": 1548,
    "name": "柴桑区",
    "type": "区",
    "parentId": 161
  },
  {
    "id": 1549,
    "name": "武宁县",
    "type": "区",
    "parentId": 161
  },
  {
    "id": 1550,
    "name": "修水县",
    "type": "区",
    "parentId": 161
  },
  {
    "id": 1551,
    "name": "永修县",
    "type": "区",
    "parentId": 161
  },
  {
    "id": 1552,
    "name": "德安县",
    "type": "区",
    "parentId": 161
  },
  {
    "id": 1553,
    "name": "都昌县",
    "type": "区",
    "parentId": 161
  },
  {
    "id": 1554,
    "name": "湖口县",
    "type": "区",
    "parentId": 161
  },
  {
    "id": 1555,
    "name": "彭泽县",
    "type": "区",
    "parentId": 161
  },
  {
    "id": 1556,
    "name": "瑞昌市",
    "type": "区",
    "parentId": 161
  },
  {
    "id": 1557,
    "name": "共青城市",
    "type": "区",
    "parentId": 161
  },
  {
    "id": 1558,
    "name": "庐山市",
    "type": "区",
    "parentId": 161
  },
  {
    "id": 1559,
    "name": "经济技术开发区",
    "type": "区",
    "parentId": 161
  },
  {
    "id": 1560,
    "name": "渝水区",
    "type": "区",
    "parentId": 162
  },
  {
    "id": 1561,
    "name": "分宜县",
    "type": "区",
    "parentId": 162
  },
  {
    "id": 1562,
    "name": "月湖区",
    "type": "区",
    "parentId": 163
  },
  {
    "id": 1563,
    "name": "余江县",
    "type": "区",
    "parentId": 163
  },
  {
    "id": 1564,
    "name": "贵溪市",
    "type": "区",
    "parentId": 163
  },
  {
    "id": 1565,
    "name": "章贡区",
    "type": "区",
    "parentId": 164
  },
  {
    "id": 1566,
    "name": "南康区",
    "type": "区",
    "parentId": 164
  },
  {
    "id": 1567,
    "name": "赣县区",
    "type": "区",
    "parentId": 164
  },
  {
    "id": 1568,
    "name": "信丰县",
    "type": "区",
    "parentId": 164
  },
  {
    "id": 1569,
    "name": "大余县",
    "type": "区",
    "parentId": 164
  },
  {
    "id": 1570,
    "name": "上犹县",
    "type": "区",
    "parentId": 164
  },
  {
    "id": 1571,
    "name": "崇义县",
    "type": "区",
    "parentId": 164
  },
  {
    "id": 1572,
    "name": "安远县",
    "type": "区",
    "parentId": 164
  },
  {
    "id": 1573,
    "name": "龙南县",
    "type": "区",
    "parentId": 164
  },
  {
    "id": 1574,
    "name": "定南县",
    "type": "区",
    "parentId": 164
  },
  {
    "id": 1575,
    "name": "全南县",
    "type": "区",
    "parentId": 164
  },
  {
    "id": 1576,
    "name": "宁都县",
    "type": "区",
    "parentId": 164
  },
  {
    "id": 1577,
    "name": "于都县",
    "type": "区",
    "parentId": 164
  },
  {
    "id": 1578,
    "name": "兴国县",
    "type": "区",
    "parentId": 164
  },
  {
    "id": 1579,
    "name": "会昌县",
    "type": "区",
    "parentId": 164
  },
  {
    "id": 1580,
    "name": "寻乌县",
    "type": "区",
    "parentId": 164
  },
  {
    "id": 1581,
    "name": "石城县",
    "type": "区",
    "parentId": 164
  },
  {
    "id": 1582,
    "name": "瑞金市",
    "type": "区",
    "parentId": 164
  },
  {
    "id": 1583,
    "name": "吉州区",
    "type": "区",
    "parentId": 165
  },
  {
    "id": 1584,
    "name": "青原区",
    "type": "区",
    "parentId": 165
  },
  {
    "id": 1585,
    "name": "吉安县",
    "type": "区",
    "parentId": 165
  },
  {
    "id": 1586,
    "name": "吉水县",
    "type": "区",
    "parentId": 165
  },
  {
    "id": 1587,
    "name": "峡江县",
    "type": "区",
    "parentId": 165
  },
  {
    "id": 1588,
    "name": "新干县",
    "type": "区",
    "parentId": 165
  },
  {
    "id": 1589,
    "name": "永丰县",
    "type": "区",
    "parentId": 165
  },
  {
    "id": 1590,
    "name": "泰和县",
    "type": "区",
    "parentId": 165
  },
  {
    "id": 1591,
    "name": "遂川县",
    "type": "区",
    "parentId": 165
  },
  {
    "id": 1592,
    "name": "万安县",
    "type": "区",
    "parentId": 165
  },
  {
    "id": 1593,
    "name": "安福县",
    "type": "区",
    "parentId": 165
  },
  {
    "id": 1594,
    "name": "永新县",
    "type": "区",
    "parentId": 165
  },
  {
    "id": 1595,
    "name": "井冈山市",
    "type": "区",
    "parentId": 165
  },
  {
    "id": 1596,
    "name": "袁州区",
    "type": "区",
    "parentId": 166
  },
  {
    "id": 1597,
    "name": "奉新县",
    "type": "区",
    "parentId": 166
  },
  {
    "id": 1598,
    "name": "万载县",
    "type": "区",
    "parentId": 166
  },
  {
    "id": 1599,
    "name": "上高县",
    "type": "区",
    "parentId": 166
  },
  {
    "id": 1600,
    "name": "宜丰县",
    "type": "区",
    "parentId": 166
  },
  {
    "id": 1601,
    "name": "靖安县",
    "type": "区",
    "parentId": 166
  },
  {
    "id": 1602,
    "name": "铜鼓县",
    "type": "区",
    "parentId": 166
  },
  {
    "id": 1603,
    "name": "丰城市",
    "type": "区",
    "parentId": 166
  },
  {
    "id": 1604,
    "name": "樟树市",
    "type": "区",
    "parentId": 166
  },
  {
    "id": 1605,
    "name": "高安市",
    "type": "区",
    "parentId": 166
  },
  {
    "id": 1606,
    "name": "临川区",
    "type": "区",
    "parentId": 167
  },
  {
    "id": 1607,
    "name": "东乡区",
    "type": "区",
    "parentId": 167
  },
  {
    "id": 1608,
    "name": "南城县",
    "type": "区",
    "parentId": 167
  },
  {
    "id": 1609,
    "name": "黎川县",
    "type": "区",
    "parentId": 167
  },
  {
    "id": 1610,
    "name": "南丰县",
    "type": "区",
    "parentId": 167
  },
  {
    "id": 1611,
    "name": "崇仁县",
    "type": "区",
    "parentId": 167
  },
  {
    "id": 1612,
    "name": "乐安县",
    "type": "区",
    "parentId": 167
  },
  {
    "id": 1613,
    "name": "宜黄县",
    "type": "区",
    "parentId": 167
  },
  {
    "id": 1614,
    "name": "金溪县",
    "type": "区",
    "parentId": 167
  },
  {
    "id": 1615,
    "name": "资溪县",
    "type": "区",
    "parentId": 167
  },
  {
    "id": 1616,
    "name": "广昌县",
    "type": "区",
    "parentId": 167
  },
  {
    "id": 1617,
    "name": "信州区",
    "type": "区",
    "parentId": 168
  },
  {
    "id": 1618,
    "name": "广丰区",
    "type": "区",
    "parentId": 168
  },
  {
    "id": 1619,
    "name": "上饶县",
    "type": "区",
    "parentId": 168
  },
  {
    "id": 1620,
    "name": "玉山县",
    "type": "区",
    "parentId": 168
  },
  {
    "id": 1621,
    "name": "铅山县",
    "type": "区",
    "parentId": 168
  },
  {
    "id": 1622,
    "name": "横峰县",
    "type": "区",
    "parentId": 168
  },
  {
    "id": 1623,
    "name": "弋阳县",
    "type": "区",
    "parentId": 168
  },
  {
    "id": 1624,
    "name": "余干县",
    "type": "区",
    "parentId": 168
  },
  {
    "id": 1625,
    "name": "鄱阳县",
    "type": "区",
    "parentId": 168
  },
  {
    "id": 1626,
    "name": "万年县",
    "type": "区",
    "parentId": 168
  },
  {
    "id": 1627,
    "name": "婺源县",
    "type": "区",
    "parentId": 168
  },
  {
    "id": 1628,
    "name": "德兴市",
    "type": "区",
    "parentId": 168
  },
  {
    "id": 1629,
    "name": "历下区",
    "type": "区",
    "parentId": 169
  },
  {
    "id": 1630,
    "name": "市中区",
    "type": "区",
    "parentId": 169
  },
  {
    "id": 1631,
    "name": "槐荫区",
    "type": "区",
    "parentId": 169
  },
  {
    "id": 1632,
    "name": "天桥区",
    "type": "区",
    "parentId": 169
  },
  {
    "id": 1633,
    "name": "历城区",
    "type": "区",
    "parentId": 169
  },
  {
    "id": 1634,
    "name": "长清区",
    "type": "区",
    "parentId": 169
  },
  {
    "id": 1635,
    "name": "章丘区",
    "type": "区",
    "parentId": 169
  },
  {
    "id": 1636,
    "name": "平阴县",
    "type": "区",
    "parentId": 169
  },
  {
    "id": 1637,
    "name": "济阳县",
    "type": "区",
    "parentId": 169
  },
  {
    "id": 1638,
    "name": "商河县",
    "type": "区",
    "parentId": 169
  },
  {
    "id": 1639,
    "name": "高新区",
    "type": "区",
    "parentId": 169
  },
  {
    "id": 1640,
    "name": "市南区",
    "type": "区",
    "parentId": 170
  },
  {
    "id": 1641,
    "name": "市北区",
    "type": "区",
    "parentId": 170
  },
  {
    "id": 1642,
    "name": "黄岛区",
    "type": "区",
    "parentId": 170
  },
  {
    "id": 1643,
    "name": "崂山区",
    "type": "区",
    "parentId": 170
  },
  {
    "id": 1644,
    "name": "李沧区",
    "type": "区",
    "parentId": 170
  },
  {
    "id": 1645,
    "name": "城阳区",
    "type": "区",
    "parentId": 170
  },
  {
    "id": 1646,
    "name": "即墨区",
    "type": "区",
    "parentId": 170
  },
  {
    "id": 1647,
    "name": "胶州市",
    "type": "区",
    "parentId": 170
  },
  {
    "id": 1648,
    "name": "平度市",
    "type": "区",
    "parentId": 170
  },
  {
    "id": 1649,
    "name": "莱西市",
    "type": "区",
    "parentId": 170
  },
  {
    "id": 1650,
    "name": "开发区",
    "type": "区",
    "parentId": 170
  },
  {
    "id": 1651,
    "name": "淄川区",
    "type": "区",
    "parentId": 171
  },
  {
    "id": 1652,
    "name": "张店区",
    "type": "区",
    "parentId": 171
  },
  {
    "id": 1653,
    "name": "博山区",
    "type": "区",
    "parentId": 171
  },
  {
    "id": 1654,
    "name": "临淄区",
    "type": "区",
    "parentId": 171
  },
  {
    "id": 1655,
    "name": "周村区",
    "type": "区",
    "parentId": 171
  },
  {
    "id": 1656,
    "name": "桓台县",
    "type": "区",
    "parentId": 171
  },
  {
    "id": 1657,
    "name": "高青县",
    "type": "区",
    "parentId": 171
  },
  {
    "id": 1658,
    "name": "沂源县",
    "type": "区",
    "parentId": 171
  },
  {
    "id": 1659,
    "name": "市中区",
    "type": "区",
    "parentId": 172
  },
  {
    "id": 1660,
    "name": "薛城区",
    "type": "区",
    "parentId": 172
  },
  {
    "id": 1661,
    "name": "峄城区",
    "type": "区",
    "parentId": 172
  },
  {
    "id": 1662,
    "name": "台儿庄区",
    "type": "区",
    "parentId": 172
  },
  {
    "id": 1663,
    "name": "山亭区",
    "type": "区",
    "parentId": 172
  },
  {
    "id": 1664,
    "name": "滕州市",
    "type": "区",
    "parentId": 172
  },
  {
    "id": 1665,
    "name": "东营区",
    "type": "区",
    "parentId": 173
  },
  {
    "id": 1666,
    "name": "河口区",
    "type": "区",
    "parentId": 173
  },
  {
    "id": 1667,
    "name": "垦利区",
    "type": "区",
    "parentId": 173
  },
  {
    "id": 1668,
    "name": "利津县",
    "type": "区",
    "parentId": 173
  },
  {
    "id": 1669,
    "name": "广饶县",
    "type": "区",
    "parentId": 173
  },
  {
    "id": 1670,
    "name": "芝罘区",
    "type": "区",
    "parentId": 174
  },
  {
    "id": 1671,
    "name": "福山区",
    "type": "区",
    "parentId": 174
  },
  {
    "id": 1672,
    "name": "牟平区",
    "type": "区",
    "parentId": 174
  },
  {
    "id": 1673,
    "name": "莱山区",
    "type": "区",
    "parentId": 174
  },
  {
    "id": 1674,
    "name": "长岛县",
    "type": "区",
    "parentId": 174
  },
  {
    "id": 1675,
    "name": "龙口市",
    "type": "区",
    "parentId": 174
  },
  {
    "id": 1676,
    "name": "莱阳市",
    "type": "区",
    "parentId": 174
  },
  {
    "id": 1677,
    "name": "莱州市",
    "type": "区",
    "parentId": 174
  },
  {
    "id": 1678,
    "name": "蓬莱市",
    "type": "区",
    "parentId": 174
  },
  {
    "id": 1679,
    "name": "招远市",
    "type": "区",
    "parentId": 174
  },
  {
    "id": 1680,
    "name": "栖霞市",
    "type": "区",
    "parentId": 174
  },
  {
    "id": 1681,
    "name": "海阳市",
    "type": "区",
    "parentId": 174
  },
  {
    "id": 1682,
    "name": "开发区",
    "type": "区",
    "parentId": 174
  },
  {
    "id": 1683,
    "name": "潍城区",
    "type": "区",
    "parentId": 175
  },
  {
    "id": 1684,
    "name": "寒亭区",
    "type": "区",
    "parentId": 175
  },
  {
    "id": 1685,
    "name": "坊子区",
    "type": "区",
    "parentId": 175
  },
  {
    "id": 1686,
    "name": "奎文区",
    "type": "区",
    "parentId": 175
  },
  {
    "id": 1687,
    "name": "临朐县",
    "type": "区",
    "parentId": 175
  },
  {
    "id": 1688,
    "name": "昌乐县",
    "type": "区",
    "parentId": 175
  },
  {
    "id": 1689,
    "name": "青州市",
    "type": "区",
    "parentId": 175
  },
  {
    "id": 1690,
    "name": "诸城市",
    "type": "区",
    "parentId": 175
  },
  {
    "id": 1691,
    "name": "寿光市",
    "type": "区",
    "parentId": 175
  },
  {
    "id": 1692,
    "name": "安丘市",
    "type": "区",
    "parentId": 175
  },
  {
    "id": 1693,
    "name": "高密市",
    "type": "区",
    "parentId": 175
  },
  {
    "id": 1694,
    "name": "昌邑市",
    "type": "区",
    "parentId": 175
  },
  {
    "id": 1695,
    "name": "开发区",
    "type": "区",
    "parentId": 175
  },
  {
    "id": 1696,
    "name": "高新区",
    "type": "区",
    "parentId": 175
  },
  {
    "id": 1697,
    "name": "任城区",
    "type": "区",
    "parentId": 176
  },
  {
    "id": 1698,
    "name": "兖州区",
    "type": "区",
    "parentId": 176
  },
  {
    "id": 1699,
    "name": "微山县",
    "type": "区",
    "parentId": 176
  },
  {
    "id": 1700,
    "name": "鱼台县",
    "type": "区",
    "parentId": 176
  },
  {
    "id": 1701,
    "name": "金乡县",
    "type": "区",
    "parentId": 176
  },
  {
    "id": 1702,
    "name": "嘉祥县",
    "type": "区",
    "parentId": 176
  },
  {
    "id": 1703,
    "name": "汶上县",
    "type": "区",
    "parentId": 176
  },
  {
    "id": 1704,
    "name": "泗水县",
    "type": "区",
    "parentId": 176
  },
  {
    "id": 1705,
    "name": "梁山县",
    "type": "区",
    "parentId": 176
  },
  {
    "id": 1706,
    "name": "曲阜市",
    "type": "区",
    "parentId": 176
  },
  {
    "id": 1707,
    "name": "邹城市",
    "type": "区",
    "parentId": 176
  },
  {
    "id": 1708,
    "name": "高新区",
    "type": "区",
    "parentId": 176
  },
  {
    "id": 1709,
    "name": "泰山区",
    "type": "区",
    "parentId": 177
  },
  {
    "id": 1710,
    "name": "岱岳区",
    "type": "区",
    "parentId": 177
  },
  {
    "id": 1711,
    "name": "宁阳县",
    "type": "区",
    "parentId": 177
  },
  {
    "id": 1712,
    "name": "东平县",
    "type": "区",
    "parentId": 177
  },
  {
    "id": 1713,
    "name": "新泰市",
    "type": "区",
    "parentId": 177
  },
  {
    "id": 1714,
    "name": "肥城市",
    "type": "区",
    "parentId": 177
  },
  {
    "id": 1715,
    "name": "环翠区",
    "type": "区",
    "parentId": 178
  },
  {
    "id": 1716,
    "name": "文登区",
    "type": "区",
    "parentId": 178
  },
  {
    "id": 1717,
    "name": "荣成市",
    "type": "区",
    "parentId": 178
  },
  {
    "id": 1718,
    "name": "乳山市",
    "type": "区",
    "parentId": 178
  },
  {
    "id": 1719,
    "name": "经济技术开发区",
    "type": "区",
    "parentId": 178
  },
  {
    "id": 1720,
    "name": "东港区",
    "type": "区",
    "parentId": 179
  },
  {
    "id": 1721,
    "name": "岚山区",
    "type": "区",
    "parentId": 179
  },
  {
    "id": 1722,
    "name": "五莲县",
    "type": "区",
    "parentId": 179
  },
  {
    "id": 1723,
    "name": "莒县",
    "type": "区",
    "parentId": 179
  },
  {
    "id": 1724,
    "name": "莱城区",
    "type": "区",
    "parentId": 180
  },
  {
    "id": 1725,
    "name": "钢城区",
    "type": "区",
    "parentId": 180
  },
  {
    "id": 1726,
    "name": "兰山区",
    "type": "区",
    "parentId": 181
  },
  {
    "id": 1727,
    "name": "罗庄区",
    "type": "区",
    "parentId": 181
  },
  {
    "id": 1728,
    "name": "河东区",
    "type": "区",
    "parentId": 181
  },
  {
    "id": 1729,
    "name": "沂南县",
    "type": "区",
    "parentId": 181
  },
  {
    "id": 1730,
    "name": "郯城县",
    "type": "区",
    "parentId": 181
  },
  {
    "id": 1731,
    "name": "沂水县",
    "type": "区",
    "parentId": 181
  },
  {
    "id": 1732,
    "name": "兰陵县",
    "type": "区",
    "parentId": 181
  },
  {
    "id": 1733,
    "name": "费县",
    "type": "区",
    "parentId": 181
  },
  {
    "id": 1734,
    "name": "平邑县",
    "type": "区",
    "parentId": 181
  },
  {
    "id": 1735,
    "name": "莒南县",
    "type": "区",
    "parentId": 181
  },
  {
    "id": 1736,
    "name": "蒙阴县",
    "type": "区",
    "parentId": 181
  },
  {
    "id": 1737,
    "name": "临沭县",
    "type": "区",
    "parentId": 181
  },
  {
    "id": 1738,
    "name": "德城区",
    "type": "区",
    "parentId": 182
  },
  {
    "id": 1739,
    "name": "陵城区",
    "type": "区",
    "parentId": 182
  },
  {
    "id": 1740,
    "name": "宁津县",
    "type": "区",
    "parentId": 182
  },
  {
    "id": 1741,
    "name": "庆云县",
    "type": "区",
    "parentId": 182
  },
  {
    "id": 1742,
    "name": "临邑县",
    "type": "区",
    "parentId": 182
  },
  {
    "id": 1743,
    "name": "齐河县",
    "type": "区",
    "parentId": 182
  },
  {
    "id": 1744,
    "name": "平原县",
    "type": "区",
    "parentId": 182
  },
  {
    "id": 1745,
    "name": "夏津县",
    "type": "区",
    "parentId": 182
  },
  {
    "id": 1746,
    "name": "武城县",
    "type": "区",
    "parentId": 182
  },
  {
    "id": 1747,
    "name": "乐陵市",
    "type": "区",
    "parentId": 182
  },
  {
    "id": 1748,
    "name": "禹城市",
    "type": "区",
    "parentId": 182
  },
  {
    "id": 1749,
    "name": "东昌府区",
    "type": "区",
    "parentId": 183
  },
  {
    "id": 1750,
    "name": "阳谷县",
    "type": "区",
    "parentId": 183
  },
  {
    "id": 1751,
    "name": "莘县",
    "type": "区",
    "parentId": 183
  },
  {
    "id": 1752,
    "name": "茌平县",
    "type": "区",
    "parentId": 183
  },
  {
    "id": 1753,
    "name": "东阿县",
    "type": "区",
    "parentId": 183
  },
  {
    "id": 1754,
    "name": "冠县",
    "type": "区",
    "parentId": 183
  },
  {
    "id": 1755,
    "name": "高唐县",
    "type": "区",
    "parentId": 183
  },
  {
    "id": 1756,
    "name": "临清市",
    "type": "区",
    "parentId": 183
  },
  {
    "id": 1757,
    "name": "滨城区",
    "type": "区",
    "parentId": 184
  },
  {
    "id": 1758,
    "name": "沾化区",
    "type": "区",
    "parentId": 184
  },
  {
    "id": 1759,
    "name": "惠民县",
    "type": "区",
    "parentId": 184
  },
  {
    "id": 1760,
    "name": "阳信县",
    "type": "区",
    "parentId": 184
  },
  {
    "id": 1761,
    "name": "无棣县",
    "type": "区",
    "parentId": 184
  },
  {
    "id": 1762,
    "name": "博兴县",
    "type": "区",
    "parentId": 184
  },
  {
    "id": 1763,
    "name": "邹平县",
    "type": "区",
    "parentId": 184
  },
  {
    "id": 1764,
    "name": "牡丹区",
    "type": "区",
    "parentId": 185
  },
  {
    "id": 1765,
    "name": "定陶区",
    "type": "区",
    "parentId": 185
  },
  {
    "id": 1766,
    "name": "曹县",
    "type": "区",
    "parentId": 185
  },
  {
    "id": 1767,
    "name": "单县",
    "type": "区",
    "parentId": 185
  },
  {
    "id": 1768,
    "name": "成武县",
    "type": "区",
    "parentId": 185
  },
  {
    "id": 1769,
    "name": "巨野县",
    "type": "区",
    "parentId": 185
  },
  {
    "id": 1770,
    "name": "郓城县",
    "type": "区",
    "parentId": 185
  },
  {
    "id": 1771,
    "name": "鄄城县",
    "type": "区",
    "parentId": 185
  },
  {
    "id": 1772,
    "name": "东明县",
    "type": "区",
    "parentId": 185
  },
  {
    "id": 1773,
    "name": "中原区",
    "type": "区",
    "parentId": 186
  },
  {
    "id": 1774,
    "name": "二七区",
    "type": "区",
    "parentId": 186
  },
  {
    "id": 1775,
    "name": "管城回族区",
    "type": "区",
    "parentId": 186
  },
  {
    "id": 1776,
    "name": "金水区",
    "type": "区",
    "parentId": 186
  },
  {
    "id": 1777,
    "name": "上街区",
    "type": "区",
    "parentId": 186
  },
  {
    "id": 1778,
    "name": "惠济区",
    "type": "区",
    "parentId": 186
  },
  {
    "id": 1779,
    "name": "中牟县",
    "type": "区",
    "parentId": 186
  },
  {
    "id": 1780,
    "name": "巩义市",
    "type": "区",
    "parentId": 186
  },
  {
    "id": 1781,
    "name": "荥阳市",
    "type": "区",
    "parentId": 186
  },
  {
    "id": 1782,
    "name": "新密市",
    "type": "区",
    "parentId": 186
  },
  {
    "id": 1783,
    "name": "新郑市",
    "type": "区",
    "parentId": 186
  },
  {
    "id": 1784,
    "name": "登封市",
    "type": "区",
    "parentId": 186
  },
  {
    "id": 1785,
    "name": "高新技术开发区",
    "type": "区",
    "parentId": 186
  },
  {
    "id": 1786,
    "name": "经济技术开发区",
    "type": "区",
    "parentId": 186
  },
  {
    "id": 1787,
    "name": "龙亭区",
    "type": "区",
    "parentId": 187
  },
  {
    "id": 1788,
    "name": "顺河回族区",
    "type": "区",
    "parentId": 187
  },
  {
    "id": 1789,
    "name": "鼓楼区",
    "type": "区",
    "parentId": 187
  },
  {
    "id": 1790,
    "name": "禹王台区",
    "type": "区",
    "parentId": 187
  },
  {
    "id": 1791,
    "name": "祥符区",
    "type": "区",
    "parentId": 187
  },
  {
    "id": 1792,
    "name": "杞县",
    "type": "区",
    "parentId": 187
  },
  {
    "id": 1793,
    "name": "通许县",
    "type": "区",
    "parentId": 187
  },
  {
    "id": 1794,
    "name": "尉氏县",
    "type": "区",
    "parentId": 187
  },
  {
    "id": 1795,
    "name": "兰考县",
    "type": "区",
    "parentId": 187
  },
  {
    "id": 1796,
    "name": "老城区",
    "type": "区",
    "parentId": 188
  },
  {
    "id": 1797,
    "name": "西工区",
    "type": "区",
    "parentId": 188
  },
  {
    "id": 1798,
    "name": "瀍河回族区",
    "type": "区",
    "parentId": 188
  },
  {
    "id": 1799,
    "name": "涧西区",
    "type": "区",
    "parentId": 188
  },
  {
    "id": 1800,
    "name": "吉利区",
    "type": "区",
    "parentId": 188
  },
  {
    "id": 1801,
    "name": "洛龙区",
    "type": "区",
    "parentId": 188
  },
  {
    "id": 1802,
    "name": "孟津县",
    "type": "区",
    "parentId": 188
  },
  {
    "id": 1803,
    "name": "新安县",
    "type": "区",
    "parentId": 188
  },
  {
    "id": 1804,
    "name": "栾川县",
    "type": "区",
    "parentId": 188
  },
  {
    "id": 1805,
    "name": "嵩县",
    "type": "区",
    "parentId": 188
  },
  {
    "id": 1806,
    "name": "汝阳县",
    "type": "区",
    "parentId": 188
  },
  {
    "id": 1807,
    "name": "宜阳县",
    "type": "区",
    "parentId": 188
  },
  {
    "id": 1808,
    "name": "洛宁县",
    "type": "区",
    "parentId": 188
  },
  {
    "id": 1809,
    "name": "伊川县",
    "type": "区",
    "parentId": 188
  },
  {
    "id": 1810,
    "name": "偃师市",
    "type": "区",
    "parentId": 188
  },
  {
    "id": 1811,
    "name": "新华区",
    "type": "区",
    "parentId": 189
  },
  {
    "id": 1812,
    "name": "卫东区",
    "type": "区",
    "parentId": 189
  },
  {
    "id": 1813,
    "name": "石龙区",
    "type": "区",
    "parentId": 189
  },
  {
    "id": 1814,
    "name": "湛河区",
    "type": "区",
    "parentId": 189
  },
  {
    "id": 1815,
    "name": "宝丰县",
    "type": "区",
    "parentId": 189
  },
  {
    "id": 1816,
    "name": "叶县",
    "type": "区",
    "parentId": 189
  },
  {
    "id": 1817,
    "name": "鲁山县",
    "type": "区",
    "parentId": 189
  },
  {
    "id": 1818,
    "name": "郏县",
    "type": "区",
    "parentId": 189
  },
  {
    "id": 1819,
    "name": "舞钢市",
    "type": "区",
    "parentId": 189
  },
  {
    "id": 1820,
    "name": "汝州市",
    "type": "区",
    "parentId": 189
  },
  {
    "id": 1821,
    "name": "文峰区",
    "type": "区",
    "parentId": 190
  },
  {
    "id": 1822,
    "name": "北关区",
    "type": "区",
    "parentId": 190
  },
  {
    "id": 1823,
    "name": "殷都区",
    "type": "区",
    "parentId": 190
  },
  {
    "id": 1824,
    "name": "龙安区",
    "type": "区",
    "parentId": 190
  },
  {
    "id": 1825,
    "name": "安阳县",
    "type": "区",
    "parentId": 190
  },
  {
    "id": 1826,
    "name": "汤阴县",
    "type": "区",
    "parentId": 190
  },
  {
    "id": 1827,
    "name": "滑县",
    "type": "区",
    "parentId": 190
  },
  {
    "id": 1828,
    "name": "内黄县",
    "type": "区",
    "parentId": 190
  },
  {
    "id": 1829,
    "name": "林州市",
    "type": "区",
    "parentId": 190
  },
  {
    "id": 1830,
    "name": "开发区",
    "type": "区",
    "parentId": 190
  },
  {
    "id": 1831,
    "name": "鹤山区",
    "type": "区",
    "parentId": 191
  },
  {
    "id": 1832,
    "name": "山城区",
    "type": "区",
    "parentId": 191
  },
  {
    "id": 1833,
    "name": "淇滨区",
    "type": "区",
    "parentId": 191
  },
  {
    "id": 1834,
    "name": "浚县",
    "type": "区",
    "parentId": 191
  },
  {
    "id": 1835,
    "name": "淇县",
    "type": "区",
    "parentId": 191
  },
  {
    "id": 1836,
    "name": "红旗区",
    "type": "区",
    "parentId": 192
  },
  {
    "id": 1837,
    "name": "卫滨区",
    "type": "区",
    "parentId": 192
  },
  {
    "id": 1838,
    "name": "凤泉区",
    "type": "区",
    "parentId": 192
  },
  {
    "id": 1839,
    "name": "牧野区",
    "type": "区",
    "parentId": 192
  },
  {
    "id": 1840,
    "name": "新乡县",
    "type": "区",
    "parentId": 192
  },
  {
    "id": 1841,
    "name": "获嘉县",
    "type": "区",
    "parentId": 192
  },
  {
    "id": 1842,
    "name": "原阳县",
    "type": "区",
    "parentId": 192
  },
  {
    "id": 1843,
    "name": "延津县",
    "type": "区",
    "parentId": 192
  },
  {
    "id": 1844,
    "name": "封丘县",
    "type": "区",
    "parentId": 192
  },
  {
    "id": 1845,
    "name": "长垣县",
    "type": "区",
    "parentId": 192
  },
  {
    "id": 1846,
    "name": "卫辉市",
    "type": "区",
    "parentId": 192
  },
  {
    "id": 1847,
    "name": "辉县市",
    "type": "区",
    "parentId": 192
  },
  {
    "id": 1848,
    "name": "解放区",
    "type": "区",
    "parentId": 193
  },
  {
    "id": 1849,
    "name": "中站区",
    "type": "区",
    "parentId": 193
  },
  {
    "id": 1850,
    "name": "马村区",
    "type": "区",
    "parentId": 193
  },
  {
    "id": 1851,
    "name": "山阳区",
    "type": "区",
    "parentId": 193
  },
  {
    "id": 1852,
    "name": "修武县",
    "type": "区",
    "parentId": 193
  },
  {
    "id": 1853,
    "name": "博爱县",
    "type": "区",
    "parentId": 193
  },
  {
    "id": 1854,
    "name": "武陟县",
    "type": "区",
    "parentId": 193
  },
  {
    "id": 1855,
    "name": "温县",
    "type": "区",
    "parentId": 193
  },
  {
    "id": 1856,
    "name": "沁阳市",
    "type": "区",
    "parentId": 193
  },
  {
    "id": 1857,
    "name": "孟州市",
    "type": "区",
    "parentId": 193
  },
  {
    "id": 1858,
    "name": "华龙区",
    "type": "区",
    "parentId": 194
  },
  {
    "id": 1859,
    "name": "清丰县",
    "type": "区",
    "parentId": 194
  },
  {
    "id": 1860,
    "name": "南乐县",
    "type": "区",
    "parentId": 194
  },
  {
    "id": 1861,
    "name": "范县",
    "type": "区",
    "parentId": 194
  },
  {
    "id": 1862,
    "name": "台前县",
    "type": "区",
    "parentId": 194
  },
  {
    "id": 1863,
    "name": "濮阳县",
    "type": "区",
    "parentId": 194
  },
  {
    "id": 1864,
    "name": "魏都区",
    "type": "区",
    "parentId": 195
  },
  {
    "id": 1865,
    "name": "建安区",
    "type": "区",
    "parentId": 195
  },
  {
    "id": 1866,
    "name": "鄢陵县",
    "type": "区",
    "parentId": 195
  },
  {
    "id": 1867,
    "name": "襄城县",
    "type": "区",
    "parentId": 195
  },
  {
    "id": 1868,
    "name": "禹州市",
    "type": "区",
    "parentId": 195
  },
  {
    "id": 1869,
    "name": "长葛市",
    "type": "区",
    "parentId": 195
  },
  {
    "id": 1870,
    "name": "源汇区",
    "type": "区",
    "parentId": 196
  },
  {
    "id": 1871,
    "name": "郾城区",
    "type": "区",
    "parentId": 196
  },
  {
    "id": 1872,
    "name": "召陵区",
    "type": "区",
    "parentId": 196
  },
  {
    "id": 1873,
    "name": "舞阳县",
    "type": "区",
    "parentId": 196
  },
  {
    "id": 1874,
    "name": "临颍县",
    "type": "区",
    "parentId": 196
  },
  {
    "id": 1875,
    "name": "湖滨区",
    "type": "区",
    "parentId": 197
  },
  {
    "id": 1876,
    "name": "陕州区",
    "type": "区",
    "parentId": 197
  },
  {
    "id": 1877,
    "name": "渑池县",
    "type": "区",
    "parentId": 197
  },
  {
    "id": 1878,
    "name": "卢氏县",
    "type": "区",
    "parentId": 197
  },
  {
    "id": 1879,
    "name": "义马市",
    "type": "区",
    "parentId": 197
  },
  {
    "id": 1880,
    "name": "灵宝市",
    "type": "区",
    "parentId": 197
  },
  {
    "id": 1881,
    "name": "宛城区",
    "type": "区",
    "parentId": 198
  },
  {
    "id": 1882,
    "name": "卧龙区",
    "type": "区",
    "parentId": 198
  },
  {
    "id": 1883,
    "name": "南召县",
    "type": "区",
    "parentId": 198
  },
  {
    "id": 1884,
    "name": "方城县",
    "type": "区",
    "parentId": 198
  },
  {
    "id": 1885,
    "name": "西峡县",
    "type": "区",
    "parentId": 198
  },
  {
    "id": 1886,
    "name": "镇平县",
    "type": "区",
    "parentId": 198
  },
  {
    "id": 1887,
    "name": "内乡县",
    "type": "区",
    "parentId": 198
  },
  {
    "id": 1888,
    "name": "淅川县",
    "type": "区",
    "parentId": 198
  },
  {
    "id": 1889,
    "name": "社旗县",
    "type": "区",
    "parentId": 198
  },
  {
    "id": 1890,
    "name": "唐河县",
    "type": "区",
    "parentId": 198
  },
  {
    "id": 1891,
    "name": "新野县",
    "type": "区",
    "parentId": 198
  },
  {
    "id": 1892,
    "name": "桐柏县",
    "type": "区",
    "parentId": 198
  },
  {
    "id": 1893,
    "name": "邓州市",
    "type": "区",
    "parentId": 198
  },
  {
    "id": 1894,
    "name": "梁园区",
    "type": "区",
    "parentId": 199
  },
  {
    "id": 1895,
    "name": "睢阳区",
    "type": "区",
    "parentId": 199
  },
  {
    "id": 1896,
    "name": "民权县",
    "type": "区",
    "parentId": 199
  },
  {
    "id": 1897,
    "name": "睢县",
    "type": "区",
    "parentId": 199
  },
  {
    "id": 1898,
    "name": "宁陵县",
    "type": "区",
    "parentId": 199
  },
  {
    "id": 1899,
    "name": "柘城县",
    "type": "区",
    "parentId": 199
  },
  {
    "id": 1900,
    "name": "虞城县",
    "type": "区",
    "parentId": 199
  },
  {
    "id": 1901,
    "name": "夏邑县",
    "type": "区",
    "parentId": 199
  },
  {
    "id": 1902,
    "name": "永城市",
    "type": "区",
    "parentId": 199
  },
  {
    "id": 1903,
    "name": "浉河区",
    "type": "区",
    "parentId": 200
  },
  {
    "id": 1904,
    "name": "平桥区",
    "type": "区",
    "parentId": 200
  },
  {
    "id": 1905,
    "name": "罗山县",
    "type": "区",
    "parentId": 200
  },
  {
    "id": 1906,
    "name": "光山县",
    "type": "区",
    "parentId": 200
  },
  {
    "id": 1907,
    "name": "新县",
    "type": "区",
    "parentId": 200
  },
  {
    "id": 1908,
    "name": "商城县",
    "type": "区",
    "parentId": 200
  },
  {
    "id": 1909,
    "name": "固始县",
    "type": "区",
    "parentId": 200
  },
  {
    "id": 1910,
    "name": "潢川县",
    "type": "区",
    "parentId": 200
  },
  {
    "id": 1911,
    "name": "淮滨县",
    "type": "区",
    "parentId": 200
  },
  {
    "id": 1912,
    "name": "息县",
    "type": "区",
    "parentId": 200
  },
  {
    "id": 1913,
    "name": "川汇区",
    "type": "区",
    "parentId": 201
  },
  {
    "id": 1914,
    "name": "扶沟县",
    "type": "区",
    "parentId": 201
  },
  {
    "id": 1915,
    "name": "西华县",
    "type": "区",
    "parentId": 201
  },
  {
    "id": 1916,
    "name": "商水县",
    "type": "区",
    "parentId": 201
  },
  {
    "id": 1917,
    "name": "沈丘县",
    "type": "区",
    "parentId": 201
  },
  {
    "id": 1918,
    "name": "郸城县",
    "type": "区",
    "parentId": 201
  },
  {
    "id": 1919,
    "name": "淮阳县",
    "type": "区",
    "parentId": 201
  },
  {
    "id": 1920,
    "name": "太康县",
    "type": "区",
    "parentId": 201
  },
  {
    "id": 1921,
    "name": "鹿邑县",
    "type": "区",
    "parentId": 201
  },
  {
    "id": 1922,
    "name": "项城市",
    "type": "区",
    "parentId": 201
  },
  {
    "id": 1923,
    "name": "经济开发区",
    "type": "区",
    "parentId": 201
  },
  {
    "id": 1924,
    "name": "驿城区",
    "type": "区",
    "parentId": 202
  },
  {
    "id": 1925,
    "name": "西平县",
    "type": "区",
    "parentId": 202
  },
  {
    "id": 1926,
    "name": "上蔡县",
    "type": "区",
    "parentId": 202
  },
  {
    "id": 1927,
    "name": "平舆县",
    "type": "区",
    "parentId": 202
  },
  {
    "id": 1928,
    "name": "正阳县",
    "type": "区",
    "parentId": 202
  },
  {
    "id": 1929,
    "name": "确山县",
    "type": "区",
    "parentId": 202
  },
  {
    "id": 1930,
    "name": "泌阳县",
    "type": "区",
    "parentId": 202
  },
  {
    "id": 1931,
    "name": "汝南县",
    "type": "区",
    "parentId": 202
  },
  {
    "id": 1932,
    "name": "遂平县",
    "type": "区",
    "parentId": 202
  },
  {
    "id": 1933,
    "name": "新蔡县",
    "type": "区",
    "parentId": 202
  },
  {
    "id": 1934,
    "name": "济源市",
    "type": "区",
    "parentId": 203
  },
  {
    "id": 1935,
    "name": "江岸区",
    "type": "区",
    "parentId": 204
  },
  {
    "id": 1936,
    "name": "江汉区",
    "type": "区",
    "parentId": 204
  },
  {
    "id": 1937,
    "name": "硚口区",
    "type": "区",
    "parentId": 204
  },
  {
    "id": 1938,
    "name": "汉阳区",
    "type": "区",
    "parentId": 204
  },
  {
    "id": 1939,
    "name": "武昌区",
    "type": "区",
    "parentId": 204
  },
  {
    "id": 1940,
    "name": "青山区",
    "type": "区",
    "parentId": 204
  },
  {
    "id": 1941,
    "name": "洪山区",
    "type": "区",
    "parentId": 204
  },
  {
    "id": 1942,
    "name": "东西湖区",
    "type": "区",
    "parentId": 204
  },
  {
    "id": 1943,
    "name": "汉南区",
    "type": "区",
    "parentId": 204
  },
  {
    "id": 1944,
    "name": "蔡甸区",
    "type": "区",
    "parentId": 204
  },
  {
    "id": 1945,
    "name": "江夏区",
    "type": "区",
    "parentId": 204
  },
  {
    "id": 1946,
    "name": "黄陂区",
    "type": "区",
    "parentId": 204
  },
  {
    "id": 1947,
    "name": "新洲区",
    "type": "区",
    "parentId": 204
  },
  {
    "id": 1948,
    "name": "黄石港区",
    "type": "区",
    "parentId": 205
  },
  {
    "id": 1949,
    "name": "西塞山区",
    "type": "区",
    "parentId": 205
  },
  {
    "id": 1950,
    "name": "下陆区",
    "type": "区",
    "parentId": 205
  },
  {
    "id": 1951,
    "name": "铁山区",
    "type": "区",
    "parentId": 205
  },
  {
    "id": 1952,
    "name": "阳新县",
    "type": "区",
    "parentId": 205
  },
  {
    "id": 1953,
    "name": "大冶市",
    "type": "区",
    "parentId": 205
  },
  {
    "id": 1954,
    "name": "茅箭区",
    "type": "区",
    "parentId": 206
  },
  {
    "id": 1955,
    "name": "张湾区",
    "type": "区",
    "parentId": 206
  },
  {
    "id": 1956,
    "name": "郧阳区",
    "type": "区",
    "parentId": 206
  },
  {
    "id": 1957,
    "name": "郧西县",
    "type": "区",
    "parentId": 206
  },
  {
    "id": 1958,
    "name": "竹山县",
    "type": "区",
    "parentId": 206
  },
  {
    "id": 1959,
    "name": "竹溪县",
    "type": "区",
    "parentId": 206
  },
  {
    "id": 1960,
    "name": "房县",
    "type": "区",
    "parentId": 206
  },
  {
    "id": 1961,
    "name": "丹江口市",
    "type": "区",
    "parentId": 206
  },
  {
    "id": 1962,
    "name": "西陵区",
    "type": "区",
    "parentId": 207
  },
  {
    "id": 1963,
    "name": "伍家岗区",
    "type": "区",
    "parentId": 207
  },
  {
    "id": 1964,
    "name": "点军区",
    "type": "区",
    "parentId": 207
  },
  {
    "id": 1965,
    "name": "猇亭区",
    "type": "区",
    "parentId": 207
  },
  {
    "id": 1966,
    "name": "夷陵区",
    "type": "区",
    "parentId": 207
  },
  {
    "id": 1967,
    "name": "远安县",
    "type": "区",
    "parentId": 207
  },
  {
    "id": 1968,
    "name": "兴山县",
    "type": "区",
    "parentId": 207
  },
  {
    "id": 1969,
    "name": "秭归县",
    "type": "区",
    "parentId": 207
  },
  {
    "id": 1970,
    "name": "长阳土家族自治县",
    "type": "区",
    "parentId": 207
  },
  {
    "id": 1971,
    "name": "五峰土家族自治县",
    "type": "区",
    "parentId": 207
  },
  {
    "id": 1972,
    "name": "宜都市",
    "type": "区",
    "parentId": 207
  },
  {
    "id": 1973,
    "name": "当阳市",
    "type": "区",
    "parentId": 207
  },
  {
    "id": 1974,
    "name": "枝江市",
    "type": "区",
    "parentId": 207
  },
  {
    "id": 1975,
    "name": "经济开发区",
    "type": "区",
    "parentId": 207
  },
  {
    "id": 1976,
    "name": "襄城区",
    "type": "区",
    "parentId": 208
  },
  {
    "id": 1977,
    "name": "樊城区",
    "type": "区",
    "parentId": 208
  },
  {
    "id": 1978,
    "name": "襄州区",
    "type": "区",
    "parentId": 208
  },
  {
    "id": 1979,
    "name": "南漳县",
    "type": "区",
    "parentId": 208
  },
  {
    "id": 1980,
    "name": "谷城县",
    "type": "区",
    "parentId": 208
  },
  {
    "id": 1981,
    "name": "保康县",
    "type": "区",
    "parentId": 208
  },
  {
    "id": 1982,
    "name": "老河口市",
    "type": "区",
    "parentId": 208
  },
  {
    "id": 1983,
    "name": "枣阳市",
    "type": "区",
    "parentId": 208
  },
  {
    "id": 1984,
    "name": "宜城市",
    "type": "区",
    "parentId": 208
  },
  {
    "id": 1985,
    "name": "梁子湖区",
    "type": "区",
    "parentId": 209
  },
  {
    "id": 1986,
    "name": "华容区",
    "type": "区",
    "parentId": 209
  },
  {
    "id": 1987,
    "name": "鄂城区",
    "type": "区",
    "parentId": 209
  },
  {
    "id": 1988,
    "name": "东宝区",
    "type": "区",
    "parentId": 210
  },
  {
    "id": 1989,
    "name": "掇刀区",
    "type": "区",
    "parentId": 210
  },
  {
    "id": 1990,
    "name": "京山县",
    "type": "区",
    "parentId": 210
  },
  {
    "id": 1991,
    "name": "沙洋县",
    "type": "区",
    "parentId": 210
  },
  {
    "id": 1992,
    "name": "钟祥市",
    "type": "区",
    "parentId": 210
  },
  {
    "id": 1993,
    "name": "孝南区",
    "type": "区",
    "parentId": 211
  },
  {
    "id": 1994,
    "name": "孝昌县",
    "type": "区",
    "parentId": 211
  },
  {
    "id": 1995,
    "name": "大悟县",
    "type": "区",
    "parentId": 211
  },
  {
    "id": 1996,
    "name": "云梦县",
    "type": "区",
    "parentId": 211
  },
  {
    "id": 1997,
    "name": "应城市",
    "type": "区",
    "parentId": 211
  },
  {
    "id": 1998,
    "name": "安陆市",
    "type": "区",
    "parentId": 211
  },
  {
    "id": 1999,
    "name": "汉川市",
    "type": "区",
    "parentId": 211
  },
  {
    "id": 2000,
    "name": "沙市区",
    "type": "区",
    "parentId": 212
  },
  {
    "id": 2001,
    "name": "荆州区",
    "type": "区",
    "parentId": 212
  },
  {
    "id": 2002,
    "name": "公安县",
    "type": "区",
    "parentId": 212
  },
  {
    "id": 2003,
    "name": "监利县",
    "type": "区",
    "parentId": 212
  },
  {
    "id": 2004,
    "name": "江陵县",
    "type": "区",
    "parentId": 212
  },
  {
    "id": 2005,
    "name": "石首市",
    "type": "区",
    "parentId": 212
  },
  {
    "id": 2006,
    "name": "洪湖市",
    "type": "区",
    "parentId": 212
  },
  {
    "id": 2007,
    "name": "松滋市",
    "type": "区",
    "parentId": 212
  },
  {
    "id": 2008,
    "name": "黄州区",
    "type": "区",
    "parentId": 213
  },
  {
    "id": 2009,
    "name": "团风县",
    "type": "区",
    "parentId": 213
  },
  {
    "id": 2010,
    "name": "红安县",
    "type": "区",
    "parentId": 213
  },
  {
    "id": 2011,
    "name": "罗田县",
    "type": "区",
    "parentId": 213
  },
  {
    "id": 2012,
    "name": "英山县",
    "type": "区",
    "parentId": 213
  },
  {
    "id": 2013,
    "name": "浠水县",
    "type": "区",
    "parentId": 213
  },
  {
    "id": 2014,
    "name": "蕲春县",
    "type": "区",
    "parentId": 213
  },
  {
    "id": 2015,
    "name": "黄梅县",
    "type": "区",
    "parentId": 213
  },
  {
    "id": 2016,
    "name": "麻城市",
    "type": "区",
    "parentId": 213
  },
  {
    "id": 2017,
    "name": "武穴市",
    "type": "区",
    "parentId": 213
  },
  {
    "id": 2018,
    "name": "咸安区",
    "type": "区",
    "parentId": 214
  },
  {
    "id": 2019,
    "name": "嘉鱼县",
    "type": "区",
    "parentId": 214
  },
  {
    "id": 2020,
    "name": "通城县",
    "type": "区",
    "parentId": 214
  },
  {
    "id": 2021,
    "name": "崇阳县",
    "type": "区",
    "parentId": 214
  },
  {
    "id": 2022,
    "name": "通山县",
    "type": "区",
    "parentId": 214
  },
  {
    "id": 2023,
    "name": "赤壁市",
    "type": "区",
    "parentId": 214
  },
  {
    "id": 2024,
    "name": "曾都区",
    "type": "区",
    "parentId": 215
  },
  {
    "id": 2025,
    "name": "随县",
    "type": "区",
    "parentId": 215
  },
  {
    "id": 2026,
    "name": "广水市",
    "type": "区",
    "parentId": 215
  },
  {
    "id": 2027,
    "name": "恩施市",
    "type": "区",
    "parentId": 216
  },
  {
    "id": 2028,
    "name": "利川市",
    "type": "区",
    "parentId": 216
  },
  {
    "id": 2029,
    "name": "建始县",
    "type": "区",
    "parentId": 216
  },
  {
    "id": 2030,
    "name": "巴东县",
    "type": "区",
    "parentId": 216
  },
  {
    "id": 2031,
    "name": "宣恩县",
    "type": "区",
    "parentId": 216
  },
  {
    "id": 2032,
    "name": "咸丰县",
    "type": "区",
    "parentId": 216
  },
  {
    "id": 2033,
    "name": "来凤县",
    "type": "区",
    "parentId": 216
  },
  {
    "id": 2034,
    "name": "鹤峰县",
    "type": "区",
    "parentId": 216
  },
  {
    "id": 2035,
    "name": "仙桃市",
    "type": "区",
    "parentId": 217
  },
  {
    "id": 2036,
    "name": "潜江市",
    "type": "区",
    "parentId": 217
  },
  {
    "id": 2037,
    "name": "天门市",
    "type": "区",
    "parentId": 217
  },
  {
    "id": 2038,
    "name": "神农架林区",
    "type": "区",
    "parentId": 217
  },
  {
    "id": 2039,
    "name": "芙蓉区",
    "type": "区",
    "parentId": 218
  },
  {
    "id": 2040,
    "name": "天心区",
    "type": "区",
    "parentId": 218
  },
  {
    "id": 2041,
    "name": "岳麓区",
    "type": "区",
    "parentId": 218
  },
  {
    "id": 2042,
    "name": "开福区",
    "type": "区",
    "parentId": 218
  },
  {
    "id": 2043,
    "name": "雨花区",
    "type": "区",
    "parentId": 218
  },
  {
    "id": 2044,
    "name": "望城区",
    "type": "区",
    "parentId": 218
  },
  {
    "id": 2045,
    "name": "长沙县",
    "type": "区",
    "parentId": 218
  },
  {
    "id": 2046,
    "name": "浏阳市",
    "type": "区",
    "parentId": 218
  },
  {
    "id": 2047,
    "name": "宁乡市",
    "type": "区",
    "parentId": 218
  },
  {
    "id": 2048,
    "name": "荷塘区",
    "type": "区",
    "parentId": 219
  },
  {
    "id": 2049,
    "name": "芦淞区",
    "type": "区",
    "parentId": 219
  },
  {
    "id": 2050,
    "name": "石峰区",
    "type": "区",
    "parentId": 219
  },
  {
    "id": 2051,
    "name": "天元区",
    "type": "区",
    "parentId": 219
  },
  {
    "id": 2052,
    "name": "株洲县",
    "type": "区",
    "parentId": 219
  },
  {
    "id": 2053,
    "name": "攸县",
    "type": "区",
    "parentId": 219
  },
  {
    "id": 2054,
    "name": "茶陵县",
    "type": "区",
    "parentId": 219
  },
  {
    "id": 2055,
    "name": "炎陵县",
    "type": "区",
    "parentId": 219
  },
  {
    "id": 2056,
    "name": "醴陵市",
    "type": "区",
    "parentId": 219
  },
  {
    "id": 2057,
    "name": "雨湖区",
    "type": "区",
    "parentId": 220
  },
  {
    "id": 2058,
    "name": "岳塘区",
    "type": "区",
    "parentId": 220
  },
  {
    "id": 2059,
    "name": "湘潭县",
    "type": "区",
    "parentId": 220
  },
  {
    "id": 2060,
    "name": "湘乡市",
    "type": "区",
    "parentId": 220
  },
  {
    "id": 2061,
    "name": "韶山市",
    "type": "区",
    "parentId": 220
  },
  {
    "id": 2062,
    "name": "珠晖区",
    "type": "区",
    "parentId": 221
  },
  {
    "id": 2063,
    "name": "雁峰区",
    "type": "区",
    "parentId": 221
  },
  {
    "id": 2064,
    "name": "石鼓区",
    "type": "区",
    "parentId": 221
  },
  {
    "id": 2065,
    "name": "蒸湘区",
    "type": "区",
    "parentId": 221
  },
  {
    "id": 2066,
    "name": "南岳区",
    "type": "区",
    "parentId": 221
  },
  {
    "id": 2067,
    "name": "衡阳县",
    "type": "区",
    "parentId": 221
  },
  {
    "id": 2068,
    "name": "衡南县",
    "type": "区",
    "parentId": 221
  },
  {
    "id": 2069,
    "name": "衡山县",
    "type": "区",
    "parentId": 221
  },
  {
    "id": 2070,
    "name": "衡东县",
    "type": "区",
    "parentId": 221
  },
  {
    "id": 2071,
    "name": "祁东县",
    "type": "区",
    "parentId": 221
  },
  {
    "id": 2072,
    "name": "耒阳市",
    "type": "区",
    "parentId": 221
  },
  {
    "id": 2073,
    "name": "常宁市",
    "type": "区",
    "parentId": 221
  },
  {
    "id": 2074,
    "name": "双清区",
    "type": "区",
    "parentId": 222
  },
  {
    "id": 2075,
    "name": "大祥区",
    "type": "区",
    "parentId": 222
  },
  {
    "id": 2076,
    "name": "北塔区",
    "type": "区",
    "parentId": 222
  },
  {
    "id": 2077,
    "name": "邵东县",
    "type": "区",
    "parentId": 222
  },
  {
    "id": 2078,
    "name": "新邵县",
    "type": "区",
    "parentId": 222
  },
  {
    "id": 2079,
    "name": "邵阳县",
    "type": "区",
    "parentId": 222
  },
  {
    "id": 2080,
    "name": "隆回县",
    "type": "区",
    "parentId": 222
  },
  {
    "id": 2081,
    "name": "洞口县",
    "type": "区",
    "parentId": 222
  },
  {
    "id": 2082,
    "name": "绥宁县",
    "type": "区",
    "parentId": 222
  },
  {
    "id": 2083,
    "name": "新宁县",
    "type": "区",
    "parentId": 222
  },
  {
    "id": 2084,
    "name": "城步苗族自治县",
    "type": "区",
    "parentId": 222
  },
  {
    "id": 2085,
    "name": "武冈市",
    "type": "区",
    "parentId": 222
  },
  {
    "id": 2086,
    "name": "岳阳楼区",
    "type": "区",
    "parentId": 223
  },
  {
    "id": 2087,
    "name": "云溪区",
    "type": "区",
    "parentId": 223
  },
  {
    "id": 2088,
    "name": "君山区",
    "type": "区",
    "parentId": 223
  },
  {
    "id": 2089,
    "name": "岳阳县",
    "type": "区",
    "parentId": 223
  },
  {
    "id": 2090,
    "name": "华容县",
    "type": "区",
    "parentId": 223
  },
  {
    "id": 2091,
    "name": "湘阴县",
    "type": "区",
    "parentId": 223
  },
  {
    "id": 2092,
    "name": "平江县",
    "type": "区",
    "parentId": 223
  },
  {
    "id": 2093,
    "name": "汨罗市",
    "type": "区",
    "parentId": 223
  },
  {
    "id": 2094,
    "name": "临湘市",
    "type": "区",
    "parentId": 223
  },
  {
    "id": 2095,
    "name": "武陵区",
    "type": "区",
    "parentId": 224
  },
  {
    "id": 2096,
    "name": "鼎城区",
    "type": "区",
    "parentId": 224
  },
  {
    "id": 2097,
    "name": "安乡县",
    "type": "区",
    "parentId": 224
  },
  {
    "id": 2098,
    "name": "汉寿县",
    "type": "区",
    "parentId": 224
  },
  {
    "id": 2099,
    "name": "澧县",
    "type": "区",
    "parentId": 224
  },
  {
    "id": 2100,
    "name": "临澧县",
    "type": "区",
    "parentId": 224
  },
  {
    "id": 2101,
    "name": "桃源县",
    "type": "区",
    "parentId": 224
  },
  {
    "id": 2102,
    "name": "石门县",
    "type": "区",
    "parentId": 224
  },
  {
    "id": 2103,
    "name": "津市市",
    "type": "区",
    "parentId": 224
  },
  {
    "id": 2104,
    "name": "永定区",
    "type": "区",
    "parentId": 225
  },
  {
    "id": 2105,
    "name": "武陵源区",
    "type": "区",
    "parentId": 225
  },
  {
    "id": 2106,
    "name": "慈利县",
    "type": "区",
    "parentId": 225
  },
  {
    "id": 2107,
    "name": "桑植县",
    "type": "区",
    "parentId": 225
  },
  {
    "id": 2108,
    "name": "资阳区",
    "type": "区",
    "parentId": 226
  },
  {
    "id": 2109,
    "name": "赫山区",
    "type": "区",
    "parentId": 226
  },
  {
    "id": 2110,
    "name": "南县",
    "type": "区",
    "parentId": 226
  },
  {
    "id": 2111,
    "name": "桃江县",
    "type": "区",
    "parentId": 226
  },
  {
    "id": 2112,
    "name": "安化县",
    "type": "区",
    "parentId": 226
  },
  {
    "id": 2113,
    "name": "沅江市",
    "type": "区",
    "parentId": 226
  },
  {
    "id": 2114,
    "name": "北湖区",
    "type": "区",
    "parentId": 227
  },
  {
    "id": 2115,
    "name": "苏仙区",
    "type": "区",
    "parentId": 227
  },
  {
    "id": 2116,
    "name": "桂阳县",
    "type": "区",
    "parentId": 227
  },
  {
    "id": 2117,
    "name": "宜章县",
    "type": "区",
    "parentId": 227
  },
  {
    "id": 2118,
    "name": "永兴县",
    "type": "区",
    "parentId": 227
  },
  {
    "id": 2119,
    "name": "嘉禾县",
    "type": "区",
    "parentId": 227
  },
  {
    "id": 2120,
    "name": "临武县",
    "type": "区",
    "parentId": 227
  },
  {
    "id": 2121,
    "name": "汝城县",
    "type": "区",
    "parentId": 227
  },
  {
    "id": 2122,
    "name": "桂东县",
    "type": "区",
    "parentId": 227
  },
  {
    "id": 2123,
    "name": "安仁县",
    "type": "区",
    "parentId": 227
  },
  {
    "id": 2124,
    "name": "资兴市",
    "type": "区",
    "parentId": 227
  },
  {
    "id": 2125,
    "name": "零陵区",
    "type": "区",
    "parentId": 228
  },
  {
    "id": 2126,
    "name": "冷水滩区",
    "type": "区",
    "parentId": 228
  },
  {
    "id": 2127,
    "name": "祁阳县",
    "type": "区",
    "parentId": 228
  },
  {
    "id": 2128,
    "name": "东安县",
    "type": "区",
    "parentId": 228
  },
  {
    "id": 2129,
    "name": "双牌县",
    "type": "区",
    "parentId": 228
  },
  {
    "id": 2130,
    "name": "道县",
    "type": "区",
    "parentId": 228
  },
  {
    "id": 2131,
    "name": "江永县",
    "type": "区",
    "parentId": 228
  },
  {
    "id": 2132,
    "name": "宁远县",
    "type": "区",
    "parentId": 228
  },
  {
    "id": 2133,
    "name": "蓝山县",
    "type": "区",
    "parentId": 228
  },
  {
    "id": 2134,
    "name": "新田县",
    "type": "区",
    "parentId": 228
  },
  {
    "id": 2135,
    "name": "江华瑶族自治县",
    "type": "区",
    "parentId": 228
  },
  {
    "id": 2136,
    "name": "鹤城区",
    "type": "区",
    "parentId": 229
  },
  {
    "id": 2137,
    "name": "中方县",
    "type": "区",
    "parentId": 229
  },
  {
    "id": 2138,
    "name": "沅陵县",
    "type": "区",
    "parentId": 229
  },
  {
    "id": 2139,
    "name": "辰溪县",
    "type": "区",
    "parentId": 229
  },
  {
    "id": 2140,
    "name": "溆浦县",
    "type": "区",
    "parentId": 229
  },
  {
    "id": 2141,
    "name": "会同县",
    "type": "区",
    "parentId": 229
  },
  {
    "id": 2142,
    "name": "麻阳苗族自治县",
    "type": "区",
    "parentId": 229
  },
  {
    "id": 2143,
    "name": "新晃侗族自治县",
    "type": "区",
    "parentId": 229
  },
  {
    "id": 2144,
    "name": "芷江侗族自治县",
    "type": "区",
    "parentId": 229
  },
  {
    "id": 2145,
    "name": "靖州苗族侗族自治县",
    "type": "区",
    "parentId": 229
  },
  {
    "id": 2146,
    "name": "通道侗族自治县",
    "type": "区",
    "parentId": 229
  },
  {
    "id": 2147,
    "name": "洪江市",
    "type": "区",
    "parentId": 229
  },
  {
    "id": 2148,
    "name": "娄星区",
    "type": "区",
    "parentId": 230
  },
  {
    "id": 2149,
    "name": "双峰县",
    "type": "区",
    "parentId": 230
  },
  {
    "id": 2150,
    "name": "新化县",
    "type": "区",
    "parentId": 230
  },
  {
    "id": 2151,
    "name": "冷水江市",
    "type": "区",
    "parentId": 230
  },
  {
    "id": 2152,
    "name": "涟源市",
    "type": "区",
    "parentId": 230
  },
  {
    "id": 2153,
    "name": "吉首市",
    "type": "区",
    "parentId": 231
  },
  {
    "id": 2154,
    "name": "泸溪县",
    "type": "区",
    "parentId": 231
  },
  {
    "id": 2155,
    "name": "凤凰县",
    "type": "区",
    "parentId": 231
  },
  {
    "id": 2156,
    "name": "花垣县",
    "type": "区",
    "parentId": 231
  },
  {
    "id": 2157,
    "name": "保靖县",
    "type": "区",
    "parentId": 231
  },
  {
    "id": 2158,
    "name": "古丈县",
    "type": "区",
    "parentId": 231
  },
  {
    "id": 2159,
    "name": "永顺县",
    "type": "区",
    "parentId": 231
  },
  {
    "id": 2160,
    "name": "龙山县",
    "type": "区",
    "parentId": 231
  },
  {
    "id": 2161,
    "name": "荔湾区",
    "type": "区",
    "parentId": 232
  },
  {
    "id": 2162,
    "name": "越秀区",
    "type": "区",
    "parentId": 232
  },
  {
    "id": 2163,
    "name": "海珠区",
    "type": "区",
    "parentId": 232
  },
  {
    "id": 2164,
    "name": "天河区",
    "type": "区",
    "parentId": 232
  },
  {
    "id": 2165,
    "name": "白云区",
    "type": "区",
    "parentId": 232
  },
  {
    "id": 2166,
    "name": "黄埔区",
    "type": "区",
    "parentId": 232
  },
  {
    "id": 2167,
    "name": "番禺区",
    "type": "区",
    "parentId": 232
  },
  {
    "id": 2168,
    "name": "花都区",
    "type": "区",
    "parentId": 232
  },
  {
    "id": 2169,
    "name": "南沙区",
    "type": "区",
    "parentId": 232
  },
  {
    "id": 2170,
    "name": "从化区",
    "type": "区",
    "parentId": 232
  },
  {
    "id": 2171,
    "name": "增城区",
    "type": "区",
    "parentId": 232
  },
  {
    "id": 2172,
    "name": "武江区",
    "type": "区",
    "parentId": 233
  },
  {
    "id": 2173,
    "name": "浈江区",
    "type": "区",
    "parentId": 233
  },
  {
    "id": 2174,
    "name": "曲江区",
    "type": "区",
    "parentId": 233
  },
  {
    "id": 2175,
    "name": "始兴县",
    "type": "区",
    "parentId": 233
  },
  {
    "id": 2176,
    "name": "仁化县",
    "type": "区",
    "parentId": 233
  },
  {
    "id": 2177,
    "name": "翁源县",
    "type": "区",
    "parentId": 233
  },
  {
    "id": 2178,
    "name": "乳源瑶族自治县",
    "type": "区",
    "parentId": 233
  },
  {
    "id": 2179,
    "name": "新丰县",
    "type": "区",
    "parentId": 233
  },
  {
    "id": 2180,
    "name": "乐昌市",
    "type": "区",
    "parentId": 233
  },
  {
    "id": 2181,
    "name": "南雄市",
    "type": "区",
    "parentId": 233
  },
  {
    "id": 2182,
    "name": "罗湖区",
    "type": "区",
    "parentId": 234
  },
  {
    "id": 2183,
    "name": "福田区",
    "type": "区",
    "parentId": 234
  },
  {
    "id": 2184,
    "name": "南山区",
    "type": "区",
    "parentId": 234
  },
  {
    "id": 2185,
    "name": "宝安区",
    "type": "区",
    "parentId": 234
  },
  {
    "id": 2186,
    "name": "龙岗区",
    "type": "区",
    "parentId": 234
  },
  {
    "id": 2187,
    "name": "盐田区",
    "type": "区",
    "parentId": 234
  },
  {
    "id": 2188,
    "name": "龙华区",
    "type": "区",
    "parentId": 234
  },
  {
    "id": 2189,
    "name": "坪山区",
    "type": "区",
    "parentId": 234
  },
  {
    "id": 2190,
    "name": "香洲区",
    "type": "区",
    "parentId": 235
  },
  {
    "id": 2191,
    "name": "斗门区",
    "type": "区",
    "parentId": 235
  },
  {
    "id": 2192,
    "name": "金湾区",
    "type": "区",
    "parentId": 235
  },
  {
    "id": 2193,
    "name": "龙湖区",
    "type": "区",
    "parentId": 236
  },
  {
    "id": 2194,
    "name": "金平区",
    "type": "区",
    "parentId": 236
  },
  {
    "id": 2195,
    "name": "濠江区",
    "type": "区",
    "parentId": 236
  },
  {
    "id": 2196,
    "name": "潮阳区",
    "type": "区",
    "parentId": 236
  },
  {
    "id": 2197,
    "name": "潮南区",
    "type": "区",
    "parentId": 236
  },
  {
    "id": 2198,
    "name": "澄海区",
    "type": "区",
    "parentId": 236
  },
  {
    "id": 2199,
    "name": "南澳县",
    "type": "区",
    "parentId": 236
  },
  {
    "id": 2200,
    "name": "禅城区",
    "type": "区",
    "parentId": 237
  },
  {
    "id": 2201,
    "name": "南海区",
    "type": "区",
    "parentId": 237
  },
  {
    "id": 2202,
    "name": "顺德区",
    "type": "区",
    "parentId": 237
  },
  {
    "id": 2203,
    "name": "三水区",
    "type": "区",
    "parentId": 237
  },
  {
    "id": 2204,
    "name": "高明区",
    "type": "区",
    "parentId": 237
  },
  {
    "id": 2205,
    "name": "蓬江区",
    "type": "区",
    "parentId": 238
  },
  {
    "id": 2206,
    "name": "江海区",
    "type": "区",
    "parentId": 238
  },
  {
    "id": 2207,
    "name": "新会区",
    "type": "区",
    "parentId": 238
  },
  {
    "id": 2208,
    "name": "台山市",
    "type": "区",
    "parentId": 238
  },
  {
    "id": 2209,
    "name": "开平市",
    "type": "区",
    "parentId": 238
  },
  {
    "id": 2210,
    "name": "鹤山市",
    "type": "区",
    "parentId": 238
  },
  {
    "id": 2211,
    "name": "恩平市",
    "type": "区",
    "parentId": 238
  },
  {
    "id": 2212,
    "name": "赤坎区",
    "type": "区",
    "parentId": 239
  },
  {
    "id": 2213,
    "name": "霞山区",
    "type": "区",
    "parentId": 239
  },
  {
    "id": 2214,
    "name": "坡头区",
    "type": "区",
    "parentId": 239
  },
  {
    "id": 2215,
    "name": "麻章区",
    "type": "区",
    "parentId": 239
  },
  {
    "id": 2216,
    "name": "遂溪县",
    "type": "区",
    "parentId": 239
  },
  {
    "id": 2217,
    "name": "徐闻县",
    "type": "区",
    "parentId": 239
  },
  {
    "id": 2218,
    "name": "廉江市",
    "type": "区",
    "parentId": 239
  },
  {
    "id": 2219,
    "name": "雷州市",
    "type": "区",
    "parentId": 239
  },
  {
    "id": 2220,
    "name": "吴川市",
    "type": "区",
    "parentId": 239
  },
  {
    "id": 2221,
    "name": "经济技术开发区",
    "type": "区",
    "parentId": 239
  },
  {
    "id": 2222,
    "name": "茂南区",
    "type": "区",
    "parentId": 240
  },
  {
    "id": 2223,
    "name": "电白区",
    "type": "区",
    "parentId": 240
  },
  {
    "id": 2224,
    "name": "高州市",
    "type": "区",
    "parentId": 240
  },
  {
    "id": 2225,
    "name": "化州市",
    "type": "区",
    "parentId": 240
  },
  {
    "id": 2226,
    "name": "信宜市",
    "type": "区",
    "parentId": 240
  },
  {
    "id": 2227,
    "name": "端州区",
    "type": "区",
    "parentId": 241
  },
  {
    "id": 2228,
    "name": "鼎湖区",
    "type": "区",
    "parentId": 241
  },
  {
    "id": 2229,
    "name": "高要区",
    "type": "区",
    "parentId": 241
  },
  {
    "id": 2230,
    "name": "广宁县",
    "type": "区",
    "parentId": 241
  },
  {
    "id": 2231,
    "name": "怀集县",
    "type": "区",
    "parentId": 241
  },
  {
    "id": 2232,
    "name": "封开县",
    "type": "区",
    "parentId": 241
  },
  {
    "id": 2233,
    "name": "德庆县",
    "type": "区",
    "parentId": 241
  },
  {
    "id": 2234,
    "name": "四会市",
    "type": "区",
    "parentId": 241
  },
  {
    "id": 2235,
    "name": "惠城区",
    "type": "区",
    "parentId": 242
  },
  {
    "id": 2236,
    "name": "惠阳区",
    "type": "区",
    "parentId": 242
  },
  {
    "id": 2237,
    "name": "博罗县",
    "type": "区",
    "parentId": 242
  },
  {
    "id": 2238,
    "name": "惠东县",
    "type": "区",
    "parentId": 242
  },
  {
    "id": 2239,
    "name": "龙门县",
    "type": "区",
    "parentId": 242
  },
  {
    "id": 2240,
    "name": "梅江区",
    "type": "区",
    "parentId": 243
  },
  {
    "id": 2241,
    "name": "梅县区",
    "type": "区",
    "parentId": 243
  },
  {
    "id": 2242,
    "name": "大埔县",
    "type": "区",
    "parentId": 243
  },
  {
    "id": 2243,
    "name": "丰顺县",
    "type": "区",
    "parentId": 243
  },
  {
    "id": 2244,
    "name": "五华县",
    "type": "区",
    "parentId": 243
  },
  {
    "id": 2245,
    "name": "平远县",
    "type": "区",
    "parentId": 243
  },
  {
    "id": 2246,
    "name": "蕉岭县",
    "type": "区",
    "parentId": 243
  },
  {
    "id": 2247,
    "name": "兴宁市",
    "type": "区",
    "parentId": 243
  },
  {
    "id": 2248,
    "name": "城区",
    "type": "区",
    "parentId": 244
  },
  {
    "id": 2249,
    "name": "海丰县",
    "type": "区",
    "parentId": 244
  },
  {
    "id": 2250,
    "name": "陆河县",
    "type": "区",
    "parentId": 244
  },
  {
    "id": 2251,
    "name": "陆丰市",
    "type": "区",
    "parentId": 244
  },
  {
    "id": 2252,
    "name": "源城区",
    "type": "区",
    "parentId": 245
  },
  {
    "id": 2253,
    "name": "紫金县",
    "type": "区",
    "parentId": 245
  },
  {
    "id": 2254,
    "name": "龙川县",
    "type": "区",
    "parentId": 245
  },
  {
    "id": 2255,
    "name": "连平县",
    "type": "区",
    "parentId": 245
  },
  {
    "id": 2256,
    "name": "和平县",
    "type": "区",
    "parentId": 245
  },
  {
    "id": 2257,
    "name": "东源县",
    "type": "区",
    "parentId": 245
  },
  {
    "id": 2258,
    "name": "江城区",
    "type": "区",
    "parentId": 246
  },
  {
    "id": 2259,
    "name": "阳东区",
    "type": "区",
    "parentId": 246
  },
  {
    "id": 2260,
    "name": "阳西县",
    "type": "区",
    "parentId": 246
  },
  {
    "id": 2261,
    "name": "阳春市",
    "type": "区",
    "parentId": 246
  },
  {
    "id": 2262,
    "name": "清城区",
    "type": "区",
    "parentId": 247
  },
  {
    "id": 2263,
    "name": "清新区",
    "type": "区",
    "parentId": 247
  },
  {
    "id": 2264,
    "name": "佛冈县",
    "type": "区",
    "parentId": 247
  },
  {
    "id": 2265,
    "name": "阳山县",
    "type": "区",
    "parentId": 247
  },
  {
    "id": 2266,
    "name": "连山壮族瑶族自治县",
    "type": "区",
    "parentId": 247
  },
  {
    "id": 2267,
    "name": "连南瑶族自治县",
    "type": "区",
    "parentId": 247
  },
  {
    "id": 2268,
    "name": "英德市",
    "type": "区",
    "parentId": 247
  },
  {
    "id": 2269,
    "name": "连州市",
    "type": "区",
    "parentId": 247
  },
  {
    "id": 2270,
    "name": "中堂镇",
    "type": "区",
    "parentId": 248
  },
  {
    "id": 2271,
    "name": "南城区",
    "type": "区",
    "parentId": 248
  },
  {
    "id": 2272,
    "name": "长安镇",
    "type": "区",
    "parentId": 248
  },
  {
    "id": 2273,
    "name": "东坑镇",
    "type": "区",
    "parentId": 248
  },
  {
    "id": 2274,
    "name": "樟木头镇",
    "type": "区",
    "parentId": 248
  },
  {
    "id": 2275,
    "name": "莞城区",
    "type": "区",
    "parentId": 248
  },
  {
    "id": 2276,
    "name": "石龙镇",
    "type": "区",
    "parentId": 248
  },
  {
    "id": 2277,
    "name": "桥头镇",
    "type": "区",
    "parentId": 248
  },
  {
    "id": 2278,
    "name": "万江区",
    "type": "区",
    "parentId": 248
  },
  {
    "id": 2279,
    "name": "麻涌镇",
    "type": "区",
    "parentId": 248
  },
  {
    "id": 2280,
    "name": "虎门镇",
    "type": "区",
    "parentId": 248
  },
  {
    "id": 2281,
    "name": "谢岗镇",
    "type": "区",
    "parentId": 248
  },
  {
    "id": 2282,
    "name": "石碣镇",
    "type": "区",
    "parentId": 248
  },
  {
    "id": 2283,
    "name": "茶山镇",
    "type": "区",
    "parentId": 248
  },
  {
    "id": 2284,
    "name": "东城区",
    "type": "区",
    "parentId": 248
  },
  {
    "id": 2285,
    "name": "洪梅镇",
    "type": "区",
    "parentId": 248
  },
  {
    "id": 2286,
    "name": "道滘镇",
    "type": "区",
    "parentId": 248
  },
  {
    "id": 2287,
    "name": "高埗镇",
    "type": "区",
    "parentId": 248
  },
  {
    "id": 2288,
    "name": "企石镇",
    "type": "区",
    "parentId": 248
  },
  {
    "id": 2289,
    "name": "凤岗镇",
    "type": "区",
    "parentId": 248
  },
  {
    "id": 2290,
    "name": "大岭山镇",
    "type": "区",
    "parentId": 248
  },
  {
    "id": 2291,
    "name": "松山湖",
    "type": "区",
    "parentId": 248
  },
  {
    "id": 2292,
    "name": "清溪镇",
    "type": "区",
    "parentId": 248
  },
  {
    "id": 2293,
    "name": "望牛墩镇",
    "type": "区",
    "parentId": 248
  },
  {
    "id": 2294,
    "name": "厚街镇",
    "type": "区",
    "parentId": 248
  },
  {
    "id": 2295,
    "name": "常平镇",
    "type": "区",
    "parentId": 248
  },
  {
    "id": 2296,
    "name": "寮步镇",
    "type": "区",
    "parentId": 248
  },
  {
    "id": 2297,
    "name": "石排镇",
    "type": "区",
    "parentId": 248
  },
  {
    "id": 2298,
    "name": "横沥镇",
    "type": "区",
    "parentId": 248
  },
  {
    "id": 2299,
    "name": "塘厦镇",
    "type": "区",
    "parentId": 248
  },
  {
    "id": 2300,
    "name": "黄江镇",
    "type": "区",
    "parentId": 248
  },
  {
    "id": 2301,
    "name": "大朗镇",
    "type": "区",
    "parentId": 248
  },
  {
    "id": 2302,
    "name": "沙田镇",
    "type": "区",
    "parentId": 248
  },
  {
    "id": 2303,
    "name": "南头镇",
    "type": "区",
    "parentId": 249
  },
  {
    "id": 2304,
    "name": "神湾镇",
    "type": "区",
    "parentId": 249
  },
  {
    "id": 2305,
    "name": "东凤镇",
    "type": "区",
    "parentId": 249
  },
  {
    "id": 2306,
    "name": "五桂山镇",
    "type": "区",
    "parentId": 249
  },
  {
    "id": 2307,
    "name": "黄圃镇",
    "type": "区",
    "parentId": 249
  },
  {
    "id": 2308,
    "name": "小榄镇",
    "type": "区",
    "parentId": 249
  },
  {
    "id": 2309,
    "name": "石岐区街道",
    "type": "区",
    "parentId": 249
  },
  {
    "id": 2310,
    "name": "横栏镇",
    "type": "区",
    "parentId": 249
  },
  {
    "id": 2311,
    "name": "三角镇",
    "type": "区",
    "parentId": 249
  },
  {
    "id": 2312,
    "name": "三乡镇",
    "type": "区",
    "parentId": 249
  },
  {
    "id": 2313,
    "name": "港口镇",
    "type": "区",
    "parentId": 249
  },
  {
    "id": 2314,
    "name": "沙溪镇",
    "type": "区",
    "parentId": 249
  },
  {
    "id": 2315,
    "name": "板芙镇",
    "type": "区",
    "parentId": 249
  },
  {
    "id": 2316,
    "name": "沙朗镇",
    "type": "区",
    "parentId": 249
  },
  {
    "id": 2317,
    "name": "东升镇",
    "type": "区",
    "parentId": 249
  },
  {
    "id": 2318,
    "name": "阜沙镇",
    "type": "区",
    "parentId": 249
  },
  {
    "id": 2319,
    "name": "民众镇",
    "type": "区",
    "parentId": 249
  },
  {
    "id": 2320,
    "name": "东区街道",
    "type": "区",
    "parentId": 249
  },
  {
    "id": 2321,
    "name": "火炬开发区",
    "type": "区",
    "parentId": 249
  },
  {
    "id": 2322,
    "name": "西区街道",
    "type": "区",
    "parentId": 249
  },
  {
    "id": 2323,
    "name": "南区街道",
    "type": "区",
    "parentId": 249
  },
  {
    "id": 2324,
    "name": "古镇",
    "type": "区",
    "parentId": 249
  },
  {
    "id": 2325,
    "name": "坦洲镇",
    "type": "区",
    "parentId": 249
  },
  {
    "id": 2326,
    "name": "大涌镇",
    "type": "区",
    "parentId": 249
  },
  {
    "id": 2327,
    "name": "南朗镇",
    "type": "区",
    "parentId": 249
  },
  {
    "id": 2328,
    "name": "湘桥区",
    "type": "区",
    "parentId": 250
  },
  {
    "id": 2329,
    "name": "潮安区",
    "type": "区",
    "parentId": 250
  },
  {
    "id": 2330,
    "name": "饶平县",
    "type": "区",
    "parentId": 250
  },
  {
    "id": 2331,
    "name": "榕城区",
    "type": "区",
    "parentId": 251
  },
  {
    "id": 2332,
    "name": "揭东区",
    "type": "区",
    "parentId": 251
  },
  {
    "id": 2333,
    "name": "揭西县",
    "type": "区",
    "parentId": 251
  },
  {
    "id": 2334,
    "name": "惠来县",
    "type": "区",
    "parentId": 251
  },
  {
    "id": 2335,
    "name": "普宁市",
    "type": "区",
    "parentId": 251
  },
  {
    "id": 2336,
    "name": "云城区",
    "type": "区",
    "parentId": 252
  },
  {
    "id": 2337,
    "name": "云安区",
    "type": "区",
    "parentId": 252
  },
  {
    "id": 2338,
    "name": "新兴县",
    "type": "区",
    "parentId": 252
  },
  {
    "id": 2339,
    "name": "郁南县",
    "type": "区",
    "parentId": 252
  },
  {
    "id": 2340,
    "name": "罗定市",
    "type": "区",
    "parentId": 252
  },
  {
    "id": 2341,
    "name": "兴宁区",
    "type": "区",
    "parentId": 253
  },
  {
    "id": 2342,
    "name": "青秀区",
    "type": "区",
    "parentId": 253
  },
  {
    "id": 2343,
    "name": "江南区",
    "type": "区",
    "parentId": 253
  },
  {
    "id": 2344,
    "name": "西乡塘区",
    "type": "区",
    "parentId": 253
  },
  {
    "id": 2345,
    "name": "良庆区",
    "type": "区",
    "parentId": 253
  },
  {
    "id": 2346,
    "name": "邕宁区",
    "type": "区",
    "parentId": 253
  },
  {
    "id": 2347,
    "name": "武鸣区",
    "type": "区",
    "parentId": 253
  },
  {
    "id": 2348,
    "name": "隆安县",
    "type": "区",
    "parentId": 253
  },
  {
    "id": 2349,
    "name": "马山县",
    "type": "区",
    "parentId": 253
  },
  {
    "id": 2350,
    "name": "上林县",
    "type": "区",
    "parentId": 253
  },
  {
    "id": 2351,
    "name": "宾阳县",
    "type": "区",
    "parentId": 253
  },
  {
    "id": 2352,
    "name": "横县",
    "type": "区",
    "parentId": 253
  },
  {
    "id": 2353,
    "name": "城中区",
    "type": "区",
    "parentId": 254
  },
  {
    "id": 2354,
    "name": "鱼峰区",
    "type": "区",
    "parentId": 254
  },
  {
    "id": 2355,
    "name": "柳南区",
    "type": "区",
    "parentId": 254
  },
  {
    "id": 2356,
    "name": "柳北区",
    "type": "区",
    "parentId": 254
  },
  {
    "id": 2357,
    "name": "柳江区",
    "type": "区",
    "parentId": 254
  },
  {
    "id": 2358,
    "name": "柳城县",
    "type": "区",
    "parentId": 254
  },
  {
    "id": 2359,
    "name": "鹿寨县",
    "type": "区",
    "parentId": 254
  },
  {
    "id": 2360,
    "name": "融安县",
    "type": "区",
    "parentId": 254
  },
  {
    "id": 2361,
    "name": "融水苗族自治县",
    "type": "区",
    "parentId": 254
  },
  {
    "id": 2362,
    "name": "三江侗族自治县",
    "type": "区",
    "parentId": 254
  },
  {
    "id": 2363,
    "name": "秀峰区",
    "type": "区",
    "parentId": 255
  },
  {
    "id": 2364,
    "name": "叠彩区",
    "type": "区",
    "parentId": 255
  },
  {
    "id": 2365,
    "name": "象山区",
    "type": "区",
    "parentId": 255
  },
  {
    "id": 2366,
    "name": "七星区",
    "type": "区",
    "parentId": 255
  },
  {
    "id": 2367,
    "name": "雁山区",
    "type": "区",
    "parentId": 255
  },
  {
    "id": 2368,
    "name": "临桂区",
    "type": "区",
    "parentId": 255
  },
  {
    "id": 2369,
    "name": "阳朔县",
    "type": "区",
    "parentId": 255
  },
  {
    "id": 2370,
    "name": "灵川县",
    "type": "区",
    "parentId": 255
  },
  {
    "id": 2371,
    "name": "全州县",
    "type": "区",
    "parentId": 255
  },
  {
    "id": 2372,
    "name": "兴安县",
    "type": "区",
    "parentId": 255
  },
  {
    "id": 2373,
    "name": "永福县",
    "type": "区",
    "parentId": 255
  },
  {
    "id": 2374,
    "name": "灌阳县",
    "type": "区",
    "parentId": 255
  },
  {
    "id": 2375,
    "name": "龙胜各族自治县",
    "type": "区",
    "parentId": 255
  },
  {
    "id": 2376,
    "name": "资源县",
    "type": "区",
    "parentId": 255
  },
  {
    "id": 2377,
    "name": "平乐县",
    "type": "区",
    "parentId": 255
  },
  {
    "id": 2378,
    "name": "荔浦县",
    "type": "区",
    "parentId": 255
  },
  {
    "id": 2379,
    "name": "恭城瑶族自治县",
    "type": "区",
    "parentId": 255
  },
  {
    "id": 2380,
    "name": "万秀区",
    "type": "区",
    "parentId": 256
  },
  {
    "id": 2381,
    "name": "长洲区",
    "type": "区",
    "parentId": 256
  },
  {
    "id": 2382,
    "name": "龙圩区",
    "type": "区",
    "parentId": 256
  },
  {
    "id": 2383,
    "name": "苍梧县",
    "type": "区",
    "parentId": 256
  },
  {
    "id": 2384,
    "name": "藤县",
    "type": "区",
    "parentId": 256
  },
  {
    "id": 2385,
    "name": "蒙山县",
    "type": "区",
    "parentId": 256
  },
  {
    "id": 2386,
    "name": "岑溪市",
    "type": "区",
    "parentId": 256
  },
  {
    "id": 2387,
    "name": "海城区",
    "type": "区",
    "parentId": 257
  },
  {
    "id": 2388,
    "name": "银海区",
    "type": "区",
    "parentId": 257
  },
  {
    "id": 2389,
    "name": "铁山港区",
    "type": "区",
    "parentId": 257
  },
  {
    "id": 2390,
    "name": "合浦县",
    "type": "区",
    "parentId": 257
  },
  {
    "id": 2391,
    "name": "港口区",
    "type": "区",
    "parentId": 258
  },
  {
    "id": 2392,
    "name": "防城区",
    "type": "区",
    "parentId": 258
  },
  {
    "id": 2393,
    "name": "上思县",
    "type": "区",
    "parentId": 258
  },
  {
    "id": 2394,
    "name": "东兴市",
    "type": "区",
    "parentId": 258
  },
  {
    "id": 2395,
    "name": "钦南区",
    "type": "区",
    "parentId": 259
  },
  {
    "id": 2396,
    "name": "钦北区",
    "type": "区",
    "parentId": 259
  },
  {
    "id": 2397,
    "name": "灵山县",
    "type": "区",
    "parentId": 259
  },
  {
    "id": 2398,
    "name": "浦北县",
    "type": "区",
    "parentId": 259
  },
  {
    "id": 2399,
    "name": "港北区",
    "type": "区",
    "parentId": 260
  },
  {
    "id": 2400,
    "name": "港南区",
    "type": "区",
    "parentId": 260
  },
  {
    "id": 2401,
    "name": "覃塘区",
    "type": "区",
    "parentId": 260
  },
  {
    "id": 2402,
    "name": "平南县",
    "type": "区",
    "parentId": 260
  },
  {
    "id": 2403,
    "name": "桂平市",
    "type": "区",
    "parentId": 260
  },
  {
    "id": 2404,
    "name": "玉州区",
    "type": "区",
    "parentId": 261
  },
  {
    "id": 2405,
    "name": "福绵区",
    "type": "区",
    "parentId": 261
  },
  {
    "id": 2406,
    "name": "容县",
    "type": "区",
    "parentId": 261
  },
  {
    "id": 2407,
    "name": "陆川县",
    "type": "区",
    "parentId": 261
  },
  {
    "id": 2408,
    "name": "博白县",
    "type": "区",
    "parentId": 261
  },
  {
    "id": 2409,
    "name": "兴业县",
    "type": "区",
    "parentId": 261
  },
  {
    "id": 2410,
    "name": "北流市",
    "type": "区",
    "parentId": 261
  },
  {
    "id": 2411,
    "name": "右江区",
    "type": "区",
    "parentId": 262
  },
  {
    "id": 2412,
    "name": "田阳县",
    "type": "区",
    "parentId": 262
  },
  {
    "id": 2413,
    "name": "田东县",
    "type": "区",
    "parentId": 262
  },
  {
    "id": 2414,
    "name": "平果县",
    "type": "区",
    "parentId": 262
  },
  {
    "id": 2415,
    "name": "德保县",
    "type": "区",
    "parentId": 262
  },
  {
    "id": 2416,
    "name": "那坡县",
    "type": "区",
    "parentId": 262
  },
  {
    "id": 2417,
    "name": "凌云县",
    "type": "区",
    "parentId": 262
  },
  {
    "id": 2418,
    "name": "乐业县",
    "type": "区",
    "parentId": 262
  },
  {
    "id": 2419,
    "name": "田林县",
    "type": "区",
    "parentId": 262
  },
  {
    "id": 2420,
    "name": "西林县",
    "type": "区",
    "parentId": 262
  },
  {
    "id": 2421,
    "name": "隆林各族自治县",
    "type": "区",
    "parentId": 262
  },
  {
    "id": 2422,
    "name": "靖西市",
    "type": "区",
    "parentId": 262
  },
  {
    "id": 2423,
    "name": "八步区",
    "type": "区",
    "parentId": 263
  },
  {
    "id": 2424,
    "name": "平桂区",
    "type": "区",
    "parentId": 263
  },
  {
    "id": 2425,
    "name": "昭平县",
    "type": "区",
    "parentId": 263
  },
  {
    "id": 2426,
    "name": "钟山县",
    "type": "区",
    "parentId": 263
  },
  {
    "id": 2427,
    "name": "富川瑶族自治县",
    "type": "区",
    "parentId": 263
  },
  {
    "id": 2428,
    "name": "金城江区",
    "type": "区",
    "parentId": 264
  },
  {
    "id": 2429,
    "name": "宜州区",
    "type": "区",
    "parentId": 264
  },
  {
    "id": 2430,
    "name": "南丹县",
    "type": "区",
    "parentId": 264
  },
  {
    "id": 2431,
    "name": "天峨县",
    "type": "区",
    "parentId": 264
  },
  {
    "id": 2432,
    "name": "凤山县",
    "type": "区",
    "parentId": 264
  },
  {
    "id": 2433,
    "name": "东兰县",
    "type": "区",
    "parentId": 264
  },
  {
    "id": 2434,
    "name": "罗城仫佬族自治县",
    "type": "区",
    "parentId": 264
  },
  {
    "id": 2435,
    "name": "环江毛南族自治县",
    "type": "区",
    "parentId": 264
  },
  {
    "id": 2436,
    "name": "巴马瑶族自治县",
    "type": "区",
    "parentId": 264
  },
  {
    "id": 2437,
    "name": "都安瑶族自治县",
    "type": "区",
    "parentId": 264
  },
  {
    "id": 2438,
    "name": "大化瑶族自治县",
    "type": "区",
    "parentId": 264
  },
  {
    "id": 2439,
    "name": "兴宾区",
    "type": "区",
    "parentId": 265
  },
  {
    "id": 2440,
    "name": "忻城县",
    "type": "区",
    "parentId": 265
  },
  {
    "id": 2441,
    "name": "象州县",
    "type": "区",
    "parentId": 265
  },
  {
    "id": 2442,
    "name": "武宣县",
    "type": "区",
    "parentId": 265
  },
  {
    "id": 2443,
    "name": "金秀瑶族自治县",
    "type": "区",
    "parentId": 265
  },
  {
    "id": 2444,
    "name": "合山市",
    "type": "区",
    "parentId": 265
  },
  {
    "id": 2445,
    "name": "江州区",
    "type": "区",
    "parentId": 266
  },
  {
    "id": 2446,
    "name": "扶绥县",
    "type": "区",
    "parentId": 266
  },
  {
    "id": 2447,
    "name": "宁明县",
    "type": "区",
    "parentId": 266
  },
  {
    "id": 2448,
    "name": "龙州县",
    "type": "区",
    "parentId": 266
  },
  {
    "id": 2449,
    "name": "大新县",
    "type": "区",
    "parentId": 266
  },
  {
    "id": 2450,
    "name": "天等县",
    "type": "区",
    "parentId": 266
  },
  {
    "id": 2451,
    "name": "凭祥市",
    "type": "区",
    "parentId": 266
  },
  {
    "id": 2452,
    "name": "秀英区",
    "type": "区",
    "parentId": 267
  },
  {
    "id": 2453,
    "name": "龙华区",
    "type": "区",
    "parentId": 267
  },
  {
    "id": 2454,
    "name": "琼山区",
    "type": "区",
    "parentId": 267
  },
  {
    "id": 2455,
    "name": "美兰区",
    "type": "区",
    "parentId": 267
  },
  {
    "id": 2456,
    "name": "海棠区",
    "type": "区",
    "parentId": 268
  },
  {
    "id": 2457,
    "name": "吉阳区",
    "type": "区",
    "parentId": 268
  },
  {
    "id": 2458,
    "name": "天涯区",
    "type": "区",
    "parentId": 268
  },
  {
    "id": 2459,
    "name": "崖州区",
    "type": "区",
    "parentId": 268
  },
  {
    "id": 2460,
    "name": "西沙群岛",
    "type": "区",
    "parentId": 269
  },
  {
    "id": 2461,
    "name": "南沙群岛",
    "type": "区",
    "parentId": 269
  },
  {
    "id": 2462,
    "name": "中沙群岛的岛礁及其海域",
    "type": "区",
    "parentId": 269
  },
  {
    "id": 2463,
    "name": "那大镇",
    "type": "区",
    "parentId": 270
  },
  {
    "id": 2464,
    "name": "和庆镇",
    "type": "区",
    "parentId": 270
  },
  {
    "id": 2465,
    "name": "南丰镇",
    "type": "区",
    "parentId": 270
  },
  {
    "id": 2466,
    "name": "大成镇",
    "type": "区",
    "parentId": 270
  },
  {
    "id": 2467,
    "name": "雅星镇",
    "type": "区",
    "parentId": 270
  },
  {
    "id": 2468,
    "name": "兰洋镇",
    "type": "区",
    "parentId": 270
  },
  {
    "id": 2469,
    "name": "光村镇",
    "type": "区",
    "parentId": 270
  },
  {
    "id": 2470,
    "name": "木棠镇",
    "type": "区",
    "parentId": 270
  },
  {
    "id": 2471,
    "name": "海头镇",
    "type": "区",
    "parentId": 270
  },
  {
    "id": 2472,
    "name": "峨蔓镇",
    "type": "区",
    "parentId": 270
  },
  {
    "id": 2473,
    "name": "王五镇",
    "type": "区",
    "parentId": 270
  },
  {
    "id": 2474,
    "name": "白马井镇",
    "type": "区",
    "parentId": 270
  },
  {
    "id": 2475,
    "name": "中和镇",
    "type": "区",
    "parentId": 270
  },
  {
    "id": 2476,
    "name": "排浦镇",
    "type": "区",
    "parentId": 270
  },
  {
    "id": 2477,
    "name": "东成镇",
    "type": "区",
    "parentId": 270
  },
  {
    "id": 2478,
    "name": "新州镇",
    "type": "区",
    "parentId": 270
  },
  {
    "id": 2479,
    "name": "五指山市",
    "type": "区",
    "parentId": 271
  },
  {
    "id": 2480,
    "name": "琼海市",
    "type": "区",
    "parentId": 271
  },
  {
    "id": 2481,
    "name": "文昌市",
    "type": "区",
    "parentId": 271
  },
  {
    "id": 2482,
    "name": "万宁市",
    "type": "区",
    "parentId": 271
  },
  {
    "id": 2483,
    "name": "东方市",
    "type": "区",
    "parentId": 271
  },
  {
    "id": 2484,
    "name": "定安县",
    "type": "区",
    "parentId": 271
  },
  {
    "id": 2485,
    "name": "屯昌县",
    "type": "区",
    "parentId": 271
  },
  {
    "id": 2486,
    "name": "澄迈县",
    "type": "区",
    "parentId": 271
  },
  {
    "id": 2487,
    "name": "临高县",
    "type": "区",
    "parentId": 271
  },
  {
    "id": 2488,
    "name": "白沙黎族自治县",
    "type": "区",
    "parentId": 271
  },
  {
    "id": 2489,
    "name": "昌江黎族自治县",
    "type": "区",
    "parentId": 271
  },
  {
    "id": 2490,
    "name": "乐东黎族自治县",
    "type": "区",
    "parentId": 271
  },
  {
    "id": 2491,
    "name": "陵水黎族自治县",
    "type": "区",
    "parentId": 271
  },
  {
    "id": 2492,
    "name": "保亭黎族苗族自治县",
    "type": "区",
    "parentId": 271
  },
  {
    "id": 2493,
    "name": "琼中黎族苗族自治县",
    "type": "区",
    "parentId": 271
  },
  {
    "id": 2494,
    "name": "万州区",
    "type": "区",
    "parentId": 272
  },
  {
    "id": 2495,
    "name": "涪陵区",
    "type": "区",
    "parentId": 272
  },
  {
    "id": 2496,
    "name": "渝中区",
    "type": "区",
    "parentId": 272
  },
  {
    "id": 2497,
    "name": "大渡口区",
    "type": "区",
    "parentId": 272
  },
  {
    "id": 2498,
    "name": "江北区",
    "type": "区",
    "parentId": 272
  },
  {
    "id": 2499,
    "name": "沙坪坝区",
    "type": "区",
    "parentId": 272
  },
  {
    "id": 2500,
    "name": "九龙坡区",
    "type": "区",
    "parentId": 272
  },
  {
    "id": 2501,
    "name": "南岸区",
    "type": "区",
    "parentId": 272
  },
  {
    "id": 2502,
    "name": "北碚区",
    "type": "区",
    "parentId": 272
  },
  {
    "id": 2503,
    "name": "綦江区",
    "type": "区",
    "parentId": 272
  },
  {
    "id": 2504,
    "name": "大足区",
    "type": "区",
    "parentId": 272
  },
  {
    "id": 2505,
    "name": "渝北区",
    "type": "区",
    "parentId": 272
  },
  {
    "id": 2506,
    "name": "巴南区",
    "type": "区",
    "parentId": 272
  },
  {
    "id": 2507,
    "name": "黔江区",
    "type": "区",
    "parentId": 272
  },
  {
    "id": 2508,
    "name": "长寿区",
    "type": "区",
    "parentId": 272
  },
  {
    "id": 2509,
    "name": "江津区",
    "type": "区",
    "parentId": 272
  },
  {
    "id": 2510,
    "name": "合川区",
    "type": "区",
    "parentId": 272
  },
  {
    "id": 2511,
    "name": "永川区",
    "type": "区",
    "parentId": 272
  },
  {
    "id": 2512,
    "name": "南川区",
    "type": "区",
    "parentId": 272
  },
  {
    "id": 2513,
    "name": "璧山区",
    "type": "区",
    "parentId": 272
  },
  {
    "id": 2514,
    "name": "铜梁区",
    "type": "区",
    "parentId": 272
  },
  {
    "id": 2515,
    "name": "潼南区",
    "type": "区",
    "parentId": 272
  },
  {
    "id": 2516,
    "name": "荣昌区",
    "type": "区",
    "parentId": 272
  },
  {
    "id": 2517,
    "name": "开州区",
    "type": "区",
    "parentId": 272
  },
  {
    "id": 2518,
    "name": "梁平区",
    "type": "区",
    "parentId": 272
  },
  {
    "id": 2519,
    "name": "武隆区",
    "type": "区",
    "parentId": 272
  },
  {
    "id": 2520,
    "name": "城口县",
    "type": "区",
    "parentId": 273
  },
  {
    "id": 2521,
    "name": "丰都县",
    "type": "区",
    "parentId": 273
  },
  {
    "id": 2522,
    "name": "垫江县",
    "type": "区",
    "parentId": 273
  },
  {
    "id": 2523,
    "name": "忠县",
    "type": "区",
    "parentId": 273
  },
  {
    "id": 2524,
    "name": "云阳县",
    "type": "区",
    "parentId": 273
  },
  {
    "id": 2525,
    "name": "奉节县",
    "type": "区",
    "parentId": 273
  },
  {
    "id": 2526,
    "name": "巫山县",
    "type": "区",
    "parentId": 273
  },
  {
    "id": 2527,
    "name": "巫溪县",
    "type": "区",
    "parentId": 273
  },
  {
    "id": 2528,
    "name": "石柱土家族自治县",
    "type": "区",
    "parentId": 273
  },
  {
    "id": 2529,
    "name": "秀山土家族苗族自治县",
    "type": "区",
    "parentId": 273
  },
  {
    "id": 2530,
    "name": "酉阳土家族苗族自治县",
    "type": "区",
    "parentId": 273
  },
  {
    "id": 2531,
    "name": "彭水苗族土家族自治县",
    "type": "区",
    "parentId": 273
  },
  {
    "id": 2532,
    "name": "锦江区",
    "type": "区",
    "parentId": 274
  },
  {
    "id": 2533,
    "name": "青羊区",
    "type": "区",
    "parentId": 274
  },
  {
    "id": 2534,
    "name": "金牛区",
    "type": "区",
    "parentId": 274
  },
  {
    "id": 2535,
    "name": "武侯区",
    "type": "区",
    "parentId": 274
  },
  {
    "id": 2536,
    "name": "成华区",
    "type": "区",
    "parentId": 274
  },
  {
    "id": 2537,
    "name": "龙泉驿区",
    "type": "区",
    "parentId": 274
  },
  {
    "id": 2538,
    "name": "青白江区",
    "type": "区",
    "parentId": 274
  },
  {
    "id": 2539,
    "name": "新都区",
    "type": "区",
    "parentId": 274
  },
  {
    "id": 2540,
    "name": "温江区",
    "type": "区",
    "parentId": 274
  },
  {
    "id": 2541,
    "name": "双流区",
    "type": "区",
    "parentId": 274
  },
  {
    "id": 2542,
    "name": "郫都区",
    "type": "区",
    "parentId": 274
  },
  {
    "id": 2543,
    "name": "金堂县",
    "type": "区",
    "parentId": 274
  },
  {
    "id": 2544,
    "name": "大邑县",
    "type": "区",
    "parentId": 274
  },
  {
    "id": 2545,
    "name": "蒲江县",
    "type": "区",
    "parentId": 274
  },
  {
    "id": 2546,
    "name": "新津县",
    "type": "区",
    "parentId": 274
  },
  {
    "id": 2547,
    "name": "都江堰市",
    "type": "区",
    "parentId": 274
  },
  {
    "id": 2548,
    "name": "彭州市",
    "type": "区",
    "parentId": 274
  },
  {
    "id": 2549,
    "name": "邛崃市",
    "type": "区",
    "parentId": 274
  },
  {
    "id": 2550,
    "name": "崇州市",
    "type": "区",
    "parentId": 274
  },
  {
    "id": 2551,
    "name": "简阳市",
    "type": "区",
    "parentId": 274
  },
  {
    "id": 2552,
    "name": "高新区",
    "type": "区",
    "parentId": 274
  },
  {
    "id": 2553,
    "name": "自流井区",
    "type": "区",
    "parentId": 275
  },
  {
    "id": 2554,
    "name": "贡井区",
    "type": "区",
    "parentId": 275
  },
  {
    "id": 2555,
    "name": "大安区",
    "type": "区",
    "parentId": 275
  },
  {
    "id": 2556,
    "name": "沿滩区",
    "type": "区",
    "parentId": 275
  },
  {
    "id": 2557,
    "name": "荣县",
    "type": "区",
    "parentId": 275
  },
  {
    "id": 2558,
    "name": "富顺县",
    "type": "区",
    "parentId": 275
  },
  {
    "id": 2559,
    "name": "东区",
    "type": "区",
    "parentId": 276
  },
  {
    "id": 2560,
    "name": "西区",
    "type": "区",
    "parentId": 276
  },
  {
    "id": 2561,
    "name": "仁和区",
    "type": "区",
    "parentId": 276
  },
  {
    "id": 2562,
    "name": "米易县",
    "type": "区",
    "parentId": 276
  },
  {
    "id": 2563,
    "name": "盐边县",
    "type": "区",
    "parentId": 276
  },
  {
    "id": 2564,
    "name": "江阳区",
    "type": "区",
    "parentId": 277
  },
  {
    "id": 2565,
    "name": "纳溪区",
    "type": "区",
    "parentId": 277
  },
  {
    "id": 2566,
    "name": "龙马潭区",
    "type": "区",
    "parentId": 277
  },
  {
    "id": 2567,
    "name": "泸县",
    "type": "区",
    "parentId": 277
  },
  {
    "id": 2568,
    "name": "合江县",
    "type": "区",
    "parentId": 277
  },
  {
    "id": 2569,
    "name": "叙永县",
    "type": "区",
    "parentId": 277
  },
  {
    "id": 2570,
    "name": "古蔺县",
    "type": "区",
    "parentId": 277
  },
  {
    "id": 2571,
    "name": "旌阳区",
    "type": "区",
    "parentId": 278
  },
  {
    "id": 2572,
    "name": "罗江区",
    "type": "区",
    "parentId": 278
  },
  {
    "id": 2573,
    "name": "中江县",
    "type": "区",
    "parentId": 278
  },
  {
    "id": 2574,
    "name": "广汉市",
    "type": "区",
    "parentId": 278
  },
  {
    "id": 2575,
    "name": "什邡市",
    "type": "区",
    "parentId": 278
  },
  {
    "id": 2576,
    "name": "绵竹市",
    "type": "区",
    "parentId": 278
  },
  {
    "id": 2577,
    "name": "涪城区",
    "type": "区",
    "parentId": 279
  },
  {
    "id": 2578,
    "name": "游仙区",
    "type": "区",
    "parentId": 279
  },
  {
    "id": 2579,
    "name": "安州区",
    "type": "区",
    "parentId": 279
  },
  {
    "id": 2580,
    "name": "三台县",
    "type": "区",
    "parentId": 279
  },
  {
    "id": 2581,
    "name": "盐亭县",
    "type": "区",
    "parentId": 279
  },
  {
    "id": 2582,
    "name": "梓潼县",
    "type": "区",
    "parentId": 279
  },
  {
    "id": 2583,
    "name": "北川羌族自治县",
    "type": "区",
    "parentId": 279
  },
  {
    "id": 2584,
    "name": "平武县",
    "type": "区",
    "parentId": 279
  },
  {
    "id": 2585,
    "name": "江油市",
    "type": "区",
    "parentId": 279
  },
  {
    "id": 2586,
    "name": "高新区",
    "type": "区",
    "parentId": 279
  },
  {
    "id": 2587,
    "name": "利州区",
    "type": "区",
    "parentId": 280
  },
  {
    "id": 2588,
    "name": "昭化区",
    "type": "区",
    "parentId": 280
  },
  {
    "id": 2589,
    "name": "朝天区",
    "type": "区",
    "parentId": 280
  },
  {
    "id": 2590,
    "name": "旺苍县",
    "type": "区",
    "parentId": 280
  },
  {
    "id": 2591,
    "name": "青川县",
    "type": "区",
    "parentId": 280
  },
  {
    "id": 2592,
    "name": "剑阁县",
    "type": "区",
    "parentId": 280
  },
  {
    "id": 2593,
    "name": "苍溪县",
    "type": "区",
    "parentId": 280
  },
  {
    "id": 2594,
    "name": "船山区",
    "type": "区",
    "parentId": 281
  },
  {
    "id": 2595,
    "name": "安居区",
    "type": "区",
    "parentId": 281
  },
  {
    "id": 2596,
    "name": "蓬溪县",
    "type": "区",
    "parentId": 281
  },
  {
    "id": 2597,
    "name": "射洪县",
    "type": "区",
    "parentId": 281
  },
  {
    "id": 2598,
    "name": "大英县",
    "type": "区",
    "parentId": 281
  },
  {
    "id": 2599,
    "name": "市中区",
    "type": "区",
    "parentId": 282
  },
  {
    "id": 2600,
    "name": "东兴区",
    "type": "区",
    "parentId": 282
  },
  {
    "id": 2601,
    "name": "威远县",
    "type": "区",
    "parentId": 282
  },
  {
    "id": 2602,
    "name": "资中县",
    "type": "区",
    "parentId": 282
  },
  {
    "id": 2603,
    "name": "隆昌市",
    "type": "区",
    "parentId": 282
  },
  {
    "id": 2604,
    "name": "市中区",
    "type": "区",
    "parentId": 283
  },
  {
    "id": 2605,
    "name": "沙湾区",
    "type": "区",
    "parentId": 283
  },
  {
    "id": 2606,
    "name": "五通桥区",
    "type": "区",
    "parentId": 283
  },
  {
    "id": 2607,
    "name": "金口河区",
    "type": "区",
    "parentId": 283
  },
  {
    "id": 2608,
    "name": "犍为县",
    "type": "区",
    "parentId": 283
  },
  {
    "id": 2609,
    "name": "井研县",
    "type": "区",
    "parentId": 283
  },
  {
    "id": 2610,
    "name": "夹江县",
    "type": "区",
    "parentId": 283
  },
  {
    "id": 2611,
    "name": "沐川县",
    "type": "区",
    "parentId": 283
  },
  {
    "id": 2612,
    "name": "峨边彝族自治县",
    "type": "区",
    "parentId": 283
  },
  {
    "id": 2613,
    "name": "马边彝族自治县",
    "type": "区",
    "parentId": 283
  },
  {
    "id": 2614,
    "name": "峨眉山市",
    "type": "区",
    "parentId": 283
  },
  {
    "id": 2615,
    "name": "顺庆区",
    "type": "区",
    "parentId": 284
  },
  {
    "id": 2616,
    "name": "高坪区",
    "type": "区",
    "parentId": 284
  },
  {
    "id": 2617,
    "name": "嘉陵区",
    "type": "区",
    "parentId": 284
  },
  {
    "id": 2618,
    "name": "南部县",
    "type": "区",
    "parentId": 284
  },
  {
    "id": 2619,
    "name": "营山县",
    "type": "区",
    "parentId": 284
  },
  {
    "id": 2620,
    "name": "蓬安县",
    "type": "区",
    "parentId": 284
  },
  {
    "id": 2621,
    "name": "仪陇县",
    "type": "区",
    "parentId": 284
  },
  {
    "id": 2622,
    "name": "西充县",
    "type": "区",
    "parentId": 284
  },
  {
    "id": 2623,
    "name": "阆中市",
    "type": "区",
    "parentId": 284
  },
  {
    "id": 2624,
    "name": "东坡区",
    "type": "区",
    "parentId": 285
  },
  {
    "id": 2625,
    "name": "彭山区",
    "type": "区",
    "parentId": 285
  },
  {
    "id": 2626,
    "name": "仁寿县",
    "type": "区",
    "parentId": 285
  },
  {
    "id": 2627,
    "name": "洪雅县",
    "type": "区",
    "parentId": 285
  },
  {
    "id": 2628,
    "name": "丹棱县",
    "type": "区",
    "parentId": 285
  },
  {
    "id": 2629,
    "name": "青神县",
    "type": "区",
    "parentId": 285
  },
  {
    "id": 2630,
    "name": "翠屏区",
    "type": "区",
    "parentId": 286
  },
  {
    "id": 2631,
    "name": "南溪区",
    "type": "区",
    "parentId": 286
  },
  {
    "id": 2632,
    "name": "宜宾县",
    "type": "区",
    "parentId": 286
  },
  {
    "id": 2633,
    "name": "江安县",
    "type": "区",
    "parentId": 286
  },
  {
    "id": 2634,
    "name": "长宁县",
    "type": "区",
    "parentId": 286
  },
  {
    "id": 2635,
    "name": "高县",
    "type": "区",
    "parentId": 286
  },
  {
    "id": 2636,
    "name": "珙县",
    "type": "区",
    "parentId": 286
  },
  {
    "id": 2637,
    "name": "筠连县",
    "type": "区",
    "parentId": 286
  },
  {
    "id": 2638,
    "name": "兴文县",
    "type": "区",
    "parentId": 286
  },
  {
    "id": 2639,
    "name": "屏山县",
    "type": "区",
    "parentId": 286
  },
  {
    "id": 2640,
    "name": "广安区",
    "type": "区",
    "parentId": 287
  },
  {
    "id": 2641,
    "name": "前锋区",
    "type": "区",
    "parentId": 287
  },
  {
    "id": 2642,
    "name": "岳池县",
    "type": "区",
    "parentId": 287
  },
  {
    "id": 2643,
    "name": "武胜县",
    "type": "区",
    "parentId": 287
  },
  {
    "id": 2644,
    "name": "邻水县",
    "type": "区",
    "parentId": 287
  },
  {
    "id": 2645,
    "name": "华蓥市",
    "type": "区",
    "parentId": 287
  },
  {
    "id": 2646,
    "name": "通川区",
    "type": "区",
    "parentId": 288
  },
  {
    "id": 2647,
    "name": "达川区",
    "type": "区",
    "parentId": 288
  },
  {
    "id": 2648,
    "name": "宣汉县",
    "type": "区",
    "parentId": 288
  },
  {
    "id": 2649,
    "name": "开江县",
    "type": "区",
    "parentId": 288
  },
  {
    "id": 2650,
    "name": "大竹县",
    "type": "区",
    "parentId": 288
  },
  {
    "id": 2651,
    "name": "渠县",
    "type": "区",
    "parentId": 288
  },
  {
    "id": 2652,
    "name": "万源市",
    "type": "区",
    "parentId": 288
  },
  {
    "id": 2653,
    "name": "雨城区",
    "type": "区",
    "parentId": 289
  },
  {
    "id": 2654,
    "name": "名山区",
    "type": "区",
    "parentId": 289
  },
  {
    "id": 2655,
    "name": "荥经县",
    "type": "区",
    "parentId": 289
  },
  {
    "id": 2656,
    "name": "汉源县",
    "type": "区",
    "parentId": 289
  },
  {
    "id": 2657,
    "name": "石棉县",
    "type": "区",
    "parentId": 289
  },
  {
    "id": 2658,
    "name": "天全县",
    "type": "区",
    "parentId": 289
  },
  {
    "id": 2659,
    "name": "芦山县",
    "type": "区",
    "parentId": 289
  },
  {
    "id": 2660,
    "name": "宝兴县",
    "type": "区",
    "parentId": 289
  },
  {
    "id": 2661,
    "name": "巴州区",
    "type": "区",
    "parentId": 290
  },
  {
    "id": 2662,
    "name": "恩阳区",
    "type": "区",
    "parentId": 290
  },
  {
    "id": 2663,
    "name": "通江县",
    "type": "区",
    "parentId": 290
  },
  {
    "id": 2664,
    "name": "南江县",
    "type": "区",
    "parentId": 290
  },
  {
    "id": 2665,
    "name": "平昌县",
    "type": "区",
    "parentId": 290
  },
  {
    "id": 2666,
    "name": "雁江区",
    "type": "区",
    "parentId": 291
  },
  {
    "id": 2667,
    "name": "安岳县",
    "type": "区",
    "parentId": 291
  },
  {
    "id": 2668,
    "name": "乐至县",
    "type": "区",
    "parentId": 291
  },
  {
    "id": 2669,
    "name": "马尔康市",
    "type": "区",
    "parentId": 292
  },
  {
    "id": 2670,
    "name": "汶川县",
    "type": "区",
    "parentId": 292
  },
  {
    "id": 2671,
    "name": "理县",
    "type": "区",
    "parentId": 292
  },
  {
    "id": 2672,
    "name": "茂县",
    "type": "区",
    "parentId": 292
  },
  {
    "id": 2673,
    "name": "松潘县",
    "type": "区",
    "parentId": 292
  },
  {
    "id": 2674,
    "name": "九寨沟县",
    "type": "区",
    "parentId": 292
  },
  {
    "id": 2675,
    "name": "金川县",
    "type": "区",
    "parentId": 292
  },
  {
    "id": 2676,
    "name": "小金县",
    "type": "区",
    "parentId": 292
  },
  {
    "id": 2677,
    "name": "黑水县",
    "type": "区",
    "parentId": 292
  },
  {
    "id": 2678,
    "name": "壤塘县",
    "type": "区",
    "parentId": 292
  },
  {
    "id": 2679,
    "name": "阿坝县",
    "type": "区",
    "parentId": 292
  },
  {
    "id": 2680,
    "name": "若尔盖县",
    "type": "区",
    "parentId": 292
  },
  {
    "id": 2681,
    "name": "红原县",
    "type": "区",
    "parentId": 292
  },
  {
    "id": 2682,
    "name": "康定市",
    "type": "区",
    "parentId": 293
  },
  {
    "id": 2683,
    "name": "泸定县",
    "type": "区",
    "parentId": 293
  },
  {
    "id": 2684,
    "name": "丹巴县",
    "type": "区",
    "parentId": 293
  },
  {
    "id": 2685,
    "name": "九龙县",
    "type": "区",
    "parentId": 293
  },
  {
    "id": 2686,
    "name": "雅江县",
    "type": "区",
    "parentId": 293
  },
  {
    "id": 2687,
    "name": "道孚县",
    "type": "区",
    "parentId": 293
  },
  {
    "id": 2688,
    "name": "炉霍县",
    "type": "区",
    "parentId": 293
  },
  {
    "id": 2689,
    "name": "甘孜县",
    "type": "区",
    "parentId": 293
  },
  {
    "id": 2690,
    "name": "新龙县",
    "type": "区",
    "parentId": 293
  },
  {
    "id": 2691,
    "name": "德格县",
    "type": "区",
    "parentId": 293
  },
  {
    "id": 2692,
    "name": "白玉县",
    "type": "区",
    "parentId": 293
  },
  {
    "id": 2693,
    "name": "石渠县",
    "type": "区",
    "parentId": 293
  },
  {
    "id": 2694,
    "name": "色达县",
    "type": "区",
    "parentId": 293
  },
  {
    "id": 2695,
    "name": "理塘县",
    "type": "区",
    "parentId": 293
  },
  {
    "id": 2696,
    "name": "巴塘县",
    "type": "区",
    "parentId": 293
  },
  {
    "id": 2697,
    "name": "乡城县",
    "type": "区",
    "parentId": 293
  },
  {
    "id": 2698,
    "name": "稻城县",
    "type": "区",
    "parentId": 293
  },
  {
    "id": 2699,
    "name": "得荣县",
    "type": "区",
    "parentId": 293
  },
  {
    "id": 2700,
    "name": "西昌市",
    "type": "区",
    "parentId": 294
  },
  {
    "id": 2701,
    "name": "木里藏族自治县",
    "type": "区",
    "parentId": 294
  },
  {
    "id": 2702,
    "name": "盐源县",
    "type": "区",
    "parentId": 294
  },
  {
    "id": 2703,
    "name": "德昌县",
    "type": "区",
    "parentId": 294
  },
  {
    "id": 2704,
    "name": "会理县",
    "type": "区",
    "parentId": 294
  },
  {
    "id": 2705,
    "name": "会东县",
    "type": "区",
    "parentId": 294
  },
  {
    "id": 2706,
    "name": "宁南县",
    "type": "区",
    "parentId": 294
  },
  {
    "id": 2707,
    "name": "普格县",
    "type": "区",
    "parentId": 294
  },
  {
    "id": 2708,
    "name": "布拖县",
    "type": "区",
    "parentId": 294
  },
  {
    "id": 2709,
    "name": "金阳县",
    "type": "区",
    "parentId": 294
  },
  {
    "id": 2710,
    "name": "昭觉县",
    "type": "区",
    "parentId": 294
  },
  {
    "id": 2711,
    "name": "喜德县",
    "type": "区",
    "parentId": 294
  },
  {
    "id": 2712,
    "name": "冕宁县",
    "type": "区",
    "parentId": 294
  },
  {
    "id": 2713,
    "name": "越西县",
    "type": "区",
    "parentId": 294
  },
  {
    "id": 2714,
    "name": "甘洛县",
    "type": "区",
    "parentId": 294
  },
  {
    "id": 2715,
    "name": "美姑县",
    "type": "区",
    "parentId": 294
  },
  {
    "id": 2716,
    "name": "雷波县",
    "type": "区",
    "parentId": 294
  },
  {
    "id": 2717,
    "name": "南明区",
    "type": "区",
    "parentId": 295
  },
  {
    "id": 2718,
    "name": "云岩区",
    "type": "区",
    "parentId": 295
  },
  {
    "id": 2719,
    "name": "花溪区",
    "type": "区",
    "parentId": 295
  },
  {
    "id": 2720,
    "name": "乌当区",
    "type": "区",
    "parentId": 295
  },
  {
    "id": 2721,
    "name": "白云区",
    "type": "区",
    "parentId": 295
  },
  {
    "id": 2722,
    "name": "观山湖区",
    "type": "区",
    "parentId": 295
  },
  {
    "id": 2723,
    "name": "开阳县",
    "type": "区",
    "parentId": 295
  },
  {
    "id": 2724,
    "name": "息烽县",
    "type": "区",
    "parentId": 295
  },
  {
    "id": 2725,
    "name": "修文县",
    "type": "区",
    "parentId": 295
  },
  {
    "id": 2726,
    "name": "清镇市",
    "type": "区",
    "parentId": 295
  },
  {
    "id": 2727,
    "name": "钟山区",
    "type": "区",
    "parentId": 296
  },
  {
    "id": 2728,
    "name": "六枝特区",
    "type": "区",
    "parentId": 296
  },
  {
    "id": 2729,
    "name": "水城县",
    "type": "区",
    "parentId": 296
  },
  {
    "id": 2730,
    "name": "盘州市",
    "type": "区",
    "parentId": 296
  },
  {
    "id": 2731,
    "name": "红花岗区",
    "type": "区",
    "parentId": 297
  },
  {
    "id": 2732,
    "name": "汇川区",
    "type": "区",
    "parentId": 297
  },
  {
    "id": 2733,
    "name": "播州区",
    "type": "区",
    "parentId": 297
  },
  {
    "id": 2734,
    "name": "桐梓县",
    "type": "区",
    "parentId": 297
  },
  {
    "id": 2735,
    "name": "绥阳县",
    "type": "区",
    "parentId": 297
  },
  {
    "id": 2736,
    "name": "正安县",
    "type": "区",
    "parentId": 297
  },
  {
    "id": 2737,
    "name": "道真仡佬族苗族自治县",
    "type": "区",
    "parentId": 297
  },
  {
    "id": 2738,
    "name": "务川仡佬族苗族自治县",
    "type": "区",
    "parentId": 297
  },
  {
    "id": 2739,
    "name": "凤冈县",
    "type": "区",
    "parentId": 297
  },
  {
    "id": 2740,
    "name": "湄潭县",
    "type": "区",
    "parentId": 297
  },
  {
    "id": 2741,
    "name": "余庆县",
    "type": "区",
    "parentId": 297
  },
  {
    "id": 2742,
    "name": "习水县",
    "type": "区",
    "parentId": 297
  },
  {
    "id": 2743,
    "name": "赤水市",
    "type": "区",
    "parentId": 297
  },
  {
    "id": 2744,
    "name": "仁怀市",
    "type": "区",
    "parentId": 297
  },
  {
    "id": 2745,
    "name": "西秀区",
    "type": "区",
    "parentId": 298
  },
  {
    "id": 2746,
    "name": "平坝区",
    "type": "区",
    "parentId": 298
  },
  {
    "id": 2747,
    "name": "普定县",
    "type": "区",
    "parentId": 298
  },
  {
    "id": 2748,
    "name": "镇宁布依族苗族自治县",
    "type": "区",
    "parentId": 298
  },
  {
    "id": 2749,
    "name": "关岭布依族苗族自治县",
    "type": "区",
    "parentId": 298
  },
  {
    "id": 2750,
    "name": "紫云苗族布依族自治县",
    "type": "区",
    "parentId": 298
  },
  {
    "id": 2751,
    "name": "七星关区",
    "type": "区",
    "parentId": 299
  },
  {
    "id": 2752,
    "name": "大方县",
    "type": "区",
    "parentId": 299
  },
  {
    "id": 2753,
    "name": "黔西县",
    "type": "区",
    "parentId": 299
  },
  {
    "id": 2754,
    "name": "金沙县",
    "type": "区",
    "parentId": 299
  },
  {
    "id": 2755,
    "name": "织金县",
    "type": "区",
    "parentId": 299
  },
  {
    "id": 2756,
    "name": "纳雍县",
    "type": "区",
    "parentId": 299
  },
  {
    "id": 2757,
    "name": "威宁彝族回族苗族自治县",
    "type": "区",
    "parentId": 299
  },
  {
    "id": 2758,
    "name": "赫章县",
    "type": "区",
    "parentId": 299
  },
  {
    "id": 2759,
    "name": "碧江区",
    "type": "区",
    "parentId": 300
  },
  {
    "id": 2760,
    "name": "万山区",
    "type": "区",
    "parentId": 300
  },
  {
    "id": 2761,
    "name": "江口县",
    "type": "区",
    "parentId": 300
  },
  {
    "id": 2762,
    "name": "玉屏侗族自治县",
    "type": "区",
    "parentId": 300
  },
  {
    "id": 2763,
    "name": "石阡县",
    "type": "区",
    "parentId": 300
  },
  {
    "id": 2764,
    "name": "思南县",
    "type": "区",
    "parentId": 300
  },
  {
    "id": 2765,
    "name": "印江土家族苗族自治县",
    "type": "区",
    "parentId": 300
  },
  {
    "id": 2766,
    "name": "德江县",
    "type": "区",
    "parentId": 300
  },
  {
    "id": 2767,
    "name": "沿河土家族自治县",
    "type": "区",
    "parentId": 300
  },
  {
    "id": 2768,
    "name": "松桃苗族自治县",
    "type": "区",
    "parentId": 300
  },
  {
    "id": 2769,
    "name": "兴义市",
    "type": "区",
    "parentId": 301
  },
  {
    "id": 2770,
    "name": "兴仁县",
    "type": "区",
    "parentId": 301
  },
  {
    "id": 2771,
    "name": "普安县",
    "type": "区",
    "parentId": 301
  },
  {
    "id": 2772,
    "name": "晴隆县",
    "type": "区",
    "parentId": 301
  },
  {
    "id": 2773,
    "name": "贞丰县",
    "type": "区",
    "parentId": 301
  },
  {
    "id": 2774,
    "name": "望谟县",
    "type": "区",
    "parentId": 301
  },
  {
    "id": 2775,
    "name": "册亨县",
    "type": "区",
    "parentId": 301
  },
  {
    "id": 2776,
    "name": "安龙县",
    "type": "区",
    "parentId": 301
  },
  {
    "id": 2777,
    "name": "凯里市",
    "type": "区",
    "parentId": 302
  },
  {
    "id": 2778,
    "name": "黄平县",
    "type": "区",
    "parentId": 302
  },
  {
    "id": 2779,
    "name": "施秉县",
    "type": "区",
    "parentId": 302
  },
  {
    "id": 2780,
    "name": "三穗县",
    "type": "区",
    "parentId": 302
  },
  {
    "id": 2781,
    "name": "镇远县",
    "type": "区",
    "parentId": 302
  },
  {
    "id": 2782,
    "name": "岑巩县",
    "type": "区",
    "parentId": 302
  },
  {
    "id": 2783,
    "name": "天柱县",
    "type": "区",
    "parentId": 302
  },
  {
    "id": 2784,
    "name": "锦屏县",
    "type": "区",
    "parentId": 302
  },
  {
    "id": 2785,
    "name": "剑河县",
    "type": "区",
    "parentId": 302
  },
  {
    "id": 2786,
    "name": "台江县",
    "type": "区",
    "parentId": 302
  },
  {
    "id": 2787,
    "name": "黎平县",
    "type": "区",
    "parentId": 302
  },
  {
    "id": 2788,
    "name": "榕江县",
    "type": "区",
    "parentId": 302
  },
  {
    "id": 2789,
    "name": "从江县",
    "type": "区",
    "parentId": 302
  },
  {
    "id": 2790,
    "name": "雷山县",
    "type": "区",
    "parentId": 302
  },
  {
    "id": 2791,
    "name": "麻江县",
    "type": "区",
    "parentId": 302
  },
  {
    "id": 2792,
    "name": "丹寨县",
    "type": "区",
    "parentId": 302
  },
  {
    "id": 2793,
    "name": "都匀市",
    "type": "区",
    "parentId": 303
  },
  {
    "id": 2794,
    "name": "福泉市",
    "type": "区",
    "parentId": 303
  },
  {
    "id": 2795,
    "name": "荔波县",
    "type": "区",
    "parentId": 303
  },
  {
    "id": 2796,
    "name": "贵定县",
    "type": "区",
    "parentId": 303
  },
  {
    "id": 2797,
    "name": "瓮安县",
    "type": "区",
    "parentId": 303
  },
  {
    "id": 2798,
    "name": "独山县",
    "type": "区",
    "parentId": 303
  },
  {
    "id": 2799,
    "name": "平塘县",
    "type": "区",
    "parentId": 303
  },
  {
    "id": 2800,
    "name": "罗甸县",
    "type": "区",
    "parentId": 303
  },
  {
    "id": 2801,
    "name": "长顺县",
    "type": "区",
    "parentId": 303
  },
  {
    "id": 2802,
    "name": "龙里县",
    "type": "区",
    "parentId": 303
  },
  {
    "id": 2803,
    "name": "惠水县",
    "type": "区",
    "parentId": 303
  },
  {
    "id": 2804,
    "name": "三都水族自治县",
    "type": "区",
    "parentId": 303
  },
  {
    "id": 2805,
    "name": "五华区",
    "type": "区",
    "parentId": 304
  },
  {
    "id": 2806,
    "name": "盘龙区",
    "type": "区",
    "parentId": 304
  },
  {
    "id": 2807,
    "name": "官渡区",
    "type": "区",
    "parentId": 304
  },
  {
    "id": 2808,
    "name": "西山区",
    "type": "区",
    "parentId": 304
  },
  {
    "id": 2809,
    "name": "东川区",
    "type": "区",
    "parentId": 304
  },
  {
    "id": 2810,
    "name": "呈贡区",
    "type": "区",
    "parentId": 304
  },
  {
    "id": 2811,
    "name": "晋宁区",
    "type": "区",
    "parentId": 304
  },
  {
    "id": 2812,
    "name": "富民县",
    "type": "区",
    "parentId": 304
  },
  {
    "id": 2813,
    "name": "宜良县",
    "type": "区",
    "parentId": 304
  },
  {
    "id": 2814,
    "name": "石林彝族自治县",
    "type": "区",
    "parentId": 304
  },
  {
    "id": 2815,
    "name": "嵩明县",
    "type": "区",
    "parentId": 304
  },
  {
    "id": 2816,
    "name": "禄劝彝族苗族自治县",
    "type": "区",
    "parentId": 304
  },
  {
    "id": 2817,
    "name": "寻甸回族彝族自治县",
    "type": "区",
    "parentId": 304
  },
  {
    "id": 2818,
    "name": "安宁市",
    "type": "区",
    "parentId": 304
  },
  {
    "id": 2819,
    "name": "麒麟区",
    "type": "区",
    "parentId": 305
  },
  {
    "id": 2820,
    "name": "沾益区",
    "type": "区",
    "parentId": 305
  },
  {
    "id": 2821,
    "name": "马龙县",
    "type": "区",
    "parentId": 305
  },
  {
    "id": 2822,
    "name": "陆良县",
    "type": "区",
    "parentId": 305
  },
  {
    "id": 2823,
    "name": "师宗县",
    "type": "区",
    "parentId": 305
  },
  {
    "id": 2824,
    "name": "罗平县",
    "type": "区",
    "parentId": 305
  },
  {
    "id": 2825,
    "name": "富源县",
    "type": "区",
    "parentId": 305
  },
  {
    "id": 2826,
    "name": "会泽县",
    "type": "区",
    "parentId": 305
  },
  {
    "id": 2827,
    "name": "宣威市",
    "type": "区",
    "parentId": 305
  },
  {
    "id": 2828,
    "name": "红塔区",
    "type": "区",
    "parentId": 306
  },
  {
    "id": 2829,
    "name": "江川区",
    "type": "区",
    "parentId": 306
  },
  {
    "id": 2830,
    "name": "澄江县",
    "type": "区",
    "parentId": 306
  },
  {
    "id": 2831,
    "name": "通海县",
    "type": "区",
    "parentId": 306
  },
  {
    "id": 2832,
    "name": "华宁县",
    "type": "区",
    "parentId": 306
  },
  {
    "id": 2833,
    "name": "易门县",
    "type": "区",
    "parentId": 306
  },
  {
    "id": 2834,
    "name": "峨山彝族自治县",
    "type": "区",
    "parentId": 306
  },
  {
    "id": 2835,
    "name": "新平彝族傣族自治县",
    "type": "区",
    "parentId": 306
  },
  {
    "id": 2836,
    "name": "元江哈尼族彝族傣族自治县",
    "type": "区",
    "parentId": 306
  },
  {
    "id": 2837,
    "name": "隆阳区",
    "type": "区",
    "parentId": 307
  },
  {
    "id": 2838,
    "name": "施甸县",
    "type": "区",
    "parentId": 307
  },
  {
    "id": 2839,
    "name": "龙陵县",
    "type": "区",
    "parentId": 307
  },
  {
    "id": 2840,
    "name": "昌宁县",
    "type": "区",
    "parentId": 307
  },
  {
    "id": 2841,
    "name": "腾冲市",
    "type": "区",
    "parentId": 307
  },
  {
    "id": 2842,
    "name": "昭阳区",
    "type": "区",
    "parentId": 308
  },
  {
    "id": 2843,
    "name": "鲁甸县",
    "type": "区",
    "parentId": 308
  },
  {
    "id": 2844,
    "name": "巧家县",
    "type": "区",
    "parentId": 308
  },
  {
    "id": 2845,
    "name": "盐津县",
    "type": "区",
    "parentId": 308
  },
  {
    "id": 2846,
    "name": "大关县",
    "type": "区",
    "parentId": 308
  },
  {
    "id": 2847,
    "name": "永善县",
    "type": "区",
    "parentId": 308
  },
  {
    "id": 2848,
    "name": "绥江县",
    "type": "区",
    "parentId": 308
  },
  {
    "id": 2849,
    "name": "镇雄县",
    "type": "区",
    "parentId": 308
  },
  {
    "id": 2850,
    "name": "彝良县",
    "type": "区",
    "parentId": 308
  },
  {
    "id": 2851,
    "name": "威信县",
    "type": "区",
    "parentId": 308
  },
  {
    "id": 2852,
    "name": "水富县",
    "type": "区",
    "parentId": 308
  },
  {
    "id": 2853,
    "name": "古城区",
    "type": "区",
    "parentId": 309
  },
  {
    "id": 2854,
    "name": "玉龙纳西族自治县",
    "type": "区",
    "parentId": 309
  },
  {
    "id": 2855,
    "name": "永胜县",
    "type": "区",
    "parentId": 309
  },
  {
    "id": 2856,
    "name": "华坪县",
    "type": "区",
    "parentId": 309
  },
  {
    "id": 2857,
    "name": "宁蒗彝族自治县",
    "type": "区",
    "parentId": 309
  },
  {
    "id": 2858,
    "name": "思茅区",
    "type": "区",
    "parentId": 310
  },
  {
    "id": 2859,
    "name": "宁洱哈尼族彝族自治县",
    "type": "区",
    "parentId": 310
  },
  {
    "id": 2860,
    "name": "墨江哈尼族自治县",
    "type": "区",
    "parentId": 310
  },
  {
    "id": 2861,
    "name": "景东彝族自治县",
    "type": "区",
    "parentId": 310
  },
  {
    "id": 2862,
    "name": "景谷傣族彝族自治县",
    "type": "区",
    "parentId": 310
  },
  {
    "id": 2863,
    "name": "镇沅彝族哈尼族拉祜族自治县",
    "type": "区",
    "parentId": 310
  },
  {
    "id": 2864,
    "name": "江城哈尼族彝族自治县",
    "type": "区",
    "parentId": 310
  },
  {
    "id": 2865,
    "name": "孟连傣族拉祜族佤族自治县",
    "type": "区",
    "parentId": 310
  },
  {
    "id": 2866,
    "name": "澜沧拉祜族自治县",
    "type": "区",
    "parentId": 310
  },
  {
    "id": 2867,
    "name": "西盟佤族自治县",
    "type": "区",
    "parentId": 310
  },
  {
    "id": 2868,
    "name": "临翔区",
    "type": "区",
    "parentId": 311
  },
  {
    "id": 2869,
    "name": "凤庆县",
    "type": "区",
    "parentId": 311
  },
  {
    "id": 2870,
    "name": "云县",
    "type": "区",
    "parentId": 311
  },
  {
    "id": 2871,
    "name": "永德县",
    "type": "区",
    "parentId": 311
  },
  {
    "id": 2872,
    "name": "镇康县",
    "type": "区",
    "parentId": 311
  },
  {
    "id": 2873,
    "name": "双江拉祜族佤族布朗族傣族自治县",
    "type": "区",
    "parentId": 311
  },
  {
    "id": 2874,
    "name": "耿马傣族佤族自治县",
    "type": "区",
    "parentId": 311
  },
  {
    "id": 2875,
    "name": "沧源佤族自治县",
    "type": "区",
    "parentId": 311
  },
  {
    "id": 2876,
    "name": "楚雄市",
    "type": "区",
    "parentId": 312
  },
  {
    "id": 2877,
    "name": "双柏县",
    "type": "区",
    "parentId": 312
  },
  {
    "id": 2878,
    "name": "牟定县",
    "type": "区",
    "parentId": 312
  },
  {
    "id": 2879,
    "name": "南华县",
    "type": "区",
    "parentId": 312
  },
  {
    "id": 2880,
    "name": "姚安县",
    "type": "区",
    "parentId": 312
  },
  {
    "id": 2881,
    "name": "大姚县",
    "type": "区",
    "parentId": 312
  },
  {
    "id": 2882,
    "name": "永仁县",
    "type": "区",
    "parentId": 312
  },
  {
    "id": 2883,
    "name": "元谋县",
    "type": "区",
    "parentId": 312
  },
  {
    "id": 2884,
    "name": "武定县",
    "type": "区",
    "parentId": 312
  },
  {
    "id": 2885,
    "name": "禄丰县",
    "type": "区",
    "parentId": 312
  },
  {
    "id": 2886,
    "name": "个旧市",
    "type": "区",
    "parentId": 313
  },
  {
    "id": 2887,
    "name": "开远市",
    "type": "区",
    "parentId": 313
  },
  {
    "id": 2888,
    "name": "蒙自市",
    "type": "区",
    "parentId": 313
  },
  {
    "id": 2889,
    "name": "弥勒市",
    "type": "区",
    "parentId": 313
  },
  {
    "id": 2890,
    "name": "屏边苗族自治县",
    "type": "区",
    "parentId": 313
  },
  {
    "id": 2891,
    "name": "建水县",
    "type": "区",
    "parentId": 313
  },
  {
    "id": 2892,
    "name": "石屏县",
    "type": "区",
    "parentId": 313
  },
  {
    "id": 2893,
    "name": "泸西县",
    "type": "区",
    "parentId": 313
  },
  {
    "id": 2894,
    "name": "元阳县",
    "type": "区",
    "parentId": 313
  },
  {
    "id": 2895,
    "name": "红河县",
    "type": "区",
    "parentId": 313
  },
  {
    "id": 2896,
    "name": "金平苗族瑶族傣族自治县",
    "type": "区",
    "parentId": 313
  },
  {
    "id": 2897,
    "name": "绿春县",
    "type": "区",
    "parentId": 313
  },
  {
    "id": 2898,
    "name": "河口瑶族自治县",
    "type": "区",
    "parentId": 313
  },
  {
    "id": 2899,
    "name": "文山市",
    "type": "区",
    "parentId": 314
  },
  {
    "id": 2900,
    "name": "砚山县",
    "type": "区",
    "parentId": 314
  },
  {
    "id": 2901,
    "name": "西畴县",
    "type": "区",
    "parentId": 314
  },
  {
    "id": 2902,
    "name": "麻栗坡县",
    "type": "区",
    "parentId": 314
  },
  {
    "id": 2903,
    "name": "马关县",
    "type": "区",
    "parentId": 314
  },
  {
    "id": 2904,
    "name": "丘北县",
    "type": "区",
    "parentId": 314
  },
  {
    "id": 2905,
    "name": "广南县",
    "type": "区",
    "parentId": 314
  },
  {
    "id": 2906,
    "name": "富宁县",
    "type": "区",
    "parentId": 314
  },
  {
    "id": 2907,
    "name": "景洪市",
    "type": "区",
    "parentId": 315
  },
  {
    "id": 2908,
    "name": "勐海县",
    "type": "区",
    "parentId": 315
  },
  {
    "id": 2909,
    "name": "勐腊县",
    "type": "区",
    "parentId": 315
  },
  {
    "id": 2910,
    "name": "大理市",
    "type": "区",
    "parentId": 316
  },
  {
    "id": 2911,
    "name": "漾濞彝族自治县",
    "type": "区",
    "parentId": 316
  },
  {
    "id": 2912,
    "name": "祥云县",
    "type": "区",
    "parentId": 316
  },
  {
    "id": 2913,
    "name": "宾川县",
    "type": "区",
    "parentId": 316
  },
  {
    "id": 2914,
    "name": "弥渡县",
    "type": "区",
    "parentId": 316
  },
  {
    "id": 2915,
    "name": "南涧彝族自治县",
    "type": "区",
    "parentId": 316
  },
  {
    "id": 2916,
    "name": "巍山彝族回族自治县",
    "type": "区",
    "parentId": 316
  },
  {
    "id": 2917,
    "name": "永平县",
    "type": "区",
    "parentId": 316
  },
  {
    "id": 2918,
    "name": "云龙县",
    "type": "区",
    "parentId": 316
  },
  {
    "id": 2919,
    "name": "洱源县",
    "type": "区",
    "parentId": 316
  },
  {
    "id": 2920,
    "name": "剑川县",
    "type": "区",
    "parentId": 316
  },
  {
    "id": 2921,
    "name": "鹤庆县",
    "type": "区",
    "parentId": 316
  },
  {
    "id": 2922,
    "name": "瑞丽市",
    "type": "区",
    "parentId": 317
  },
  {
    "id": 2923,
    "name": "芒市",
    "type": "区",
    "parentId": 317
  },
  {
    "id": 2924,
    "name": "梁河县",
    "type": "区",
    "parentId": 317
  },
  {
    "id": 2925,
    "name": "盈江县",
    "type": "区",
    "parentId": 317
  },
  {
    "id": 2926,
    "name": "陇川县",
    "type": "区",
    "parentId": 317
  },
  {
    "id": 2927,
    "name": "泸水市",
    "type": "区",
    "parentId": 318
  },
  {
    "id": 2928,
    "name": "福贡县",
    "type": "区",
    "parentId": 318
  },
  {
    "id": 2929,
    "name": "贡山独龙族怒族自治县",
    "type": "区",
    "parentId": 318
  },
  {
    "id": 2930,
    "name": "兰坪白族普米族自治县",
    "type": "区",
    "parentId": 318
  },
  {
    "id": 2931,
    "name": "香格里拉市",
    "type": "区",
    "parentId": 319
  },
  {
    "id": 2932,
    "name": "德钦县",
    "type": "区",
    "parentId": 319
  },
  {
    "id": 2933,
    "name": "维西傈僳族自治县",
    "type": "区",
    "parentId": 319
  },
  {
    "id": 2934,
    "name": "城关区",
    "type": "区",
    "parentId": 320
  },
  {
    "id": 2935,
    "name": "堆龙德庆区",
    "type": "区",
    "parentId": 320
  },
  {
    "id": 2936,
    "name": "达孜区",
    "type": "区",
    "parentId": 320
  },
  {
    "id": 2937,
    "name": "林周县",
    "type": "区",
    "parentId": 320
  },
  {
    "id": 2938,
    "name": "当雄县",
    "type": "区",
    "parentId": 320
  },
  {
    "id": 2939,
    "name": "尼木县",
    "type": "区",
    "parentId": 320
  },
  {
    "id": 2940,
    "name": "曲水县",
    "type": "区",
    "parentId": 320
  },
  {
    "id": 2941,
    "name": "墨竹工卡县",
    "type": "区",
    "parentId": 320
  },
  {
    "id": 2942,
    "name": "桑珠孜区",
    "type": "区",
    "parentId": 321
  },
  {
    "id": 2943,
    "name": "南木林县",
    "type": "区",
    "parentId": 321
  },
  {
    "id": 2944,
    "name": "江孜县",
    "type": "区",
    "parentId": 321
  },
  {
    "id": 2945,
    "name": "定日县",
    "type": "区",
    "parentId": 321
  },
  {
    "id": 2946,
    "name": "萨迦县",
    "type": "区",
    "parentId": 321
  },
  {
    "id": 2947,
    "name": "拉孜县",
    "type": "区",
    "parentId": 321
  },
  {
    "id": 2948,
    "name": "昂仁县",
    "type": "区",
    "parentId": 321
  },
  {
    "id": 2949,
    "name": "谢通门县",
    "type": "区",
    "parentId": 321
  },
  {
    "id": 2950,
    "name": "白朗县",
    "type": "区",
    "parentId": 321
  },
  {
    "id": 2951,
    "name": "仁布县",
    "type": "区",
    "parentId": 321
  },
  {
    "id": 2952,
    "name": "康马县",
    "type": "区",
    "parentId": 321
  },
  {
    "id": 2953,
    "name": "定结县",
    "type": "区",
    "parentId": 321
  },
  {
    "id": 2954,
    "name": "仲巴县",
    "type": "区",
    "parentId": 321
  },
  {
    "id": 2955,
    "name": "亚东县",
    "type": "区",
    "parentId": 321
  },
  {
    "id": 2956,
    "name": "吉隆县",
    "type": "区",
    "parentId": 321
  },
  {
    "id": 2957,
    "name": "聂拉木县",
    "type": "区",
    "parentId": 321
  },
  {
    "id": 2958,
    "name": "萨嘎县",
    "type": "区",
    "parentId": 321
  },
  {
    "id": 2959,
    "name": "岗巴县",
    "type": "区",
    "parentId": 321
  },
  {
    "id": 2960,
    "name": "卡若区",
    "type": "区",
    "parentId": 322
  },
  {
    "id": 2961,
    "name": "江达县",
    "type": "区",
    "parentId": 322
  },
  {
    "id": 2962,
    "name": "贡觉县",
    "type": "区",
    "parentId": 322
  },
  {
    "id": 2963,
    "name": "类乌齐县",
    "type": "区",
    "parentId": 322
  },
  {
    "id": 2964,
    "name": "丁青县",
    "type": "区",
    "parentId": 322
  },
  {
    "id": 2965,
    "name": "察雅县",
    "type": "区",
    "parentId": 322
  },
  {
    "id": 2966,
    "name": "八宿县",
    "type": "区",
    "parentId": 322
  },
  {
    "id": 2967,
    "name": "左贡县",
    "type": "区",
    "parentId": 322
  },
  {
    "id": 2968,
    "name": "芒康县",
    "type": "区",
    "parentId": 322
  },
  {
    "id": 2969,
    "name": "洛隆县",
    "type": "区",
    "parentId": 322
  },
  {
    "id": 2970,
    "name": "边坝县",
    "type": "区",
    "parentId": 322
  },
  {
    "id": 2971,
    "name": "巴宜区",
    "type": "区",
    "parentId": 323
  },
  {
    "id": 2972,
    "name": "工布江达县",
    "type": "区",
    "parentId": 323
  },
  {
    "id": 2973,
    "name": "米林县",
    "type": "区",
    "parentId": 323
  },
  {
    "id": 2974,
    "name": "墨脱县",
    "type": "区",
    "parentId": 323
  },
  {
    "id": 2975,
    "name": "波密县",
    "type": "区",
    "parentId": 323
  },
  {
    "id": 2976,
    "name": "察隅县",
    "type": "区",
    "parentId": 323
  },
  {
    "id": 2977,
    "name": "朗县",
    "type": "区",
    "parentId": 323
  },
  {
    "id": 2978,
    "name": "乃东区",
    "type": "区",
    "parentId": 324
  },
  {
    "id": 2979,
    "name": "扎囊县",
    "type": "区",
    "parentId": 324
  },
  {
    "id": 2980,
    "name": "贡嘎县",
    "type": "区",
    "parentId": 324
  },
  {
    "id": 2981,
    "name": "桑日县",
    "type": "区",
    "parentId": 324
  },
  {
    "id": 2982,
    "name": "琼结县",
    "type": "区",
    "parentId": 324
  },
  {
    "id": 2983,
    "name": "曲松县",
    "type": "区",
    "parentId": 324
  },
  {
    "id": 2984,
    "name": "措美县",
    "type": "区",
    "parentId": 324
  },
  {
    "id": 2985,
    "name": "洛扎县",
    "type": "区",
    "parentId": 324
  },
  {
    "id": 2986,
    "name": "加查县",
    "type": "区",
    "parentId": 324
  },
  {
    "id": 2987,
    "name": "隆子县",
    "type": "区",
    "parentId": 324
  },
  {
    "id": 2988,
    "name": "错那县",
    "type": "区",
    "parentId": 324
  },
  {
    "id": 2989,
    "name": "浪卡子县",
    "type": "区",
    "parentId": 324
  },
  {
    "id": 2990,
    "name": "色尼区",
    "type": "区",
    "parentId": 325
  },
  {
    "id": 2991,
    "name": "普兰县",
    "type": "区",
    "parentId": 326
  },
  {
    "id": 2992,
    "name": "札达县",
    "type": "区",
    "parentId": 326
  },
  {
    "id": 2993,
    "name": "噶尔县",
    "type": "区",
    "parentId": 326
  },
  {
    "id": 2994,
    "name": "日土县",
    "type": "区",
    "parentId": 326
  },
  {
    "id": 2995,
    "name": "革吉县",
    "type": "区",
    "parentId": 326
  },
  {
    "id": 2996,
    "name": "改则县",
    "type": "区",
    "parentId": 326
  },
  {
    "id": 2997,
    "name": "措勤县",
    "type": "区",
    "parentId": 326
  },
  {
    "id": 2998,
    "name": "新城区",
    "type": "区",
    "parentId": 327
  },
  {
    "id": 2999,
    "name": "碑林区",
    "type": "区",
    "parentId": 327
  },
  {
    "id": 3000,
    "name": "莲湖区",
    "type": "区",
    "parentId": 327
  },
  {
    "id": 3001,
    "name": "灞桥区",
    "type": "区",
    "parentId": 327
  },
  {
    "id": 3002,
    "name": "未央区",
    "type": "区",
    "parentId": 327
  },
  {
    "id": 3003,
    "name": "雁塔区",
    "type": "区",
    "parentId": 327
  },
  {
    "id": 3004,
    "name": "阎良区",
    "type": "区",
    "parentId": 327
  },
  {
    "id": 3005,
    "name": "临潼区",
    "type": "区",
    "parentId": 327
  },
  {
    "id": 3006,
    "name": "长安区",
    "type": "区",
    "parentId": 327
  },
  {
    "id": 3007,
    "name": "高陵区",
    "type": "区",
    "parentId": 327
  },
  {
    "id": 3008,
    "name": "鄠邑区",
    "type": "区",
    "parentId": 327
  },
  {
    "id": 3009,
    "name": "蓝田县",
    "type": "区",
    "parentId": 327
  },
  {
    "id": 3010,
    "name": "周至县",
    "type": "区",
    "parentId": 327
  },
  {
    "id": 3011,
    "name": "王益区",
    "type": "区",
    "parentId": 328
  },
  {
    "id": 3012,
    "name": "印台区",
    "type": "区",
    "parentId": 328
  },
  {
    "id": 3013,
    "name": "耀州区",
    "type": "区",
    "parentId": 328
  },
  {
    "id": 3014,
    "name": "宜君县",
    "type": "区",
    "parentId": 328
  },
  {
    "id": 3015,
    "name": "渭滨区",
    "type": "区",
    "parentId": 329
  },
  {
    "id": 3016,
    "name": "金台区",
    "type": "区",
    "parentId": 329
  },
  {
    "id": 3017,
    "name": "陈仓区",
    "type": "区",
    "parentId": 329
  },
  {
    "id": 3018,
    "name": "凤翔县",
    "type": "区",
    "parentId": 329
  },
  {
    "id": 3019,
    "name": "岐山县",
    "type": "区",
    "parentId": 329
  },
  {
    "id": 3020,
    "name": "扶风县",
    "type": "区",
    "parentId": 329
  },
  {
    "id": 3021,
    "name": "眉县",
    "type": "区",
    "parentId": 329
  },
  {
    "id": 3022,
    "name": "陇县",
    "type": "区",
    "parentId": 329
  },
  {
    "id": 3023,
    "name": "千阳县",
    "type": "区",
    "parentId": 329
  },
  {
    "id": 3024,
    "name": "麟游县",
    "type": "区",
    "parentId": 329
  },
  {
    "id": 3025,
    "name": "凤县",
    "type": "区",
    "parentId": 329
  },
  {
    "id": 3026,
    "name": "太白县",
    "type": "区",
    "parentId": 329
  },
  {
    "id": 3027,
    "name": "秦都区",
    "type": "区",
    "parentId": 330
  },
  {
    "id": 3028,
    "name": "杨陵区",
    "type": "区",
    "parentId": 330
  },
  {
    "id": 3029,
    "name": "渭城区",
    "type": "区",
    "parentId": 330
  },
  {
    "id": 3030,
    "name": "三原县",
    "type": "区",
    "parentId": 330
  },
  {
    "id": 3031,
    "name": "泾阳县",
    "type": "区",
    "parentId": 330
  },
  {
    "id": 3032,
    "name": "乾县",
    "type": "区",
    "parentId": 330
  },
  {
    "id": 3033,
    "name": "礼泉县",
    "type": "区",
    "parentId": 330
  },
  {
    "id": 3034,
    "name": "永寿县",
    "type": "区",
    "parentId": 330
  },
  {
    "id": 3035,
    "name": "彬县",
    "type": "区",
    "parentId": 330
  },
  {
    "id": 3036,
    "name": "长武县",
    "type": "区",
    "parentId": 330
  },
  {
    "id": 3037,
    "name": "旬邑县",
    "type": "区",
    "parentId": 330
  },
  {
    "id": 3038,
    "name": "淳化县",
    "type": "区",
    "parentId": 330
  },
  {
    "id": 3039,
    "name": "武功县",
    "type": "区",
    "parentId": 330
  },
  {
    "id": 3040,
    "name": "兴平市",
    "type": "区",
    "parentId": 330
  },
  {
    "id": 3041,
    "name": "临渭区",
    "type": "区",
    "parentId": 331
  },
  {
    "id": 3042,
    "name": "华州区",
    "type": "区",
    "parentId": 331
  },
  {
    "id": 3043,
    "name": "潼关县",
    "type": "区",
    "parentId": 331
  },
  {
    "id": 3044,
    "name": "大荔县",
    "type": "区",
    "parentId": 331
  },
  {
    "id": 3045,
    "name": "合阳县",
    "type": "区",
    "parentId": 331
  },
  {
    "id": 3046,
    "name": "澄城县",
    "type": "区",
    "parentId": 331
  },
  {
    "id": 3047,
    "name": "蒲城县",
    "type": "区",
    "parentId": 331
  },
  {
    "id": 3048,
    "name": "白水县",
    "type": "区",
    "parentId": 331
  },
  {
    "id": 3049,
    "name": "富平县",
    "type": "区",
    "parentId": 331
  },
  {
    "id": 3050,
    "name": "韩城市",
    "type": "区",
    "parentId": 331
  },
  {
    "id": 3051,
    "name": "华阴市",
    "type": "区",
    "parentId": 331
  },
  {
    "id": 3052,
    "name": "宝塔区",
    "type": "区",
    "parentId": 332
  },
  {
    "id": 3053,
    "name": "安塞区",
    "type": "区",
    "parentId": 332
  },
  {
    "id": 3054,
    "name": "延长县",
    "type": "区",
    "parentId": 332
  },
  {
    "id": 3055,
    "name": "延川县",
    "type": "区",
    "parentId": 332
  },
  {
    "id": 3056,
    "name": "子长县",
    "type": "区",
    "parentId": 332
  },
  {
    "id": 3057,
    "name": "志丹县",
    "type": "区",
    "parentId": 332
  },
  {
    "id": 3058,
    "name": "吴起县",
    "type": "区",
    "parentId": 332
  },
  {
    "id": 3059,
    "name": "甘泉县",
    "type": "区",
    "parentId": 332
  },
  {
    "id": 3060,
    "name": "富县",
    "type": "区",
    "parentId": 332
  },
  {
    "id": 3061,
    "name": "洛川县",
    "type": "区",
    "parentId": 332
  },
  {
    "id": 3062,
    "name": "宜川县",
    "type": "区",
    "parentId": 332
  },
  {
    "id": 3063,
    "name": "黄龙县",
    "type": "区",
    "parentId": 332
  },
  {
    "id": 3064,
    "name": "黄陵县",
    "type": "区",
    "parentId": 332
  },
  {
    "id": 3065,
    "name": "汉台区",
    "type": "区",
    "parentId": 333
  },
  {
    "id": 3066,
    "name": "南郑区",
    "type": "区",
    "parentId": 333
  },
  {
    "id": 3067,
    "name": "城固县",
    "type": "区",
    "parentId": 333
  },
  {
    "id": 3068,
    "name": "洋县",
    "type": "区",
    "parentId": 333
  },
  {
    "id": 3069,
    "name": "西乡县",
    "type": "区",
    "parentId": 333
  },
  {
    "id": 3070,
    "name": "勉县",
    "type": "区",
    "parentId": 333
  },
  {
    "id": 3071,
    "name": "宁强县",
    "type": "区",
    "parentId": 333
  },
  {
    "id": 3072,
    "name": "略阳县",
    "type": "区",
    "parentId": 333
  },
  {
    "id": 3073,
    "name": "镇巴县",
    "type": "区",
    "parentId": 333
  },
  {
    "id": 3074,
    "name": "留坝县",
    "type": "区",
    "parentId": 333
  },
  {
    "id": 3075,
    "name": "佛坪县",
    "type": "区",
    "parentId": 333
  },
  {
    "id": 3076,
    "name": "榆阳区",
    "type": "区",
    "parentId": 334
  },
  {
    "id": 3077,
    "name": "横山区",
    "type": "区",
    "parentId": 334
  },
  {
    "id": 3078,
    "name": "府谷县",
    "type": "区",
    "parentId": 334
  },
  {
    "id": 3079,
    "name": "靖边县",
    "type": "区",
    "parentId": 334
  },
  {
    "id": 3080,
    "name": "定边县",
    "type": "区",
    "parentId": 334
  },
  {
    "id": 3081,
    "name": "绥德县",
    "type": "区",
    "parentId": 334
  },
  {
    "id": 3082,
    "name": "米脂县",
    "type": "区",
    "parentId": 334
  },
  {
    "id": 3083,
    "name": "佳县",
    "type": "区",
    "parentId": 334
  },
  {
    "id": 3084,
    "name": "吴堡县",
    "type": "区",
    "parentId": 334
  },
  {
    "id": 3085,
    "name": "清涧县",
    "type": "区",
    "parentId": 334
  },
  {
    "id": 3086,
    "name": "子洲县",
    "type": "区",
    "parentId": 334
  },
  {
    "id": 3087,
    "name": "神木市",
    "type": "区",
    "parentId": 334
  },
  {
    "id": 3088,
    "name": "汉滨区",
    "type": "区",
    "parentId": 335
  },
  {
    "id": 3089,
    "name": "汉阴县",
    "type": "区",
    "parentId": 335
  },
  {
    "id": 3090,
    "name": "石泉县",
    "type": "区",
    "parentId": 335
  },
  {
    "id": 3091,
    "name": "宁陕县",
    "type": "区",
    "parentId": 335
  },
  {
    "id": 3092,
    "name": "紫阳县",
    "type": "区",
    "parentId": 335
  },
  {
    "id": 3093,
    "name": "岚皋县",
    "type": "区",
    "parentId": 335
  },
  {
    "id": 3094,
    "name": "平利县",
    "type": "区",
    "parentId": 335
  },
  {
    "id": 3095,
    "name": "镇坪县",
    "type": "区",
    "parentId": 335
  },
  {
    "id": 3096,
    "name": "旬阳县",
    "type": "区",
    "parentId": 335
  },
  {
    "id": 3097,
    "name": "白河县",
    "type": "区",
    "parentId": 335
  },
  {
    "id": 3098,
    "name": "商州区",
    "type": "区",
    "parentId": 336
  },
  {
    "id": 3099,
    "name": "洛南县",
    "type": "区",
    "parentId": 336
  },
  {
    "id": 3100,
    "name": "丹凤县",
    "type": "区",
    "parentId": 336
  },
  {
    "id": 3101,
    "name": "商南县",
    "type": "区",
    "parentId": 336
  },
  {
    "id": 3102,
    "name": "山阳县",
    "type": "区",
    "parentId": 336
  },
  {
    "id": 3103,
    "name": "镇安县",
    "type": "区",
    "parentId": 336
  },
  {
    "id": 3104,
    "name": "柞水县",
    "type": "区",
    "parentId": 336
  },
  {
    "id": 3105,
    "name": "城关区",
    "type": "区",
    "parentId": 337
  },
  {
    "id": 3106,
    "name": "七里河区",
    "type": "区",
    "parentId": 337
  },
  {
    "id": 3107,
    "name": "西固区",
    "type": "区",
    "parentId": 337
  },
  {
    "id": 3108,
    "name": "安宁区",
    "type": "区",
    "parentId": 337
  },
  {
    "id": 3109,
    "name": "红古区",
    "type": "区",
    "parentId": 337
  },
  {
    "id": 3110,
    "name": "永登县",
    "type": "区",
    "parentId": 337
  },
  {
    "id": 3111,
    "name": "皋兰县",
    "type": "区",
    "parentId": 337
  },
  {
    "id": 3112,
    "name": "榆中县",
    "type": "区",
    "parentId": 337
  },
  {
    "id": 3113,
    "name": "市辖区",
    "type": "区",
    "parentId": 338
  },
  {
    "id": 3114,
    "name": "雄关区",
    "type": "区",
    "parentId": 338
  },
  {
    "id": 3115,
    "name": "长城区",
    "type": "区",
    "parentId": 338
  },
  {
    "id": 3116,
    "name": "镜铁区",
    "type": "区",
    "parentId": 338
  },
  {
    "id": 3117,
    "name": "新城镇",
    "type": "区",
    "parentId": 338
  },
  {
    "id": 3118,
    "name": "峪泉镇",
    "type": "区",
    "parentId": 338
  },
  {
    "id": 3119,
    "name": "文殊镇",
    "type": "区",
    "parentId": 338
  },
  {
    "id": 3120,
    "name": "金川区",
    "type": "区",
    "parentId": 339
  },
  {
    "id": 3121,
    "name": "永昌县",
    "type": "区",
    "parentId": 339
  },
  {
    "id": 3122,
    "name": "白银区",
    "type": "区",
    "parentId": 340
  },
  {
    "id": 3123,
    "name": "平川区",
    "type": "区",
    "parentId": 340
  },
  {
    "id": 3124,
    "name": "靖远县",
    "type": "区",
    "parentId": 340
  },
  {
    "id": 3125,
    "name": "会宁县",
    "type": "区",
    "parentId": 340
  },
  {
    "id": 3126,
    "name": "景泰县",
    "type": "区",
    "parentId": 340
  },
  {
    "id": 3127,
    "name": "秦州区",
    "type": "区",
    "parentId": 341
  },
  {
    "id": 3128,
    "name": "麦积区",
    "type": "区",
    "parentId": 341
  },
  {
    "id": 3129,
    "name": "清水县",
    "type": "区",
    "parentId": 341
  },
  {
    "id": 3130,
    "name": "秦安县",
    "type": "区",
    "parentId": 341
  },
  {
    "id": 3131,
    "name": "甘谷县",
    "type": "区",
    "parentId": 341
  },
  {
    "id": 3132,
    "name": "武山县",
    "type": "区",
    "parentId": 341
  },
  {
    "id": 3133,
    "name": "张家川回族自治县",
    "type": "区",
    "parentId": 341
  },
  {
    "id": 3134,
    "name": "凉州区",
    "type": "区",
    "parentId": 342
  },
  {
    "id": 3135,
    "name": "民勤县",
    "type": "区",
    "parentId": 342
  },
  {
    "id": 3136,
    "name": "古浪县",
    "type": "区",
    "parentId": 342
  },
  {
    "id": 3137,
    "name": "天祝藏族自治县",
    "type": "区",
    "parentId": 342
  },
  {
    "id": 3138,
    "name": "甘州区",
    "type": "区",
    "parentId": 343
  },
  {
    "id": 3139,
    "name": "肃南裕固族自治县",
    "type": "区",
    "parentId": 343
  },
  {
    "id": 3140,
    "name": "民乐县",
    "type": "区",
    "parentId": 343
  },
  {
    "id": 3141,
    "name": "临泽县",
    "type": "区",
    "parentId": 343
  },
  {
    "id": 3142,
    "name": "高台县",
    "type": "区",
    "parentId": 343
  },
  {
    "id": 3143,
    "name": "山丹县",
    "type": "区",
    "parentId": 343
  },
  {
    "id": 3144,
    "name": "崆峒区",
    "type": "区",
    "parentId": 344
  },
  {
    "id": 3145,
    "name": "泾川县",
    "type": "区",
    "parentId": 344
  },
  {
    "id": 3146,
    "name": "灵台县",
    "type": "区",
    "parentId": 344
  },
  {
    "id": 3147,
    "name": "崇信县",
    "type": "区",
    "parentId": 344
  },
  {
    "id": 3148,
    "name": "华亭县",
    "type": "区",
    "parentId": 344
  },
  {
    "id": 3149,
    "name": "庄浪县",
    "type": "区",
    "parentId": 344
  },
  {
    "id": 3150,
    "name": "静宁县",
    "type": "区",
    "parentId": 344
  },
  {
    "id": 3151,
    "name": "肃州区",
    "type": "区",
    "parentId": 345
  },
  {
    "id": 3152,
    "name": "金塔县",
    "type": "区",
    "parentId": 345
  },
  {
    "id": 3153,
    "name": "瓜州县",
    "type": "区",
    "parentId": 345
  },
  {
    "id": 3154,
    "name": "肃北蒙古族自治县",
    "type": "区",
    "parentId": 345
  },
  {
    "id": 3155,
    "name": "阿克塞哈萨克族自治县",
    "type": "区",
    "parentId": 345
  },
  {
    "id": 3156,
    "name": "玉门市",
    "type": "区",
    "parentId": 345
  },
  {
    "id": 3157,
    "name": "敦煌市",
    "type": "区",
    "parentId": 345
  },
  {
    "id": 3158,
    "name": "西峰区",
    "type": "区",
    "parentId": 346
  },
  {
    "id": 3159,
    "name": "庆城县",
    "type": "区",
    "parentId": 346
  },
  {
    "id": 3160,
    "name": "环县",
    "type": "区",
    "parentId": 346
  },
  {
    "id": 3161,
    "name": "华池县",
    "type": "区",
    "parentId": 346
  },
  {
    "id": 3162,
    "name": "合水县",
    "type": "区",
    "parentId": 346
  },
  {
    "id": 3163,
    "name": "正宁县",
    "type": "区",
    "parentId": 346
  },
  {
    "id": 3164,
    "name": "宁县",
    "type": "区",
    "parentId": 346
  },
  {
    "id": 3165,
    "name": "镇原县",
    "type": "区",
    "parentId": 346
  },
  {
    "id": 3166,
    "name": "安定区",
    "type": "区",
    "parentId": 347
  },
  {
    "id": 3167,
    "name": "通渭县",
    "type": "区",
    "parentId": 347
  },
  {
    "id": 3168,
    "name": "陇西县",
    "type": "区",
    "parentId": 347
  },
  {
    "id": 3169,
    "name": "渭源县",
    "type": "区",
    "parentId": 347
  },
  {
    "id": 3170,
    "name": "临洮县",
    "type": "区",
    "parentId": 347
  },
  {
    "id": 3171,
    "name": "漳县",
    "type": "区",
    "parentId": 347
  },
  {
    "id": 3172,
    "name": "岷县",
    "type": "区",
    "parentId": 347
  },
  {
    "id": 3173,
    "name": "武都区",
    "type": "区",
    "parentId": 348
  },
  {
    "id": 3174,
    "name": "成县",
    "type": "区",
    "parentId": 348
  },
  {
    "id": 3175,
    "name": "文县",
    "type": "区",
    "parentId": 348
  },
  {
    "id": 3176,
    "name": "宕昌县",
    "type": "区",
    "parentId": 348
  },
  {
    "id": 3177,
    "name": "康县",
    "type": "区",
    "parentId": 348
  },
  {
    "id": 3178,
    "name": "西和县",
    "type": "区",
    "parentId": 348
  },
  {
    "id": 3179,
    "name": "礼县",
    "type": "区",
    "parentId": 348
  },
  {
    "id": 3180,
    "name": "徽县",
    "type": "区",
    "parentId": 348
  },
  {
    "id": 3181,
    "name": "两当县",
    "type": "区",
    "parentId": 348
  },
  {
    "id": 3182,
    "name": "临夏市",
    "type": "区",
    "parentId": 349
  },
  {
    "id": 3183,
    "name": "临夏县",
    "type": "区",
    "parentId": 349
  },
  {
    "id": 3184,
    "name": "康乐县",
    "type": "区",
    "parentId": 349
  },
  {
    "id": 3185,
    "name": "永靖县",
    "type": "区",
    "parentId": 349
  },
  {
    "id": 3186,
    "name": "广河县",
    "type": "区",
    "parentId": 349
  },
  {
    "id": 3187,
    "name": "和政县",
    "type": "区",
    "parentId": 349
  },
  {
    "id": 3188,
    "name": "东乡族自治县",
    "type": "区",
    "parentId": 349
  },
  {
    "id": 3189,
    "name": "积石山保安族东乡族撒拉族自治县",
    "type": "区",
    "parentId": 349
  },
  {
    "id": 3190,
    "name": "合作市",
    "type": "区",
    "parentId": 350
  },
  {
    "id": 3191,
    "name": "临潭县",
    "type": "区",
    "parentId": 350
  },
  {
    "id": 3192,
    "name": "卓尼县",
    "type": "区",
    "parentId": 350
  },
  {
    "id": 3193,
    "name": "舟曲县",
    "type": "区",
    "parentId": 350
  },
  {
    "id": 3194,
    "name": "迭部县",
    "type": "区",
    "parentId": 350
  },
  {
    "id": 3195,
    "name": "玛曲县",
    "type": "区",
    "parentId": 350
  },
  {
    "id": 3196,
    "name": "碌曲县",
    "type": "区",
    "parentId": 350
  },
  {
    "id": 3197,
    "name": "夏河县",
    "type": "区",
    "parentId": 350
  },
  {
    "id": 3198,
    "name": "城东区",
    "type": "区",
    "parentId": 351
  },
  {
    "id": 3199,
    "name": "城中区",
    "type": "区",
    "parentId": 351
  },
  {
    "id": 3200,
    "name": "城西区",
    "type": "区",
    "parentId": 351
  },
  {
    "id": 3201,
    "name": "城北区",
    "type": "区",
    "parentId": 351
  },
  {
    "id": 3202,
    "name": "大通回族土族自治县",
    "type": "区",
    "parentId": 351
  },
  {
    "id": 3203,
    "name": "湟中县",
    "type": "区",
    "parentId": 351
  },
  {
    "id": 3204,
    "name": "湟源县",
    "type": "区",
    "parentId": 351
  },
  {
    "id": 3205,
    "name": "乐都区",
    "type": "区",
    "parentId": 352
  },
  {
    "id": 3206,
    "name": "平安区",
    "type": "区",
    "parentId": 352
  },
  {
    "id": 3207,
    "name": "民和回族土族自治县",
    "type": "区",
    "parentId": 352
  },
  {
    "id": 3208,
    "name": "互助土族自治县",
    "type": "区",
    "parentId": 352
  },
  {
    "id": 3209,
    "name": "化隆回族自治县",
    "type": "区",
    "parentId": 352
  },
  {
    "id": 3210,
    "name": "循化撒拉族自治县",
    "type": "区",
    "parentId": 352
  },
  {
    "id": 3211,
    "name": "门源回族自治县",
    "type": "区",
    "parentId": 353
  },
  {
    "id": 3212,
    "name": "祁连县",
    "type": "区",
    "parentId": 353
  },
  {
    "id": 3213,
    "name": "海晏县",
    "type": "区",
    "parentId": 353
  },
  {
    "id": 3214,
    "name": "刚察县",
    "type": "区",
    "parentId": 353
  },
  {
    "id": 3215,
    "name": "同仁县",
    "type": "区",
    "parentId": 354
  },
  {
    "id": 3216,
    "name": "尖扎县",
    "type": "区",
    "parentId": 354
  },
  {
    "id": 3217,
    "name": "泽库县",
    "type": "区",
    "parentId": 354
  },
  {
    "id": 3218,
    "name": "河南蒙古族自治县",
    "type": "区",
    "parentId": 354
  },
  {
    "id": 3219,
    "name": "共和县",
    "type": "区",
    "parentId": 355
  },
  {
    "id": 3220,
    "name": "同德县",
    "type": "区",
    "parentId": 355
  },
  {
    "id": 3221,
    "name": "贵德县",
    "type": "区",
    "parentId": 355
  },
  {
    "id": 3222,
    "name": "兴海县",
    "type": "区",
    "parentId": 355
  },
  {
    "id": 3223,
    "name": "贵南县",
    "type": "区",
    "parentId": 355
  },
  {
    "id": 3224,
    "name": "玛沁县",
    "type": "区",
    "parentId": 356
  },
  {
    "id": 3225,
    "name": "班玛县",
    "type": "区",
    "parentId": 356
  },
  {
    "id": 3226,
    "name": "甘德县",
    "type": "区",
    "parentId": 356
  },
  {
    "id": 3227,
    "name": "达日县",
    "type": "区",
    "parentId": 356
  },
  {
    "id": 3228,
    "name": "久治县",
    "type": "区",
    "parentId": 356
  },
  {
    "id": 3229,
    "name": "玛多县",
    "type": "区",
    "parentId": 356
  },
  {
    "id": 3230,
    "name": "玉树市",
    "type": "区",
    "parentId": 357
  },
  {
    "id": 3231,
    "name": "杂多县",
    "type": "区",
    "parentId": 357
  },
  {
    "id": 3232,
    "name": "称多县",
    "type": "区",
    "parentId": 357
  },
  {
    "id": 3233,
    "name": "治多县",
    "type": "区",
    "parentId": 357
  },
  {
    "id": 3234,
    "name": "囊谦县",
    "type": "区",
    "parentId": 357
  },
  {
    "id": 3235,
    "name": "曲麻莱县",
    "type": "区",
    "parentId": 357
  },
  {
    "id": 3236,
    "name": "格尔木市",
    "type": "区",
    "parentId": 358
  },
  {
    "id": 3237,
    "name": "德令哈市",
    "type": "区",
    "parentId": 358
  },
  {
    "id": 3238,
    "name": "乌兰县",
    "type": "区",
    "parentId": 358
  },
  {
    "id": 3239,
    "name": "都兰县",
    "type": "区",
    "parentId": 358
  },
  {
    "id": 3240,
    "name": "天峻县",
    "type": "区",
    "parentId": 358
  },
  {
    "id": 3241,
    "name": "兴庆区",
    "type": "区",
    "parentId": 359
  },
  {
    "id": 3242,
    "name": "西夏区",
    "type": "区",
    "parentId": 359
  },
  {
    "id": 3243,
    "name": "金凤区",
    "type": "区",
    "parentId": 359
  },
  {
    "id": 3244,
    "name": "永宁县",
    "type": "区",
    "parentId": 359
  },
  {
    "id": 3245,
    "name": "贺兰县",
    "type": "区",
    "parentId": 359
  },
  {
    "id": 3246,
    "name": "灵武市",
    "type": "区",
    "parentId": 359
  },
  {
    "id": 3247,
    "name": "大武口区",
    "type": "区",
    "parentId": 360
  },
  {
    "id": 3248,
    "name": "惠农区",
    "type": "区",
    "parentId": 360
  },
  {
    "id": 3249,
    "name": "平罗县",
    "type": "区",
    "parentId": 360
  },
  {
    "id": 3250,
    "name": "利通区",
    "type": "区",
    "parentId": 361
  },
  {
    "id": 3251,
    "name": "红寺堡区",
    "type": "区",
    "parentId": 361
  },
  {
    "id": 3252,
    "name": "盐池县",
    "type": "区",
    "parentId": 361
  },
  {
    "id": 3253,
    "name": "同心县",
    "type": "区",
    "parentId": 361
  },
  {
    "id": 3254,
    "name": "青铜峡市",
    "type": "区",
    "parentId": 361
  },
  {
    "id": 3255,
    "name": "原州区",
    "type": "区",
    "parentId": 362
  },
  {
    "id": 3256,
    "name": "西吉县",
    "type": "区",
    "parentId": 362
  },
  {
    "id": 3257,
    "name": "隆德县",
    "type": "区",
    "parentId": 362
  },
  {
    "id": 3258,
    "name": "泾源县",
    "type": "区",
    "parentId": 362
  },
  {
    "id": 3259,
    "name": "彭阳县",
    "type": "区",
    "parentId": 362
  },
  {
    "id": 3260,
    "name": "沙坡头区",
    "type": "区",
    "parentId": 363
  },
  {
    "id": 3261,
    "name": "中宁县",
    "type": "区",
    "parentId": 363
  },
  {
    "id": 3262,
    "name": "海原县",
    "type": "区",
    "parentId": 363
  },
  {
    "id": 3263,
    "name": "天山区",
    "type": "区",
    "parentId": 364
  },
  {
    "id": 3264,
    "name": "沙依巴克区",
    "type": "区",
    "parentId": 364
  },
  {
    "id": 3265,
    "name": "新市区",
    "type": "区",
    "parentId": 364
  },
  {
    "id": 3266,
    "name": "水磨沟区",
    "type": "区",
    "parentId": 364
  },
  {
    "id": 3267,
    "name": "头屯河区",
    "type": "区",
    "parentId": 364
  },
  {
    "id": 3268,
    "name": "达坂城区",
    "type": "区",
    "parentId": 364
  },
  {
    "id": 3269,
    "name": "米东区",
    "type": "区",
    "parentId": 364
  },
  {
    "id": 3270,
    "name": "乌鲁木齐县",
    "type": "区",
    "parentId": 364
  },
  {
    "id": 3271,
    "name": "独山子区",
    "type": "区",
    "parentId": 365
  },
  {
    "id": 3272,
    "name": "克拉玛依区",
    "type": "区",
    "parentId": 365
  },
  {
    "id": 3273,
    "name": "白碱滩区",
    "type": "区",
    "parentId": 365
  },
  {
    "id": 3274,
    "name": "乌尔禾区",
    "type": "区",
    "parentId": 365
  },
  {
    "id": 3275,
    "name": "高昌区",
    "type": "区",
    "parentId": 366
  },
  {
    "id": 3276,
    "name": "鄯善县",
    "type": "区",
    "parentId": 366
  },
  {
    "id": 3277,
    "name": "托克逊县",
    "type": "区",
    "parentId": 366
  },
  {
    "id": 3278,
    "name": "伊州区",
    "type": "区",
    "parentId": 367
  },
  {
    "id": 3279,
    "name": "巴里坤哈萨克自治县",
    "type": "区",
    "parentId": 367
  },
  {
    "id": 3280,
    "name": "伊吾县",
    "type": "区",
    "parentId": 367
  },
  {
    "id": 3281,
    "name": "昌吉市",
    "type": "区",
    "parentId": 368
  },
  {
    "id": 3282,
    "name": "阜康市",
    "type": "区",
    "parentId": 368
  },
  {
    "id": 3283,
    "name": "呼图壁县",
    "type": "区",
    "parentId": 368
  },
  {
    "id": 3284,
    "name": "玛纳斯县",
    "type": "区",
    "parentId": 368
  },
  {
    "id": 3285,
    "name": "奇台县",
    "type": "区",
    "parentId": 368
  },
  {
    "id": 3286,
    "name": "吉木萨尔县",
    "type": "区",
    "parentId": 368
  },
  {
    "id": 3287,
    "name": "木垒哈萨克自治县",
    "type": "区",
    "parentId": 368
  },
  {
    "id": 3288,
    "name": "博乐市",
    "type": "区",
    "parentId": 369
  },
  {
    "id": 3289,
    "name": "阿拉山口市",
    "type": "区",
    "parentId": 369
  },
  {
    "id": 3290,
    "name": "精河县",
    "type": "区",
    "parentId": 369
  },
  {
    "id": 3291,
    "name": "温泉县",
    "type": "区",
    "parentId": 369
  },
  {
    "id": 3292,
    "name": "库尔勒市",
    "type": "区",
    "parentId": 370
  },
  {
    "id": 3293,
    "name": "轮台县",
    "type": "区",
    "parentId": 370
  },
  {
    "id": 3294,
    "name": "尉犁县",
    "type": "区",
    "parentId": 370
  },
  {
    "id": 3295,
    "name": "若羌县",
    "type": "区",
    "parentId": 370
  },
  {
    "id": 3296,
    "name": "且末县",
    "type": "区",
    "parentId": 370
  },
  {
    "id": 3297,
    "name": "焉耆回族自治县",
    "type": "区",
    "parentId": 370
  },
  {
    "id": 3298,
    "name": "和静县",
    "type": "区",
    "parentId": 370
  },
  {
    "id": 3299,
    "name": "和硕县",
    "type": "区",
    "parentId": 370
  },
  {
    "id": 3300,
    "name": "博湖县",
    "type": "区",
    "parentId": 370
  },
  {
    "id": 3301,
    "name": "阿克苏市",
    "type": "区",
    "parentId": 371
  },
  {
    "id": 3302,
    "name": "温宿县",
    "type": "区",
    "parentId": 371
  },
  {
    "id": 3303,
    "name": "库车县",
    "type": "区",
    "parentId": 371
  },
  {
    "id": 3304,
    "name": "沙雅县",
    "type": "区",
    "parentId": 371
  },
  {
    "id": 3305,
    "name": "新和县",
    "type": "区",
    "parentId": 371
  },
  {
    "id": 3306,
    "name": "拜城县",
    "type": "区",
    "parentId": 371
  },
  {
    "id": 3307,
    "name": "乌什县",
    "type": "区",
    "parentId": 371
  },
  {
    "id": 3308,
    "name": "阿瓦提县",
    "type": "区",
    "parentId": 371
  },
  {
    "id": 3309,
    "name": "柯坪县",
    "type": "区",
    "parentId": 371
  },
  {
    "id": 3310,
    "name": "阿图什市",
    "type": "区",
    "parentId": 372
  },
  {
    "id": 3311,
    "name": "阿克陶县",
    "type": "区",
    "parentId": 372
  },
  {
    "id": 3312,
    "name": "阿合奇县",
    "type": "区",
    "parentId": 372
  },
  {
    "id": 3313,
    "name": "乌恰县",
    "type": "区",
    "parentId": 372
  },
  {
    "id": 3314,
    "name": "喀什市",
    "type": "区",
    "parentId": 373
  },
  {
    "id": 3315,
    "name": "疏附县",
    "type": "区",
    "parentId": 373
  },
  {
    "id": 3316,
    "name": "疏勒县",
    "type": "区",
    "parentId": 373
  },
  {
    "id": 3317,
    "name": "英吉沙县",
    "type": "区",
    "parentId": 373
  },
  {
    "id": 3318,
    "name": "泽普县",
    "type": "区",
    "parentId": 373
  },
  {
    "id": 3319,
    "name": "莎车县",
    "type": "区",
    "parentId": 373
  },
  {
    "id": 3320,
    "name": "叶城县",
    "type": "区",
    "parentId": 373
  },
  {
    "id": 3321,
    "name": "麦盖提县",
    "type": "区",
    "parentId": 373
  },
  {
    "id": 3322,
    "name": "岳普湖县",
    "type": "区",
    "parentId": 373
  },
  {
    "id": 3323,
    "name": "伽师县",
    "type": "区",
    "parentId": 373
  },
  {
    "id": 3324,
    "name": "巴楚县",
    "type": "区",
    "parentId": 373
  },
  {
    "id": 3325,
    "name": "塔什库尔干塔吉克自治县",
    "type": "区",
    "parentId": 373
  },
  {
    "id": 3326,
    "name": "和田市",
    "type": "区",
    "parentId": 374
  },
  {
    "id": 3327,
    "name": "和田县",
    "type": "区",
    "parentId": 374
  },
  {
    "id": 3328,
    "name": "墨玉县",
    "type": "区",
    "parentId": 374
  },
  {
    "id": 3329,
    "name": "皮山县",
    "type": "区",
    "parentId": 374
  },
  {
    "id": 3330,
    "name": "洛浦县",
    "type": "区",
    "parentId": 374
  },
  {
    "id": 3331,
    "name": "策勒县",
    "type": "区",
    "parentId": 374
  },
  {
    "id": 3332,
    "name": "于田县",
    "type": "区",
    "parentId": 374
  },
  {
    "id": 3333,
    "name": "民丰县",
    "type": "区",
    "parentId": 374
  },
  {
    "id": 3334,
    "name": "伊宁市",
    "type": "区",
    "parentId": 375
  },
  {
    "id": 3335,
    "name": "奎屯市",
    "type": "区",
    "parentId": 375
  },
  {
    "id": 3336,
    "name": "霍尔果斯市",
    "type": "区",
    "parentId": 375
  },
  {
    "id": 3337,
    "name": "伊宁县",
    "type": "区",
    "parentId": 375
  },
  {
    "id": 3338,
    "name": "察布查尔锡伯自治县",
    "type": "区",
    "parentId": 375
  },
  {
    "id": 3339,
    "name": "霍城县",
    "type": "区",
    "parentId": 375
  },
  {
    "id": 3340,
    "name": "巩留县",
    "type": "区",
    "parentId": 375
  },
  {
    "id": 3341,
    "name": "新源县",
    "type": "区",
    "parentId": 375
  },
  {
    "id": 3342,
    "name": "昭苏县",
    "type": "区",
    "parentId": 375
  },
  {
    "id": 3343,
    "name": "特克斯县",
    "type": "区",
    "parentId": 375
  },
  {
    "id": 3344,
    "name": "尼勒克县",
    "type": "区",
    "parentId": 375
  },
  {
    "id": 3345,
    "name": "塔城市",
    "type": "区",
    "parentId": 376
  },
  {
    "id": 3346,
    "name": "乌苏市",
    "type": "区",
    "parentId": 376
  },
  {
    "id": 3347,
    "name": "额敏县",
    "type": "区",
    "parentId": 376
  },
  {
    "id": 3348,
    "name": "沙湾县",
    "type": "区",
    "parentId": 376
  },
  {
    "id": 3349,
    "name": "托里县",
    "type": "区",
    "parentId": 376
  },
  {
    "id": 3350,
    "name": "裕民县",
    "type": "区",
    "parentId": 376
  },
  {
    "id": 3351,
    "name": "和布克赛尔蒙古自治县",
    "type": "区",
    "parentId": 376
  },
  {
    "id": 3352,
    "name": "阿勒泰市",
    "type": "区",
    "parentId": 377
  },
  {
    "id": 3353,
    "name": "布尔津县",
    "type": "区",
    "parentId": 377
  },
  {
    "id": 3354,
    "name": "富蕴县",
    "type": "区",
    "parentId": 377
  },
  {
    "id": 3355,
    "name": "福海县",
    "type": "区",
    "parentId": 377
  },
  {
    "id": 3356,
    "name": "哈巴河县",
    "type": "区",
    "parentId": 377
  },
  {
    "id": 3357,
    "name": "青河县",
    "type": "区",
    "parentId": 377
  },
  {
    "id": 3358,
    "name": "吉木乃县",
    "type": "区",
    "parentId": 377
  },
  {
    "id": 3359,
    "name": "石河子市",
    "type": "区",
    "parentId": 378
  },
  {
    "id": 3360,
    "name": "阿拉尔市",
    "type": "区",
    "parentId": 378
  },
  {
    "id": 3361,
    "name": "图木舒克市",
    "type": "区",
    "parentId": 378
  },
  {
    "id": 3362,
    "name": "五家渠市",
    "type": "区",
    "parentId": 378
  },
  {
    "id": 3363,
    "name": "北屯市",
    "type": "区",
    "parentId": 378
  },
  {
    "id": 3364,
    "name": "铁门关市",
    "type": "区",
    "parentId": 378
  },
  {
    "id": 3365,
    "name": "双河市",
    "type": "区",
    "parentId": 378
  },
  {
    "id": 3366,
    "name": "可克达拉市",
    "type": "区",
    "parentId": 378
  },
  {
    "id": 3367,
    "name": "昆玉市",
    "type": "区",
    "parentId": 378
  },
  {
    "id": 3368,
    "name": "中正区",
    "type": "区",
    "parentId": 379
  },
  {
    "id": 3369,
    "name": "大同区",
    "type": "区",
    "parentId": 379
  },
  {
    "id": 3370,
    "name": "中山区",
    "type": "区",
    "parentId": 379
  },
  {
    "id": 3371,
    "name": "松山区",
    "type": "区",
    "parentId": 379
  },
  {
    "id": 3372,
    "name": "大安区",
    "type": "区",
    "parentId": 379
  },
  {
    "id": 3373,
    "name": "万华区",
    "type": "区",
    "parentId": 379
  },
  {
    "id": 3374,
    "name": "信义区",
    "type": "区",
    "parentId": 379
  },
  {
    "id": 3375,
    "name": "士林区",
    "type": "区",
    "parentId": 379
  },
  {
    "id": 3376,
    "name": "北投区",
    "type": "区",
    "parentId": 379
  },
  {
    "id": 3377,
    "name": "内湖区",
    "type": "区",
    "parentId": 379
  },
  {
    "id": 3378,
    "name": "南港区",
    "type": "区",
    "parentId": 379
  },
  {
    "id": 3379,
    "name": "文山区",
    "type": "区",
    "parentId": 379
  },
  {
    "id": 3380,
    "name": "其它区",
    "type": "区",
    "parentId": 379
  },
  {
    "id": 3381,
    "name": "新兴区",
    "type": "区",
    "parentId": 380
  },
  {
    "id": 3382,
    "name": "前金区",
    "type": "区",
    "parentId": 380
  },
  {
    "id": 3383,
    "name": "芩雅区",
    "type": "区",
    "parentId": 380
  },
  {
    "id": 3384,
    "name": "盐埕区",
    "type": "区",
    "parentId": 380
  },
  {
    "id": 3385,
    "name": "鼓山区",
    "type": "区",
    "parentId": 380
  },
  {
    "id": 3386,
    "name": "旗津区",
    "type": "区",
    "parentId": 380
  },
  {
    "id": 3387,
    "name": "前镇区",
    "type": "区",
    "parentId": 380
  },
  {
    "id": 3388,
    "name": "三民区",
    "type": "区",
    "parentId": 380
  },
  {
    "id": 3389,
    "name": "左营区",
    "type": "区",
    "parentId": 380
  },
  {
    "id": 3390,
    "name": "楠梓区",
    "type": "区",
    "parentId": 380
  },
  {
    "id": 3391,
    "name": "小港区",
    "type": "区",
    "parentId": 380
  },
  {
    "id": 3392,
    "name": "苓雅区",
    "type": "区",
    "parentId": 380
  },
  {
    "id": 3393,
    "name": "仁武区",
    "type": "区",
    "parentId": 380
  },
  {
    "id": 3394,
    "name": "大社区",
    "type": "区",
    "parentId": 380
  },
  {
    "id": 3395,
    "name": "冈山区",
    "type": "区",
    "parentId": 380
  },
  {
    "id": 3396,
    "name": "路竹区",
    "type": "区",
    "parentId": 380
  },
  {
    "id": 3397,
    "name": "阿莲区",
    "type": "区",
    "parentId": 380
  },
  {
    "id": 3398,
    "name": "田寮区",
    "type": "区",
    "parentId": 380
  },
  {
    "id": 3399,
    "name": "燕巢区",
    "type": "区",
    "parentId": 380
  },
  {
    "id": 3400,
    "name": "桥头区",
    "type": "区",
    "parentId": 380
  },
  {
    "id": 3401,
    "name": "梓官区",
    "type": "区",
    "parentId": 380
  },
  {
    "id": 3402,
    "name": "弥陀区",
    "type": "区",
    "parentId": 380
  },
  {
    "id": 3403,
    "name": "永安区",
    "type": "区",
    "parentId": 380
  },
  {
    "id": 3404,
    "name": "湖内区",
    "type": "区",
    "parentId": 380
  },
  {
    "id": 3405,
    "name": "凤山区",
    "type": "区",
    "parentId": 380
  },
  {
    "id": 3406,
    "name": "大寮区",
    "type": "区",
    "parentId": 380
  },
  {
    "id": 3407,
    "name": "林园区",
    "type": "区",
    "parentId": 380
  },
  {
    "id": 3408,
    "name": "鸟松区",
    "type": "区",
    "parentId": 380
  },
  {
    "id": 3409,
    "name": "大树区",
    "type": "区",
    "parentId": 380
  },
  {
    "id": 3410,
    "name": "旗山区",
    "type": "区",
    "parentId": 380
  },
  {
    "id": 3411,
    "name": "美浓区",
    "type": "区",
    "parentId": 380
  },
  {
    "id": 3412,
    "name": "六龟区",
    "type": "区",
    "parentId": 380
  },
  {
    "id": 3413,
    "name": "内门区",
    "type": "区",
    "parentId": 380
  },
  {
    "id": 3414,
    "name": "杉林区",
    "type": "区",
    "parentId": 380
  },
  {
    "id": 3415,
    "name": "甲仙区",
    "type": "区",
    "parentId": 380
  },
  {
    "id": 3416,
    "name": "桃源区",
    "type": "区",
    "parentId": 380
  },
  {
    "id": 3417,
    "name": "那玛夏区",
    "type": "区",
    "parentId": 380
  },
  {
    "id": 3418,
    "name": "茂林区",
    "type": "区",
    "parentId": 380
  },
  {
    "id": 3419,
    "name": "茄萣区",
    "type": "区",
    "parentId": 380
  },
  {
    "id": 3420,
    "name": "其它区",
    "type": "区",
    "parentId": 380
  },
  {
    "id": 3421,
    "name": "中西区",
    "type": "区",
    "parentId": 381
  },
  {
    "id": 3422,
    "name": "东区",
    "type": "区",
    "parentId": 381
  },
  {
    "id": 3423,
    "name": "南区",
    "type": "区",
    "parentId": 381
  },
  {
    "id": 3424,
    "name": "北区",
    "type": "区",
    "parentId": 381
  },
  {
    "id": 3425,
    "name": "安平区",
    "type": "区",
    "parentId": 381
  },
  {
    "id": 3426,
    "name": "安南区",
    "type": "区",
    "parentId": 381
  },
  {
    "id": 3427,
    "name": "永康区",
    "type": "区",
    "parentId": 381
  },
  {
    "id": 3428,
    "name": "归仁区",
    "type": "区",
    "parentId": 381
  },
  {
    "id": 3429,
    "name": "新化区",
    "type": "区",
    "parentId": 381
  },
  {
    "id": 3430,
    "name": "左镇区",
    "type": "区",
    "parentId": 381
  },
  {
    "id": 3431,
    "name": "玉井区",
    "type": "区",
    "parentId": 381
  },
  {
    "id": 3432,
    "name": "楠西区",
    "type": "区",
    "parentId": 381
  },
  {
    "id": 3433,
    "name": "南化区",
    "type": "区",
    "parentId": 381
  },
  {
    "id": 3434,
    "name": "仁德区",
    "type": "区",
    "parentId": 381
  },
  {
    "id": 3435,
    "name": "关庙区",
    "type": "区",
    "parentId": 381
  },
  {
    "id": 3436,
    "name": "龙崎区",
    "type": "区",
    "parentId": 381
  },
  {
    "id": 3437,
    "name": "官田区",
    "type": "区",
    "parentId": 381
  },
  {
    "id": 3438,
    "name": "麻豆区",
    "type": "区",
    "parentId": 381
  },
  {
    "id": 3439,
    "name": "佳里区",
    "type": "区",
    "parentId": 381
  },
  {
    "id": 3440,
    "name": "西港区",
    "type": "区",
    "parentId": 381
  },
  {
    "id": 3441,
    "name": "七股区",
    "type": "区",
    "parentId": 381
  },
  {
    "id": 3442,
    "name": "将军区",
    "type": "区",
    "parentId": 381
  },
  {
    "id": 3443,
    "name": "学甲区",
    "type": "区",
    "parentId": 381
  },
  {
    "id": 3444,
    "name": "北门区",
    "type": "区",
    "parentId": 381
  },
  {
    "id": 3445,
    "name": "新营区",
    "type": "区",
    "parentId": 381
  },
  {
    "id": 3446,
    "name": "后壁区",
    "type": "区",
    "parentId": 381
  },
  {
    "id": 3447,
    "name": "白河区",
    "type": "区",
    "parentId": 381
  },
  {
    "id": 3448,
    "name": "东山区",
    "type": "区",
    "parentId": 381
  },
  {
    "id": 3449,
    "name": "六甲区",
    "type": "区",
    "parentId": 381
  },
  {
    "id": 3450,
    "name": "下营区",
    "type": "区",
    "parentId": 381
  },
  {
    "id": 3451,
    "name": "柳营区",
    "type": "区",
    "parentId": 381
  },
  {
    "id": 3452,
    "name": "盐水区",
    "type": "区",
    "parentId": 381
  },
  {
    "id": 3453,
    "name": "善化区",
    "type": "区",
    "parentId": 381
  },
  {
    "id": 3454,
    "name": "大内区",
    "type": "区",
    "parentId": 381
  },
  {
    "id": 3455,
    "name": "山上区",
    "type": "区",
    "parentId": 381
  },
  {
    "id": 3456,
    "name": "新市区",
    "type": "区",
    "parentId": 381
  },
  {
    "id": 3457,
    "name": "安定区",
    "type": "区",
    "parentId": 381
  },
  {
    "id": 3458,
    "name": "其它区",
    "type": "区",
    "parentId": 381
  },
  {
    "id": 3459,
    "name": "中区",
    "type": "区",
    "parentId": 382
  },
  {
    "id": 3460,
    "name": "东区",
    "type": "区",
    "parentId": 382
  },
  {
    "id": 3461,
    "name": "南区",
    "type": "区",
    "parentId": 382
  },
  {
    "id": 3462,
    "name": "西区",
    "type": "区",
    "parentId": 382
  },
  {
    "id": 3463,
    "name": "北区",
    "type": "区",
    "parentId": 382
  },
  {
    "id": 3464,
    "name": "北屯区",
    "type": "区",
    "parentId": 382
  },
  {
    "id": 3465,
    "name": "西屯区",
    "type": "区",
    "parentId": 382
  },
  {
    "id": 3466,
    "name": "南屯区",
    "type": "区",
    "parentId": 382
  },
  {
    "id": 3467,
    "name": "太平区",
    "type": "区",
    "parentId": 382
  },
  {
    "id": 3468,
    "name": "大里区",
    "type": "区",
    "parentId": 382
  },
  {
    "id": 3469,
    "name": "雾峰区",
    "type": "区",
    "parentId": 382
  },
  {
    "id": 3470,
    "name": "乌日区",
    "type": "区",
    "parentId": 382
  },
  {
    "id": 3471,
    "name": "丰原区",
    "type": "区",
    "parentId": 382
  },
  {
    "id": 3472,
    "name": "后里区",
    "type": "区",
    "parentId": 382
  },
  {
    "id": 3473,
    "name": "石冈区",
    "type": "区",
    "parentId": 382
  },
  {
    "id": 3474,
    "name": "东势区",
    "type": "区",
    "parentId": 382
  },
  {
    "id": 3475,
    "name": "和平区",
    "type": "区",
    "parentId": 382
  },
  {
    "id": 3476,
    "name": "新社区",
    "type": "区",
    "parentId": 382
  },
  {
    "id": 3477,
    "name": "潭子区",
    "type": "区",
    "parentId": 382
  },
  {
    "id": 3478,
    "name": "大雅区",
    "type": "区",
    "parentId": 382
  },
  {
    "id": 3479,
    "name": "神冈区",
    "type": "区",
    "parentId": 382
  },
  {
    "id": 3480,
    "name": "大肚区",
    "type": "区",
    "parentId": 382
  },
  {
    "id": 3481,
    "name": "沙鹿区",
    "type": "区",
    "parentId": 382
  },
  {
    "id": 3482,
    "name": "龙井区",
    "type": "区",
    "parentId": 382
  },
  {
    "id": 3483,
    "name": "梧栖区",
    "type": "区",
    "parentId": 382
  },
  {
    "id": 3484,
    "name": "清水区",
    "type": "区",
    "parentId": 382
  },
  {
    "id": 3485,
    "name": "大甲区",
    "type": "区",
    "parentId": 382
  },
  {
    "id": 3486,
    "name": "外埔区",
    "type": "区",
    "parentId": 382
  },
  {
    "id": 3487,
    "name": "大安区",
    "type": "区",
    "parentId": 382
  },
  {
    "id": 3488,
    "name": "其它区",
    "type": "区",
    "parentId": 382
  },
  {
    "id": 3489,
    "name": "金沙镇",
    "type": "区",
    "parentId": 383
  },
  {
    "id": 3490,
    "name": "金湖镇",
    "type": "区",
    "parentId": 383
  },
  {
    "id": 3491,
    "name": "金宁乡",
    "type": "区",
    "parentId": 383
  },
  {
    "id": 3492,
    "name": "金城镇",
    "type": "区",
    "parentId": 383
  },
  {
    "id": 3493,
    "name": "烈屿乡",
    "type": "区",
    "parentId": 383
  },
  {
    "id": 3494,
    "name": "乌坵乡",
    "type": "区",
    "parentId": 383
  },
  {
    "id": 3495,
    "name": "南投市",
    "type": "区",
    "parentId": 384
  },
  {
    "id": 3496,
    "name": "中寮乡",
    "type": "区",
    "parentId": 384
  },
  {
    "id": 3497,
    "name": "草屯镇",
    "type": "区",
    "parentId": 384
  },
  {
    "id": 3498,
    "name": "国姓乡",
    "type": "区",
    "parentId": 384
  },
  {
    "id": 3499,
    "name": "埔里镇",
    "type": "区",
    "parentId": 384
  },
  {
    "id": 3500,
    "name": "仁爱乡",
    "type": "区",
    "parentId": 384
  },
  {
    "id": 3501,
    "name": "名间乡",
    "type": "区",
    "parentId": 384
  },
  {
    "id": 3502,
    "name": "集集镇",
    "type": "区",
    "parentId": 384
  },
  {
    "id": 3503,
    "name": "水里乡",
    "type": "区",
    "parentId": 384
  },
  {
    "id": 3504,
    "name": "鱼池乡",
    "type": "区",
    "parentId": 384
  },
  {
    "id": 3505,
    "name": "信义乡",
    "type": "区",
    "parentId": 384
  },
  {
    "id": 3506,
    "name": "竹山镇",
    "type": "区",
    "parentId": 384
  },
  {
    "id": 3507,
    "name": "鹿谷乡",
    "type": "区",
    "parentId": 384
  },
  {
    "id": 3508,
    "name": "仁爱区",
    "type": "区",
    "parentId": 385
  },
  {
    "id": 3509,
    "name": "信义区",
    "type": "区",
    "parentId": 385
  },
  {
    "id": 3510,
    "name": "中正区",
    "type": "区",
    "parentId": 385
  },
  {
    "id": 3511,
    "name": "中山区",
    "type": "区",
    "parentId": 385
  },
  {
    "id": 3512,
    "name": "安乐区",
    "type": "区",
    "parentId": 385
  },
  {
    "id": 3513,
    "name": "暖暖区",
    "type": "区",
    "parentId": 385
  },
  {
    "id": 3514,
    "name": "七堵区",
    "type": "区",
    "parentId": 385
  },
  {
    "id": 3515,
    "name": "其它区",
    "type": "区",
    "parentId": 385
  },
  {
    "id": 3516,
    "name": "东区",
    "type": "区",
    "parentId": 386
  },
  {
    "id": 3517,
    "name": "北区",
    "type": "区",
    "parentId": 386
  },
  {
    "id": 3518,
    "name": "香山区",
    "type": "区",
    "parentId": 386
  },
  {
    "id": 3519,
    "name": "其它区",
    "type": "区",
    "parentId": 386
  },
  {
    "id": 3520,
    "name": "东区",
    "type": "区",
    "parentId": 387
  },
  {
    "id": 3521,
    "name": "西区",
    "type": "区",
    "parentId": 387
  },
  {
    "id": 3522,
    "name": "其它区",
    "type": "区",
    "parentId": 387
  },
  {
    "id": 3523,
    "name": "万里区",
    "type": "区",
    "parentId": 388
  },
  {
    "id": 3524,
    "name": "板桥区",
    "type": "区",
    "parentId": 388
  },
  {
    "id": 3525,
    "name": "汐止区",
    "type": "区",
    "parentId": 388
  },
  {
    "id": 3526,
    "name": "深坑区",
    "type": "区",
    "parentId": 388
  },
  {
    "id": 3527,
    "name": "瑞芳区",
    "type": "区",
    "parentId": 388
  },
  {
    "id": 3528,
    "name": "平溪区",
    "type": "区",
    "parentId": 388
  },
  {
    "id": 3529,
    "name": "双溪区",
    "type": "区",
    "parentId": 388
  },
  {
    "id": 3530,
    "name": "新店区",
    "type": "区",
    "parentId": 388
  },
  {
    "id": 3531,
    "name": "坪林区",
    "type": "区",
    "parentId": 388
  },
  {
    "id": 3532,
    "name": "乌来区",
    "type": "区",
    "parentId": 388
  },
  {
    "id": 3533,
    "name": "永和区",
    "type": "区",
    "parentId": 388
  },
  {
    "id": 3534,
    "name": "中和区",
    "type": "区",
    "parentId": 388
  },
  {
    "id": 3535,
    "name": "土城区",
    "type": "区",
    "parentId": 388
  },
  {
    "id": 3536,
    "name": "三峡区",
    "type": "区",
    "parentId": 388
  },
  {
    "id": 3537,
    "name": "树林区",
    "type": "区",
    "parentId": 388
  },
  {
    "id": 3538,
    "name": "三重区",
    "type": "区",
    "parentId": 388
  },
  {
    "id": 3539,
    "name": "新庄区",
    "type": "区",
    "parentId": 388
  },
  {
    "id": 3540,
    "name": "泰山区",
    "type": "区",
    "parentId": 388
  },
  {
    "id": 3541,
    "name": "林口区",
    "type": "区",
    "parentId": 388
  },
  {
    "id": 3542,
    "name": "五股区",
    "type": "区",
    "parentId": 388
  },
  {
    "id": 3543,
    "name": "八里区",
    "type": "区",
    "parentId": 388
  },
  {
    "id": 3544,
    "name": "淡水区",
    "type": "区",
    "parentId": 388
  },
  {
    "id": 3545,
    "name": "三芝区",
    "type": "区",
    "parentId": 388
  },
  {
    "id": 3546,
    "name": "宜兰市",
    "type": "区",
    "parentId": 389
  },
  {
    "id": 3547,
    "name": "头城镇",
    "type": "区",
    "parentId": 389
  },
  {
    "id": 3548,
    "name": "礁溪乡",
    "type": "区",
    "parentId": 389
  },
  {
    "id": 3549,
    "name": "壮围乡",
    "type": "区",
    "parentId": 389
  },
  {
    "id": 3550,
    "name": "员山乡",
    "type": "区",
    "parentId": 389
  },
  {
    "id": 3551,
    "name": "罗东镇",
    "type": "区",
    "parentId": 389
  },
  {
    "id": 3552,
    "name": "三星乡",
    "type": "区",
    "parentId": 389
  },
  {
    "id": 3553,
    "name": "大同乡",
    "type": "区",
    "parentId": 389
  },
  {
    "id": 3554,
    "name": "五结乡",
    "type": "区",
    "parentId": 389
  },
  {
    "id": 3555,
    "name": "冬山乡",
    "type": "区",
    "parentId": 389
  },
  {
    "id": 3556,
    "name": "苏澳镇",
    "type": "区",
    "parentId": 389
  },
  {
    "id": 3557,
    "name": "南澳乡",
    "type": "区",
    "parentId": 389
  },
  {
    "id": 3558,
    "name": "钓鱼台",
    "type": "区",
    "parentId": 389
  },
  {
    "id": 3559,
    "name": "竹北市",
    "type": "区",
    "parentId": 390
  },
  {
    "id": 3560,
    "name": "湖口乡",
    "type": "区",
    "parentId": 390
  },
  {
    "id": 3561,
    "name": "新丰乡",
    "type": "区",
    "parentId": 390
  },
  {
    "id": 3562,
    "name": "新埔镇",
    "type": "区",
    "parentId": 390
  },
  {
    "id": 3563,
    "name": "关西镇",
    "type": "区",
    "parentId": 390
  },
  {
    "id": 3564,
    "name": "芎林乡",
    "type": "区",
    "parentId": 390
  },
  {
    "id": 3565,
    "name": "宝山乡",
    "type": "区",
    "parentId": 390
  },
  {
    "id": 3566,
    "name": "竹东镇",
    "type": "区",
    "parentId": 390
  },
  {
    "id": 3567,
    "name": "五峰乡",
    "type": "区",
    "parentId": 390
  },
  {
    "id": 3568,
    "name": "横山乡",
    "type": "区",
    "parentId": 390
  },
  {
    "id": 3569,
    "name": "尖石乡",
    "type": "区",
    "parentId": 390
  },
  {
    "id": 3570,
    "name": "北埔乡",
    "type": "区",
    "parentId": 390
  },
  {
    "id": 3571,
    "name": "峨眉乡",
    "type": "区",
    "parentId": 390
  },
  {
    "id": 3572,
    "name": "中坜市",
    "type": "区",
    "parentId": 391
  },
  {
    "id": 3573,
    "name": "平镇市",
    "type": "区",
    "parentId": 391
  },
  {
    "id": 3574,
    "name": "龙潭乡",
    "type": "区",
    "parentId": 391
  },
  {
    "id": 3575,
    "name": "杨梅市",
    "type": "区",
    "parentId": 391
  },
  {
    "id": 3576,
    "name": "新屋乡",
    "type": "区",
    "parentId": 391
  },
  {
    "id": 3577,
    "name": "观音乡",
    "type": "区",
    "parentId": 391
  },
  {
    "id": 3578,
    "name": "桃园市",
    "type": "区",
    "parentId": 391
  },
  {
    "id": 3579,
    "name": "龟山乡",
    "type": "区",
    "parentId": 391
  },
  {
    "id": 3580,
    "name": "八德市",
    "type": "区",
    "parentId": 391
  },
  {
    "id": 3581,
    "name": "大溪镇",
    "type": "区",
    "parentId": 391
  },
  {
    "id": 3582,
    "name": "复兴乡",
    "type": "区",
    "parentId": 391
  },
  {
    "id": 3583,
    "name": "大园乡",
    "type": "区",
    "parentId": 391
  },
  {
    "id": 3584,
    "name": "芦竹乡",
    "type": "区",
    "parentId": 391
  },
  {
    "id": 3585,
    "name": "竹南镇",
    "type": "区",
    "parentId": 392
  },
  {
    "id": 3586,
    "name": "头份镇",
    "type": "区",
    "parentId": 392
  },
  {
    "id": 3587,
    "name": "三湾乡",
    "type": "区",
    "parentId": 392
  },
  {
    "id": 3588,
    "name": "南庄乡",
    "type": "区",
    "parentId": 392
  },
  {
    "id": 3589,
    "name": "狮潭乡",
    "type": "区",
    "parentId": 392
  },
  {
    "id": 3590,
    "name": "后龙镇",
    "type": "区",
    "parentId": 392
  },
  {
    "id": 3591,
    "name": "通霄镇",
    "type": "区",
    "parentId": 392
  },
  {
    "id": 3592,
    "name": "苑里镇",
    "type": "区",
    "parentId": 392
  },
  {
    "id": 3593,
    "name": "苗栗市",
    "type": "区",
    "parentId": 392
  },
  {
    "id": 3594,
    "name": "造桥乡",
    "type": "区",
    "parentId": 392
  },
  {
    "id": 3595,
    "name": "头屋乡",
    "type": "区",
    "parentId": 392
  },
  {
    "id": 3596,
    "name": "公馆乡",
    "type": "区",
    "parentId": 392
  },
  {
    "id": 3597,
    "name": "大湖乡",
    "type": "区",
    "parentId": 392
  },
  {
    "id": 3598,
    "name": "泰安乡",
    "type": "区",
    "parentId": 392
  },
  {
    "id": 3599,
    "name": "铜锣乡",
    "type": "区",
    "parentId": 392
  },
  {
    "id": 3600,
    "name": "三义乡",
    "type": "区",
    "parentId": 392
  },
  {
    "id": 3601,
    "name": "西湖乡",
    "type": "区",
    "parentId": 392
  },
  {
    "id": 3602,
    "name": "卓兰镇",
    "type": "区",
    "parentId": 392
  },
  {
    "id": 3603,
    "name": "彰化市",
    "type": "区",
    "parentId": 393
  },
  {
    "id": 3604,
    "name": "芬园乡",
    "type": "区",
    "parentId": 393
  },
  {
    "id": 3605,
    "name": "花坛乡",
    "type": "区",
    "parentId": 393
  },
  {
    "id": 3606,
    "name": "秀水乡",
    "type": "区",
    "parentId": 393
  },
  {
    "id": 3607,
    "name": "鹿港镇",
    "type": "区",
    "parentId": 393
  },
  {
    "id": 3608,
    "name": "福兴乡",
    "type": "区",
    "parentId": 393
  },
  {
    "id": 3609,
    "name": "线西乡",
    "type": "区",
    "parentId": 393
  },
  {
    "id": 3610,
    "name": "和美镇",
    "type": "区",
    "parentId": 393
  },
  {
    "id": 3611,
    "name": "伸港乡",
    "type": "区",
    "parentId": 393
  },
  {
    "id": 3612,
    "name": "员林镇",
    "type": "区",
    "parentId": 393
  },
  {
    "id": 3613,
    "name": "社头乡",
    "type": "区",
    "parentId": 393
  },
  {
    "id": 3614,
    "name": "永靖乡",
    "type": "区",
    "parentId": 393
  },
  {
    "id": 3615,
    "name": "埔心乡",
    "type": "区",
    "parentId": 393
  },
  {
    "id": 3616,
    "name": "溪湖镇",
    "type": "区",
    "parentId": 393
  },
  {
    "id": 3617,
    "name": "大村乡",
    "type": "区",
    "parentId": 393
  },
  {
    "id": 3618,
    "name": "埔盐乡",
    "type": "区",
    "parentId": 393
  },
  {
    "id": 3619,
    "name": "田中镇",
    "type": "区",
    "parentId": 393
  },
  {
    "id": 3620,
    "name": "北斗镇",
    "type": "区",
    "parentId": 393
  },
  {
    "id": 3621,
    "name": "田尾乡",
    "type": "区",
    "parentId": 393
  },
  {
    "id": 3622,
    "name": "埤头乡",
    "type": "区",
    "parentId": 393
  },
  {
    "id": 3623,
    "name": "溪州乡",
    "type": "区",
    "parentId": 393
  },
  {
    "id": 3624,
    "name": "竹塘乡",
    "type": "区",
    "parentId": 393
  },
  {
    "id": 3625,
    "name": "二林镇",
    "type": "区",
    "parentId": 393
  },
  {
    "id": 3626,
    "name": "大城乡",
    "type": "区",
    "parentId": 393
  },
  {
    "id": 3627,
    "name": "芳苑乡",
    "type": "区",
    "parentId": 393
  },
  {
    "id": 3628,
    "name": "二水乡",
    "type": "区",
    "parentId": 393
  },
  {
    "id": 3629,
    "name": "番路乡",
    "type": "区",
    "parentId": 394
  },
  {
    "id": 3630,
    "name": "梅山乡",
    "type": "区",
    "parentId": 394
  },
  {
    "id": 3631,
    "name": "竹崎乡",
    "type": "区",
    "parentId": 394
  },
  {
    "id": 3632,
    "name": "阿里山乡",
    "type": "区",
    "parentId": 394
  },
  {
    "id": 3633,
    "name": "中埔乡",
    "type": "区",
    "parentId": 394
  },
  {
    "id": 3634,
    "name": "大埔乡",
    "type": "区",
    "parentId": 394
  },
  {
    "id": 3635,
    "name": "水上乡",
    "type": "区",
    "parentId": 394
  },
  {
    "id": 3636,
    "name": "鹿草乡",
    "type": "区",
    "parentId": 394
  },
  {
    "id": 3637,
    "name": "太保市",
    "type": "区",
    "parentId": 394
  },
  {
    "id": 3638,
    "name": "朴子市",
    "type": "区",
    "parentId": 394
  },
  {
    "id": 3639,
    "name": "东石乡",
    "type": "区",
    "parentId": 394
  },
  {
    "id": 3640,
    "name": "六脚乡",
    "type": "区",
    "parentId": 394
  },
  {
    "id": 3641,
    "name": "新港乡",
    "type": "区",
    "parentId": 394
  },
  {
    "id": 3642,
    "name": "民雄乡",
    "type": "区",
    "parentId": 394
  },
  {
    "id": 3643,
    "name": "大林镇",
    "type": "区",
    "parentId": 394
  },
  {
    "id": 3644,
    "name": "溪口乡",
    "type": "区",
    "parentId": 394
  },
  {
    "id": 3645,
    "name": "义竹乡",
    "type": "区",
    "parentId": 394
  },
  {
    "id": 3646,
    "name": "布袋镇",
    "type": "区",
    "parentId": 394
  },
  {
    "id": 3647,
    "name": "斗南镇",
    "type": "区",
    "parentId": 395
  },
  {
    "id": 3648,
    "name": "大埤乡",
    "type": "区",
    "parentId": 395
  },
  {
    "id": 3649,
    "name": "虎尾镇",
    "type": "区",
    "parentId": 395
  },
  {
    "id": 3650,
    "name": "土库镇",
    "type": "区",
    "parentId": 395
  },
  {
    "id": 3651,
    "name": "褒忠乡",
    "type": "区",
    "parentId": 395
  },
  {
    "id": 3652,
    "name": "东势乡",
    "type": "区",
    "parentId": 395
  },
  {
    "id": 3653,
    "name": "台西乡",
    "type": "区",
    "parentId": 395
  },
  {
    "id": 3654,
    "name": "仑背乡",
    "type": "区",
    "parentId": 395
  },
  {
    "id": 3655,
    "name": "麦寮乡",
    "type": "区",
    "parentId": 395
  },
  {
    "id": 3656,
    "name": "斗六市",
    "type": "区",
    "parentId": 395
  },
  {
    "id": 3657,
    "name": "林内乡",
    "type": "区",
    "parentId": 395
  },
  {
    "id": 3658,
    "name": "古坑乡",
    "type": "区",
    "parentId": 395
  },
  {
    "id": 3659,
    "name": "莿桐乡",
    "type": "区",
    "parentId": 395
  },
  {
    "id": 3660,
    "name": "西螺镇",
    "type": "区",
    "parentId": 395
  },
  {
    "id": 3661,
    "name": "二仑乡",
    "type": "区",
    "parentId": 395
  },
  {
    "id": 3662,
    "name": "北港镇",
    "type": "区",
    "parentId": 395
  },
  {
    "id": 3663,
    "name": "水林乡",
    "type": "区",
    "parentId": 395
  },
  {
    "id": 3664,
    "name": "口湖乡",
    "type": "区",
    "parentId": 395
  },
  {
    "id": 3665,
    "name": "四湖乡",
    "type": "区",
    "parentId": 395
  },
  {
    "id": 3666,
    "name": "元长乡",
    "type": "区",
    "parentId": 395
  },
  {
    "id": 3667,
    "name": "屏东市",
    "type": "区",
    "parentId": 396
  },
  {
    "id": 3668,
    "name": "三地门乡",
    "type": "区",
    "parentId": 396
  },
  {
    "id": 3669,
    "name": "雾台乡",
    "type": "区",
    "parentId": 396
  },
  {
    "id": 3670,
    "name": "玛家乡",
    "type": "区",
    "parentId": 396
  },
  {
    "id": 3671,
    "name": "九如乡",
    "type": "区",
    "parentId": 396
  },
  {
    "id": 3672,
    "name": "里港乡",
    "type": "区",
    "parentId": 396
  },
  {
    "id": 3673,
    "name": "高树乡",
    "type": "区",
    "parentId": 396
  },
  {
    "id": 3674,
    "name": "盐埔乡",
    "type": "区",
    "parentId": 396
  },
  {
    "id": 3675,
    "name": "长治乡",
    "type": "区",
    "parentId": 396
  },
  {
    "id": 3676,
    "name": "麟洛乡",
    "type": "区",
    "parentId": 396
  },
  {
    "id": 3677,
    "name": "竹田乡",
    "type": "区",
    "parentId": 396
  },
  {
    "id": 3678,
    "name": "内埔乡",
    "type": "区",
    "parentId": 396
  },
  {
    "id": 3679,
    "name": "万丹乡",
    "type": "区",
    "parentId": 396
  },
  {
    "id": 3680,
    "name": "潮州镇",
    "type": "区",
    "parentId": 396
  },
  {
    "id": 3681,
    "name": "泰武乡",
    "type": "区",
    "parentId": 396
  },
  {
    "id": 3682,
    "name": "来义乡",
    "type": "区",
    "parentId": 396
  },
  {
    "id": 3683,
    "name": "万峦乡",
    "type": "区",
    "parentId": 396
  },
  {
    "id": 3684,
    "name": "莰顶乡",
    "type": "区",
    "parentId": 396
  },
  {
    "id": 3685,
    "name": "新埤乡",
    "type": "区",
    "parentId": 396
  },
  {
    "id": 3686,
    "name": "南州乡",
    "type": "区",
    "parentId": 396
  },
  {
    "id": 3687,
    "name": "林边乡",
    "type": "区",
    "parentId": 396
  },
  {
    "id": 3688,
    "name": "东港镇",
    "type": "区",
    "parentId": 396
  },
  {
    "id": 3689,
    "name": "琉球乡",
    "type": "区",
    "parentId": 396
  },
  {
    "id": 3690,
    "name": "佳冬乡",
    "type": "区",
    "parentId": 396
  },
  {
    "id": 3691,
    "name": "新园乡",
    "type": "区",
    "parentId": 396
  },
  {
    "id": 3692,
    "name": "枋寮乡",
    "type": "区",
    "parentId": 396
  },
  {
    "id": 3693,
    "name": "枋山乡",
    "type": "区",
    "parentId": 396
  },
  {
    "id": 3694,
    "name": "春日乡",
    "type": "区",
    "parentId": 396
  },
  {
    "id": 3695,
    "name": "狮子乡",
    "type": "区",
    "parentId": 396
  },
  {
    "id": 3696,
    "name": "车城乡",
    "type": "区",
    "parentId": 396
  },
  {
    "id": 3697,
    "name": "牡丹乡",
    "type": "区",
    "parentId": 396
  },
  {
    "id": 3698,
    "name": "恒春镇",
    "type": "区",
    "parentId": 396
  },
  {
    "id": 3699,
    "name": "满州乡",
    "type": "区",
    "parentId": 396
  },
  {
    "id": 3700,
    "name": "台东市",
    "type": "区",
    "parentId": 397
  },
  {
    "id": 3701,
    "name": "绿岛乡",
    "type": "区",
    "parentId": 397
  },
  {
    "id": 3702,
    "name": "兰屿乡",
    "type": "区",
    "parentId": 397
  },
  {
    "id": 3703,
    "name": "延平乡",
    "type": "区",
    "parentId": 397
  },
  {
    "id": 3704,
    "name": "卑南乡",
    "type": "区",
    "parentId": 397
  },
  {
    "id": 3705,
    "name": "鹿野乡",
    "type": "区",
    "parentId": 397
  },
  {
    "id": 3706,
    "name": "关山镇",
    "type": "区",
    "parentId": 397
  },
  {
    "id": 3707,
    "name": "海端乡",
    "type": "区",
    "parentId": 397
  },
  {
    "id": 3708,
    "name": "池上乡",
    "type": "区",
    "parentId": 397
  },
  {
    "id": 3709,
    "name": "东河乡",
    "type": "区",
    "parentId": 397
  },
  {
    "id": 3710,
    "name": "成功镇",
    "type": "区",
    "parentId": 397
  },
  {
    "id": 3711,
    "name": "长滨乡",
    "type": "区",
    "parentId": 397
  },
  {
    "id": 3712,
    "name": "金峰乡",
    "type": "区",
    "parentId": 397
  },
  {
    "id": 3713,
    "name": "大武乡",
    "type": "区",
    "parentId": 397
  },
  {
    "id": 3714,
    "name": "达仁乡",
    "type": "区",
    "parentId": 397
  },
  {
    "id": 3715,
    "name": "太麻里乡",
    "type": "区",
    "parentId": 397
  },
  {
    "id": 3716,
    "name": "花莲市",
    "type": "区",
    "parentId": 398
  },
  {
    "id": 3717,
    "name": "新城乡",
    "type": "区",
    "parentId": 398
  },
  {
    "id": 3718,
    "name": "太鲁阁",
    "type": "区",
    "parentId": 398
  },
  {
    "id": 3719,
    "name": "秀林乡",
    "type": "区",
    "parentId": 398
  },
  {
    "id": 3720,
    "name": "吉安乡",
    "type": "区",
    "parentId": 398
  },
  {
    "id": 3721,
    "name": "寿丰乡",
    "type": "区",
    "parentId": 398
  },
  {
    "id": 3722,
    "name": "凤林镇",
    "type": "区",
    "parentId": 398
  },
  {
    "id": 3723,
    "name": "光复乡",
    "type": "区",
    "parentId": 398
  },
  {
    "id": 3724,
    "name": "丰滨乡",
    "type": "区",
    "parentId": 398
  },
  {
    "id": 3725,
    "name": "瑞穗乡",
    "type": "区",
    "parentId": 398
  },
  {
    "id": 3726,
    "name": "万荣乡",
    "type": "区",
    "parentId": 398
  },
  {
    "id": 3727,
    "name": "玉里镇",
    "type": "区",
    "parentId": 398
  },
  {
    "id": 3728,
    "name": "卓溪乡",
    "type": "区",
    "parentId": 398
  },
  {
    "id": 3729,
    "name": "富里乡",
    "type": "区",
    "parentId": 398
  },
  {
    "id": 3730,
    "name": "马公市",
    "type": "区",
    "parentId": 399
  },
  {
    "id": 3731,
    "name": "西屿乡",
    "type": "区",
    "parentId": 399
  },
  {
    "id": 3732,
    "name": "望安乡",
    "type": "区",
    "parentId": 399
  },
  {
    "id": 3733,
    "name": "七美乡",
    "type": "区",
    "parentId": 399
  },
  {
    "id": 3734,
    "name": "白沙乡",
    "type": "区",
    "parentId": 399
  },
  {
    "id": 3735,
    "name": "湖西乡",
    "type": "区",
    "parentId": 399
  },
  {
    "id": 3736,
    "name": "南竿乡",
    "type": "区",
    "parentId": 400
  },
  {
    "id": 3737,
    "name": "北竿乡",
    "type": "区",
    "parentId": 400
  },
  {
    "id": 3738,
    "name": "东引乡",
    "type": "区",
    "parentId": 400
  },
  {
    "id": 3739,
    "name": "莒光乡",
    "type": "区",
    "parentId": 400
  },
  {
    "id": 3740,
    "name": "中西区",
    "type": "区",
    "parentId": 401
  },
  {
    "id": 3741,
    "name": "湾仔",
    "type": "区",
    "parentId": 401
  },
  {
    "id": 3742,
    "name": "东区",
    "type": "区",
    "parentId": 401
  },
  {
    "id": 3743,
    "name": "南区",
    "type": "区",
    "parentId": 401
  },
  {
    "id": 3744,
    "name": "九龙城区",
    "type": "区",
    "parentId": 402
  },
  {
    "id": 3745,
    "name": "油尖旺区",
    "type": "区",
    "parentId": 402
  },
  {
    "id": 3746,
    "name": "深水埗区",
    "type": "区",
    "parentId": 402
  },
  {
    "id": 3747,
    "name": "黄大仙区",
    "type": "区",
    "parentId": 402
  },
  {
    "id": 3748,
    "name": "观塘区",
    "type": "区",
    "parentId": 402
  },
  {
    "id": 3749,
    "name": "北区",
    "type": "区",
    "parentId": 403
  },
  {
    "id": 3750,
    "name": "大埔区",
    "type": "区",
    "parentId": 403
  },
  {
    "id": 3751,
    "name": "沙田区",
    "type": "区",
    "parentId": 403
  },
  {
    "id": 3752,
    "name": "西贡区",
    "type": "区",
    "parentId": 403
  },
  {
    "id": 3753,
    "name": "元朗区",
    "type": "区",
    "parentId": 403
  },
  {
    "id": 3754,
    "name": "屯门区",
    "type": "区",
    "parentId": 403
  },
  {
    "id": 3755,
    "name": "荃湾区",
    "type": "区",
    "parentId": 403
  },
  {
    "id": 3756,
    "name": "葵青区",
    "type": "区",
    "parentId": 403
  },
  {
    "id": 3757,
    "name": "离岛区",
    "type": "区",
    "parentId": 403
  },
  {
    "id": 3758,
    "name": "澳门半岛",
    "type": "区",
    "parentId": 404
  },
  {
    "id": 3759,
    "name": "离岛",
    "type": "区",
    "parentId": 405
  }
]